
  /* eslint-disable */
  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  // THIS FILE IS AUTO-GENERATED. ANYTHING YOU CHANGE WILL BE LOST!
  // ¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡¡
  
import { gql } from 'apollo-angular';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  EmailAddress: { input: string; output: string; }
  GUID: { input: string; output: string; }
  JSON: { input: any; output: any; }
  URL: { input: string; output: string; }
  Upload: { input: any; output: any; }
  Void: { input: any; output: any; }
}

export enum ActivityTypeSlug {
  AddedToCollection = 'addedToCollection',
  Completed = 'completed',
  Created = 'created',
  Liked = 'liked',
  Purchased = 'purchased'
}

export interface AddAssetToCollection {
  __typename?: 'AddAssetToCollection';
  asset?: Maybe<ChildAsset>;
  collection?: Maybe<CollectionAsset>;
}

export type AnyAsset = CollectionAsset | GeneratedSampleAsset | LessonAsset | MidiAsset | PackAsset | PresetAsset | SampleAsset | VideoAsset;

export type AnyProduct = CreditBooster | ProductPlan | ProductRtoPlugin;

/**
 * ArchiveManifest represents the content and relative paths of a collection of files,
 * such as might be bundled into a zip file or DAW project folder.
 */
export interface ArchiveManifest {
  __typename?: 'ArchiveManifest';
  /** Entries is the list of files and directories in the archive */
  entries: Array<ArchiveManifestEntry>;
  /** Name of the archive, i.e. zip filename */
  name?: Maybe<Scalars['String']['output']>;
}

/**
 * ArchiveManifestEntry represents a single file or directory in an ArchiveManifest.
 * For files, exactly one of `url` or `data` will be set. (Directories have no content.)
 */
export interface ArchiveManifestEntry {
  __typename?: 'ArchiveManifestEntry';
  /** Data is the actual Base64-encoded file content */
  data?: Maybe<Scalars['String']['output']>;
  /** Meta is a list of tags or "key:value" items */
  meta?: Maybe<Array<Scalars['String']['output']>>;
  /** Path of the entry relative to the archive root, e.g. dir/ or my/file.txt */
  path: Scalars['String']['output'];
  /** URL from which to GET the file content */
  url?: Maybe<Scalars['String']['output']>;
}

/** Asset access type defines the access control level for assets */
export enum AssetAccessTypeSlug {
  /** Publicly accessible to all users */
  Public = 'public',
  /** Accessible to subscribed users only */
  Subscribed = 'subscribed',
  /** Accessible to trial users */
  Trial = 'trial'
}

export interface AssetActivity {
  __typename?: 'AssetActivity';
  type?: Maybe<ActivityTypeSlug>;
  users?: Maybe<Array<Scalars['GUID']['output']>>;
}

/**
 * an asset attribute is a property of an asset that is usually determined by
 * custom business logic, ie it isn't something you can infer from the asset itself
 * for example a "rare find" is determined by a data science algorithm analyzing user activity
 */
export enum AssetAttributeSlug {
  PresonusEvergreen = 'presonus_evergreen',
  Rare = 'rare'
}

/**
 * an asset bundled content daw refers to any daw that has free bundled content
 * including the asset. For example "presonus_studio_one_pro" indicates this asset
 * is eligible for presonus studio one pro free bundled content.
 */
export enum AssetBundledContentDawSlug {
  AbletonLive = 'ableton_live',
  AvidProTools = 'avid_pro_tools',
  PresonusStudioOnePro = 'presonus_studio_one_pro'
}

/** An asset category is essentially the kind of a sample: loop, one shot, etc. */
export interface AssetCategory {
  __typename?: 'AssetCategory';
  id?: Maybe<Scalars['Int']['output']>;
  /** The user-friendly name for the category (ie, "Foo Bar") */
  label?: Maybe<Scalars['String']['output']>;
  /** The tokenized format of the label. (ie, "foo-bar") */
  slug?: Maybe<AssetCategorySlug>;
}

/** Asset category represents the type of audio content */
export enum AssetCategorySlug {
  /** Instructional guide or tutorial */
  Guide = 'guide',
  /** Repeating audio loop */
  Loop = 'loop',
  /** Single-hit sample or one-shot sound */
  Oneshot = 'oneshot',
  /** Production technique or method */
  Technique = 'technique'
}

/** Inputs to return children of one or more parent assets */
export interface AssetChildrenInput {
  /**
   * Return all children of this parent asset
   * @deprecated Any asset type that hits the search service first and does not depend on catalog service to do the search can not use this key.
   */
  parent_asset_uuid?: InputMaybe<Scalars['GUID']['input']>;
  /** Return all children of these parent assets */
  parent_asset_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
}

/** Input values used when creating a brand new Asset. */
export interface AssetCreateInput {
  /** Asset Visibility Slug will be used to represent a video's availability (trial, public or subscribed) */
  asset_access_type_slug?: InputMaybe<AssetAccessTypeSlug>;
  asset_category_slug?: InputMaybe<AssetCategorySlug>;
  asset_status_slug?: InputMaybe<AssetStatusSlug>;
  asset_type_slug?: InputMaybe<AssetTypeSlug>;
  banner_image?: InputMaybe<Scalars['Upload']['input']>;
  child_asset_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  cover_image?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  device_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  header_image?: InputMaybe<Scalars['Upload']['input']>;
  instructor_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  mp4?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_asset_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  provider_uuid?: InputMaybe<Scalars['GUID']['input']>;
  /** Public will be used to represent whether the video is available only to all */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** A string field on a Lesson asset */
  subheader?: InputMaybe<Scalars['String']['input']>;
  tag_uuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Trial will be used to represent whether the video is available only to trial members */
  trial?: InputMaybe<Scalars['Boolean']['input']>;
}

/** a specific minimum version of a device to require */
export interface AssetDevice {
  __typename?: 'AssetDevice';
  device?: Maybe<IDevice>;
  minimum_version?: Maybe<Scalars['String']['output']>;
  /** uuid of a Device */
  uuid?: Maybe<Scalars['GUID']['output']>;
}

export interface AssetDimensions {
  __typename?: 'AssetDimensions';
  height?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
}

/** Error info on an asset */
export interface AssetErrorDetail {
  __typename?: 'AssetErrorDetail';
  level?: Maybe<AssetErrorLevel>;
  message?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
}

/** TODO: This requires better documentation */
export enum AssetErrorLevel {
  Error = 'error',
  Warning = 'warning'
}

/** A file associated with an Asset */
export interface AssetFile {
  __typename?: 'AssetFile';
  asset_file_type_slug?: Maybe<AssetFileTypeSlug>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  deleted_at?: Maybe<Scalars['DateTime']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Path to file in asset directory structure
   * example: '/path/to/the/folder/filename'
   */
  path?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  /** The fully-qualified URL to the file. */
  url?: Maybe<Scalars['URL']['output']>;
  uuid: Scalars['GUID']['output'];
}

/** The types of files that can me associated with an asset such as images, audio, or source */
export interface AssetFileType {
  __typename?: 'AssetFileType';
  id?: Maybe<Scalars['Int']['output']>;
  /** The user-friendly name for the type (ie, "Foo Bar") */
  label?: Maybe<Scalars['String']['output']>;
  /** The tokenized format of the label. (ie, "foo-bar") */
  slug?: Maybe<AssetFileTypeSlug>;
}

export enum AssetFileTypeSlug {
  BannerImage = 'banner_image',
  CoverImage = 'cover_image',
  DemoMp3 = 'demo_mp3',
  GeneratedCoverImage = 'generated_cover_image',
  HeaderImage = 'header_image',
  Mp4 = 'mp4',
  PreviewMp3 = 'preview_mp3',
  Source = 'source',
  SrtTranscript = 'srt_transcript',
  ThumbnailImage = 'thumbnail_image',
  VttTranscript = 'vtt_transcript',
  Waveform = 'waveform',
  ZipFile = 'zip_file'
}

/** A list of files for an asset */
export interface AssetFilesList {
  __typename?: 'AssetFilesList';
  assetStatusSlug?: Maybe<Scalars['String']['output']>;
  /** Used to enforce response data policy */
  assetTypeSlug?: Maybe<Scalars['String']['output']>;
  assetUuid?: Maybe<Scalars['GUID']['output']>;
  files?: Maybe<Array<AssetFile>>;
  public?: Maybe<Scalars['Boolean']['output']>;
}

/**
 * These inputs narrow the characteristics of the Assets returned
 * in the query. `AssetTypeSlug!` is required, since only one type
 * of asset can be returned at a time.
 */
export interface AssetFiltersInput {
  /** Optional UUID for searches performed with autocomplete suggestion */
  ac_uuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * Filter Sample assets by a specific `asset_category_slug`.
   *   any category set: 'loop'
   *   no category set: 'NOT_SET'
   */
  asset_category_slug?: InputMaybe<AssetCategorySlug>;
  /** Status of assets to return in response */
  asset_status_slug?: InputMaybe<AssetStatusSlug>;
  /** Only one Asset type can be returned at a time, so this is required. */
  asset_type_slug: AssetTypeSlug;
  /** Return only content whose attributes property contains the list of strings */
  attributes?: InputMaybe<Array<AssetAttributeSlug>>;
  /** Exclude content whose attributes property contains the list of strings */
  attributes_exclude?: InputMaybe<Array<AssetAttributeSlug>>;
  /**
   * Filter Sample assets by a specific `bpm`.
   *   equal bpm: '120'
   *   not equal bpm: '!120'
   *   any bpm set: 'IS_SET'
   *   no bpm set: 'NOT_SET'
   */
  bpm?: InputMaybe<Scalars['String']['input']>;
  /** Return only content whose bundled content daws property contains the list of strings */
  bundled_content_daws?: InputMaybe<Array<AssetBundledContentDawSlug>>;
  /** Exclude content whose bundled content daws contains the list of strings */
  bundled_content_daws_exclude?: InputMaybe<Array<AssetBundledContentDawSlug>>;
  /**
   * Chord types: major, minor
   *   equal chord: 'major'
   *   not equal chord: '!major'
   *   any chord set: 'IS_SET'
   *   no chord set: 'NOT_SET'
   */
  chord_type?: InputMaybe<Scalars['String']['input']>;
  coso_search_opts?: InputMaybe<CosoSearchOpts>;
  /** Seeds for coso search */
  coso_seed?: InputMaybe<CosoSeedInput>;
  /** Only return assets associated with a particular device eg. "serum" */
  device_name?: InputMaybe<Scalars['String']['input']>;
  /** Asset Device GUID */
  device_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  drums_only?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * When true, the search service will attempt to extract asset filters
   * from the query string. Currently (2/23/26) available for one-shots / loops
   * on semantic search only.
   */
  extract_filters?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return assets that match a filepath */
  filepath?: InputMaybe<Scalars['String']['input']>;
  /** Only return assets associated with a genre e.g. "trap" */
  genre?: InputMaybe<Scalars['String']['input']>;
  /** Only return assets that have errors */
  has_errors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only return assets that have warnings */
  has_warnings?: InputMaybe<Scalars['Boolean']['input']>;
  include_inherited_tags?: InputMaybe<Scalars['Boolean']['input']>;
  /** Asset Instructor GUID */
  instructor_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  /**
   * Sample assets in `key`.
   *   equal key: 'a#'
   *   not equal key: '!a#'
   *   any key set: 'IS_SET'
   *   no key set: 'NOT_SET'
   */
  key?: InputMaybe<Scalars['String']['input']>;
  /**
   * Query the catalog using behavior from the Splice Legacy API
   * @deprecated There is a param in the assetSearch args outside of this filter param for legacy params. It is an object that can have any parameters relevant to legacy API endpoints -- use this instead
   */
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only content that the Authenticated User has a license to use. This is filtered by default. */
  licensed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Return only content that the Authenticated User liked/did not like. This is not filtered by default. */
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter Sample assets with a maximum `bpm`. Example: 140. */
  max_bpm?: InputMaybe<Scalars['Int']['input']>;
  /** Filter Sample assets with a minimum `bpm`. Example: 120. */
  min_bpm?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exclude?: InputMaybe<Scalars['String']['input']>;
  /** Only return assets owned by the current user */
  owned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional bounded popularity boost for hybrid relevance searches. A value of 0 disables it. */
  popularity_weight?: InputMaybe<Scalars['Float']['input']>;
  /** Provider UUID */
  provider?: InputMaybe<Scalars['GUID']['input']>;
  /** Allows filtering by published or unpublished status */
  published?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * URL-encoded search query.
   * This allows us to execute a string search against multiple fields eg. "Trap Snare"
   */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Optional server-side query understanding strategy. HEURISTIC_V1 currently supports samples. */
  query_strategy?: InputMaybe<AssetSearchQueryStrategy>;
  /**
   * Whether to rephrase the query using semantic search.
   * Defaults to true. Set to false to skip rephrasing when the query
   * is already a rephrased result from a previous search.
   */
  rephrase?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Pre-rephrased query string to use instead of calling the LLM to rephrase.
   * When provided, the search will use this value directly for semantic search
   * without triggering a new rephrase operation.
   */
  rephrased_query?: InputMaybe<Scalars['String']['input']>;
  /**
   * Semantic search relevance weight (0.0 to 1.0).
   * - Absent or 0.0 performs a traditional keyword search.
   * - 1.0 performs semantic search.
   */
  semantic?: InputMaybe<Scalars['Float']['input']>;
  /** Seed for siso (similar sounds) search */
  siso_seed?: InputMaybe<SisoSeedInput>;
  /**
   * Allow legacy clients to query tags in a backward-compatible way.
   * This input relaxes the `GUID` input type so that we can pass string
   * identifiers into queries.
   */
  tag_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tag_ids_exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tag_uuids_exclude?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  /** Return only content matching the tag uuids in the comma-delimited */
  tags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Asset User GUID */
  user_uuid?: InputMaybe<Scalars['GUID']['input']>;
}

export interface AssetFolderSummary {
  __typename?: 'AssetFolderSummary';
  children?: Maybe<Array<Maybe<AssetFolderSummary>>>;
  count?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
}

/** Ingestion issues for the asset itself, and if a parent asset, all children */
export interface AssetIngestionIssues {
  __typename?: 'AssetIngestionIssues';
  /** Ingestion issue details for all child assets */
  child_issues?: Maybe<Array<Maybe<AssetIssueDetail>>>;
  /** Ingestion issue details for the asset */
  issues?: Maybe<Array<Maybe<AssetIssueDetail>>>;
}

export interface AssetIssueDetail {
  __typename?: 'AssetIssueDetail';
  /** Asset type of the asset which is the source of this issue. */
  asset_type_slug?: Maybe<AssetTypeSlug>;
  /** GUID of the asset which is the source of this issue. */
  asset_uuid?: Maybe<Scalars['GUID']['output']>;
  level?: Maybe<AssetErrorLevel>;
  message?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<AssetIssueDetailMetadata>;
  /** Ingestion issue type. "upload", for example. */
  type?: Maybe<Scalars['String']['output']>;
}

export interface AssetIssueDetailMetadata {
  __typename?: 'AssetIssueDetailMetadata';
  assets?: Maybe<Array<Maybe<IAsset>>>;
  filename?: Maybe<Scalars['String']['output']>;
  fingerprint?: Maybe<Scalars['String']['output']>;
}

export enum AssetJobState {
  Building = 'building',
  Completed = 'completed',
  Error = 'error',
  Pending = 'pending',
  Processing = 'processing',
  Unknown = 'unknown'
}

/**
 * Use this input type to query the asset entry point
 * for legacy assets
 */
export interface AssetLegacyInput {
  searchCatalog?: InputMaybe<Scalars['Boolean']['input']>;
  type: AssetTypeSlug;
}

/** Desktop-specific asset metadata */
export interface AssetLocalInfo {
  __typename?: 'AssetLocalInfo';
  asset?: Maybe<DownloadableAsset>;
  /** Path on disk for assets modified locally by Bridge */
  bridgeModifiedPath?: Maybe<Scalars['String']['output']>;
  /** Flag to indicate that the asset is loading */
  loading?: Maybe<Scalars['Boolean']['output']>;
  /** Flag to indicate the state of an asset as it is loaded through Splice Connect */
  loadingInPlugin?: Maybe<Scalars['Int']['output']>;
  /** Loading progress between 0 and 100 */
  loadingProgress?: Maybe<Scalars['Int']['output']>;
  /** Path on disk for downloaded assets */
  path?: Maybe<Scalars['String']['output']>;
}

/** Paged set of Assets */
export interface AssetPage {
  __typename?: 'AssetPage';
  device_summary?: Maybe<Array<DeviceSummary>>;
  /**
   * Filters that were extracted from query string when extract_filters
   * was true in the request. Currently (2/23/26) available for one-shots / loops
   * filter on semantic search only.
   */
  extracted_filter_by?: Maybe<AssetSearchFilterBy>;
  folder_summary?: Maybe<Array<AssetFolderSummary>>;
  /** Subset of Assets */
  items?: Maybe<Array<AnyAsset>>;
  pagination_metadata?: Maybe<PaginationMetadata>;
  /**
   * The rephrased query string from semantic search.
   * Use this to skip rephrasing on subsequent identical searches.
   */
  rephrased_query_string?: Maybe<Scalars['String']['output']>;
  response_metadata?: Maybe<ResponseMetadata>;
  /** A list of tag uuids and their number of occurrences in the full set of Assets */
  tag_summary?: Maybe<Array<TagSummary>>;
}

/** Inputs to return the parent of a child asset */
export interface AssetParentsInput {
  /** Return all parents of a child */
  child_asset_uuid?: InputMaybe<Scalars['GUID']['input']>;
}

export enum AssetPublishResult {
  Failure = 'failure',
  Partial = 'partial',
  Success = 'success'
}

/** An asset status indicates whether an asset is published or unpublished. */
export interface AssetPublishStatus {
  __typename?: 'AssetPublishStatus';
  child_asset_uuids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['Int']['output']>;
  parent_asset_uuid?: Maybe<Scalars['String']['output']>;
}

export enum AssetRequestedStatus {
  Published = 'published',
  Restricted = 'restricted',
  Unpublished = 'unpublished'
}

/**
 * Below type is used in the semantic search response to define which asset filters the back-end
 * was able to detect from the user's query string.
 * Currently (2/23/26) available for one-shots / loops filter on semantic search only.
 */
export interface AssetSearchFilterBy {
  __typename?: 'AssetSearchFilterBy';
  asset_category?: Maybe<AssetCategorySlug>;
}

/**
 * Use this endpoint for parameters for legacy API search inputs. Only contains the parameters necessary to resolve
 * to legacy endpoints that won't be needed for catalog.
 */
export interface AssetSearchLegacyInput {
  parent_asset_type?: InputMaybe<AssetTypeSlug>;
  use?: InputMaybe<Scalars['Boolean']['input']>;
}

export enum AssetSearchQueryStrategy {
  HeuristicV1 = 'HEURISTIC_V1'
}

/** Inputs to sort the returned list of Assets */
export interface AssetSortInput {
  /** asc or desc */
  order?: InputMaybe<SortOrder>;
  /**
   * Enforce a stable random sort across page refreshes & pagination.
   * Send a new random_seed to refresh search results.
   */
  random_seed?: InputMaybe<Scalars['String']['input']>;
  /** The order in which a search query returns results */
  sort?: InputMaybe<AssetSortType>;
}

export enum AssetSortType {
  AssetStatusSlug = 'asset_status_slug',
  AudioKey = 'audio_key',
  Bpm = 'bpm',
  Duration = 'duration',
  /** @deprecated key is deprecated, use audio_key */
  Key = 'key',
  Name = 'name',
  Popularity = 'popularity',
  ProviderName = 'provider_name',
  PublishedAt = 'published_at',
  Random = 'random',
  Recency = 'recency',
  Recommended = 'recommended',
  Relevance = 'relevance',
  Score = 'score',
  UpdatedAt = 'updated_at'
}

/** TODO: This requires better documentation */
export interface AssetStatus {
  __typename?: 'AssetStatus';
  id?: Maybe<Scalars['Int']['output']>;
  /** The user-friendly name for the type (ie, "Foo Bar") */
  label?: Maybe<Scalars['String']['output']>;
  /** The tokenized format of the label. (ie, "foo-bar") */
  slug?: Maybe<AssetStatusSlug>;
}

/**
 * As opposed to the `AssetStatusSlug`, this enum lets us specify
 * additional states when querying assets that don't necessarily
 * map 1:1 with the status of the assets themselves. For instance,
 * assets can be queried by whether they're published, but we also
 * want to return results that the user has licensed, regardless
 * of the published status of the asset.
 */
export enum AssetStatusQuerySlug {
  Licensed = 'licensed',
  Published = 'published',
  Unpublished = 'unpublished'
}

export enum AssetStatusSlug {
  Published = 'published',
  Restricted = 'restricted',
  Unpublished = 'unpublished'
}

/** Asset Type is the type of thing you get. */
export interface AssetType {
  __typename?: 'AssetType';
  id?: Maybe<Scalars['Int']['output']>;
  /** The user-friendly name for the type (ie, "Foo Bar") */
  label?: Maybe<Scalars['String']['output']>;
  /** The tokenized format of the label. (ie, "foo-bar") */
  slug?: Maybe<AssetTypeSlug>;
}

export enum AssetTypeSlug {
  Collection = 'collection',
  GeneratedSample = 'generated_sample',
  Lesson = 'lesson',
  Midi = 'midi',
  Pack = 'pack',
  Plugin = 'plugin',
  Preset = 'preset',
  Sample = 'sample',
  Video = 'video'
}

/** Summary of asset counts grouped by asset type */
export interface AssetTypeSummary {
  __typename?: 'AssetTypeSummary';
  /** The asset type slug (e.g. "sample", "preset", "midi") */
  assetType: Scalars['String']['output'];
  /** The number of assets of this type matching the given filters */
  count: Scalars['Int']['output'];
}

/**
 * Input values used when creating or updating an Asset. Not all fields are
 * relevant to all asset types.
 */
export interface AssetUpdateInput {
  /** Asset Visibility Slug will be used to represent a video's availability (trial, public or subscribed) */
  asset_access_type_slug?: InputMaybe<AssetAccessTypeSlug>;
  asset_category_slug?: InputMaybe<AssetCategorySlug>;
  asset_status_slug?: InputMaybe<AssetStatusSlug>;
  bpm?: InputMaybe<Scalars['Int']['input']>;
  child_asset_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  chord_type?: InputMaybe<Scalars['String']['input']>;
  /** An image file of an asset's image preview. */
  cover_image?: InputMaybe<Scalars['Upload']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** A device on a preset */
  device_uuid?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  /** An array of device objects for a video asset */
  device_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  /** An array of instructor objects for a video asset */
  instructor_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  key?: InputMaybe<Scalars['String']['input']>;
  /** An array of lessons for a video asset */
  lessons?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  /** Free form device version */
  minimum_device_version?: InputMaybe<Scalars['String']['input']>;
  /** mp4 for a video asset */
  mp4?: InputMaybe<Scalars['Upload']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_asset_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  /** Where the asset lives on the site */
  permalink_slug?: InputMaybe<Scalars['String']['input']>;
  /** An MP3 file of an asset's audio preview. */
  preview_mp3?: InputMaybe<Scalars['Upload']['input']>;
  /** How much to charge */
  price_amount?: InputMaybe<Scalars['Float']['input']>;
  provider_sku?: InputMaybe<Scalars['String']['input']>;
  provider_uuid?: InputMaybe<Scalars['GUID']['input']>;
  /** Public will be used to represent whether the video is available to all users */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** A string field on a Lesson asset */
  subheader?: InputMaybe<Scalars['String']['input']>;
  tag_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  /** Trial will be used to represent whether the video is available only to trial members */
  trial?: InputMaybe<Scalars['Boolean']['input']>;
  /** Required during update; ignored during create. */
  uuid?: InputMaybe<Scalars['GUID']['input']>;
}

/** Input values used when uploading an Asset. */
export interface AssetUploadInput {
  asset_type?: InputMaybe<AssetTypeSlug>;
  /** A device name is the name of the Preset asset's device */
  device_name?: InputMaybe<Scalars['String']['input']>;
  /** A minimum device version is the version of the Preset asset's device */
  minimum_device_version?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['GUID']['input']>;
  /** A zip file that is correctly structured for the asset type selected. */
  zip: Scalars['Upload']['input'];
}

/** UUID will be deleted soon. */
export interface AssetUploadStatus {
  __typename?: 'AssetUploadStatus';
  asset_uuid: Scalars['GUID']['output'];
  entity_type?: Maybe<AssetTypeSlug>;
  job_state?: Maybe<AssetJobState>;
  job_uuid?: Maybe<Scalars['GUID']['output']>;
}

/** Input values used when uploading an Asset. */
export interface AssetUploadStatusInput {
  uuid?: InputMaybe<Scalars['GUID']['input']>;
}

export interface AssetsCost {
  __typename?: 'AssetsCost';
  count: Scalars['Int']['output'];
  price: Price;
  type: AssetTypeSlug;
}

export interface AudioContentItem {
  __typename?: 'AudioContentItem';
  artist: Scalars['String']['output'];
  content_id: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  revision: Scalars['Int']['output'];
  source_asset?: Maybe<ContentAsset>;
  source_id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: ContentType;
}

export interface AvailableCreditPacks {
  __typename?: 'AvailableCreditPacks';
  credit_boosters?: Maybe<Array<Maybe<CreditPack>>>;
  max_credits?: Maybe<Scalars['Int']['output']>;
  recommended?: Maybe<Scalars['GUID']['output']>;
}

/**
 * A saved beat in the Beatmaker app. Returns the beat content already merged:
 * pattern tracks and sample map combined into positional pads with boolean steps.
 */
export interface BeatmakerBeat {
  __typename?: 'BeatmakerBeat';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  bpm: Scalars['Float']['output'];
  kitUuid?: Maybe<Scalars['GUID']['output']>;
  name: Scalars['String']['output'];
  pads: Array<BeatmakerPad>;
  username?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['GUID']['output'];
}

export interface BeatmakerBeatContentInput {
  device?: InputMaybe<Scalars['String']['input']>;
  kitUuid?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pattern?: InputMaybe<BeatmakerBeatPatternInput>;
  sampleMap?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
}

export interface BeatmakerBeatPadInfoInput {
  cutSelf?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface BeatmakerBeatPatternInput {
  name?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<BeatmakerBeatSeqInput>;
  tracks?: InputMaybe<Array<InputMaybe<BeatmakerBeatTrackInput>>>;
  uuid?: InputMaybe<Scalars['String']['input']>;
}

export interface BeatmakerBeatSeqInput {
  bpm?: InputMaybe<Scalars['Float']['input']>;
  patternTracks?: InputMaybe<Scalars['JSON']['input']>;
}

export interface BeatmakerBeatTrackInput {
  name?: InputMaybe<Scalars['String']['input']>;
  padInfo?: InputMaybe<BeatmakerBeatPadInfoInput>;
  sample?: InputMaybe<BeatmakerBeatTrackSampleInput>;
  vol?: InputMaybe<Scalars['Float']['input']>;
}

export interface BeatmakerBeatTrackSampleInput {
  fileHash?: InputMaybe<Scalars['String']['input']>;
  imageURL?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}

/**
 * A Beatmaker kit (also known as a repack). Contains the browsable pool of
 * samples, pack filter chips, and kit metadata.
 */
export interface BeatmakerKit {
  __typename?: 'BeatmakerKit';
  coverUrl?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<BeatmakerKitCreator>;
  name: Scalars['String']['output'];
  packs?: Maybe<Array<Maybe<LegacyPack2>>>;
  samples?: Maybe<Array<Maybe<Sample>>>;
  totalSamples: Scalars['Int']['output'];
  uuid: Scalars['GUID']['output'];
}

export interface BeatmakerKitCreator {
  __typename?: 'BeatmakerKitCreator';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  username: Scalars['String']['output'];
}

/**
 * Minimal kit metadata returned when a kit is created. The full kit can
 * be retrieved via `beatmakerKit` once samples have been added.
 */
export interface BeatmakerKitSet {
  __typename?: 'BeatmakerKitSet';
  name?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['GUID']['output'];
}

/**
 * One positional pad in a beat: the file hash of the sample loaded on it,
 * the 32-step boolean pattern, which of those active steps are accented
 * (half velocity), and the volume (0–1).
 */
export interface BeatmakerPad {
  __typename?: 'BeatmakerPad';
  accents: Array<Scalars['Boolean']['output']>;
  fileHash?: Maybe<Scalars['String']['output']>;
  steps: Array<Scalars['Boolean']['output']>;
  volume: Scalars['Float']['output'];
}

/** A beat shared by the current user, as it appears in the "Your Beats" list. */
export interface BeatmakerSharedBeat {
  __typename?: 'BeatmakerSharedBeat';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['GUID']['output'];
}

export enum BillingFrequencySlug {
  Annual = 'annual',
  Monthly = 'monthly'
}

export interface BlogPost {
  __typename?: 'BlogPost';
  description: Scalars['String']['output'];
  external_id: Scalars['String']['output'];
  published_at: Scalars['String']['output'];
  thumbnail: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export enum Brand {
  All = 'ALL',
  Labs = 'LABS',
  SpitfireAudio = 'SPITFIRE_AUDIO',
  Splice = 'SPLICE'
}

export interface BulkAddAssetsToCollection {
  __typename?: 'BulkAddAssetsToCollection';
  collection?: Maybe<CollectionAsset>;
}

export interface BulkAssetActionInput {
  assetType?: InputMaybe<AssetTypeSlug>;
  items?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

/**
 * Input values used when creating a brand new Asset.
 *
 * All of these values needs to match the same filter values that
 * are pass in the the search for an asset in
 * apps/graphql/src/app/graphql/catalog/Query.graphql
 */
export interface BulkAssetUpdateFilters {
  asset_category_slug?: InputMaybe<Scalars['String']['input']>;
  asset_status_slug?: InputMaybe<AssetStatusSlug>;
  asset_type_slug: AssetTypeSlug;
  bpm?: InputMaybe<Scalars['String']['input']>;
  chord_type?: InputMaybe<Scalars['String']['input']>;
  device_name?: InputMaybe<Scalars['String']['input']>;
  device_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  excluded_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  filepath?: InputMaybe<Scalars['String']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  has_errors?: InputMaybe<Scalars['Boolean']['input']>;
  has_warnings?: InputMaybe<Scalars['Boolean']['input']>;
  include_inherited_tags?: InputMaybe<Scalars['Boolean']['input']>;
  instructor_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  key?: InputMaybe<Scalars['String']['input']>;
  licensed?: InputMaybe<Scalars['Boolean']['input']>;
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  max_bpm?: InputMaybe<Scalars['Int']['input']>;
  min_bpm?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exclude?: InputMaybe<Scalars['String']['input']>;
  parent_asset_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  provider?: InputMaybe<Scalars['GUID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  selected_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  tag_uuids_exclude?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
}

/** Input values used when creating a brand new Asset. */
export interface BulkAssetUpdateInput {
  add_devices?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  add_instructors?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  add_parent_asset_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  add_tags?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  asset_access_type_slug?: InputMaybe<AssetAccessTypeSlug>;
  asset_category_slug?: InputMaybe<AssetCategorySlug>;
  asset_type_slug?: InputMaybe<AssetTypeSlug>;
  bpm?: InputMaybe<Scalars['Int']['input']>;
  chord_type?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  device_uuid?: InputMaybe<Scalars['String']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  marketplace_status_slug?: InputMaybe<MarketplaceStatusSlug>;
  minimum_device_version?: InputMaybe<Scalars['String']['input']>;
  price_amount?: InputMaybe<Scalars['Float']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  remove_all_devices?: InputMaybe<Scalars['Boolean']['input']>;
  remove_all_instructors?: InputMaybe<Scalars['Boolean']['input']>;
  remove_all_parent_assets?: InputMaybe<Scalars['Boolean']['input']>;
  remove_all_tags?: InputMaybe<Scalars['Boolean']['input']>;
  remove_devices?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  remove_instructors?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  remove_parent_asset_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  remove_tags?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  replace_tags?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface BulkPublishResponse {
  __typename?: 'BulkPublishResponse';
  errors: Array<Maybe<PublishError>>;
  requested_status: AssetRequestedStatus;
  result: AssetPublishResult;
}

export interface BundleOffer {
  __typename?: 'BundleOffer';
  bundled_products: Array<BundledProduct>;
}

export interface BundledProduct {
  __typename?: 'BundledProduct';
  product: AnyProduct;
}

/**
 * One selectable cancellation reason from `/www/cancellation_reasons/{category}`.
 * The copy in `ui_text` is backend-owned — render it as-is.
 */
export interface CancellationReason {
  __typename?: 'CancellationReason';
  /** Groups reasons for analytics. */
  category_id: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  /** When true, the reason needs a free-text follow-up from the user. */
  requires_additional_info: Scalars['Boolean']['output'];
  /**
   * Radio label shown to the user. Submitted back as `cancellation_option_id`
   * via the `id` field, not this text.
   */
  ui_text: Scalars['String']['output'];
}

export interface CatalogJobError {
  __typename?: 'CatalogJobError';
  asset?: Maybe<AnyAsset>;
  asset_uuid: Scalars['GUID']['output'];
  errors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export interface CatalogJobResponse {
  __typename?: 'CatalogJobResponse';
  action?: Maybe<Scalars['String']['output']>;
  errors?: Maybe<Array<Maybe<CatalogJobError>>>;
  id?: Maybe<Scalars['Int']['output']>;
  job_uuid?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
}

export enum CatalogJobStatus {
  Completed = 'completed',
  Error = 'error',
  Processing = 'processing'
}

export interface CategoryPageContent {
  __typename?: 'CategoryPageContent';
  description?: Maybe<Scalars['JSON']['output']>;
  image?: Maybe<SanityImage>;
  permalink: Scalars['String']['output'];
}

export interface CheckoutBillingAddressInput {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  postal_code?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  street1?: InputMaybe<Scalars['String']['input']>;
  street2?: InputMaybe<Scalars['String']['input']>;
}

export interface CheckoutPlanSubscription {
  __typename?: 'CheckoutPlanSubscription';
  billing_frequency: BillingFrequencySlug;
  display_name: Scalars['String']['output'];
  plan_uuid: Scalars['ID']['output'];
  product_group?: Maybe<PlanGroupSlug>;
  renews_at: Scalars['String']['output'];
  state: SubscriptionState;
  subscription_uuid: Scalars['ID']['output'];
  trial_end_at?: Maybe<Scalars['String']['output']>;
  trial_start_at?: Maybe<Scalars['String']['output']>;
}

export interface CheckoutPromoCode {
  __typename?: 'CheckoutPromoCode';
  amountOff?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  durationInMonths?: Maybe<Scalars['Int']['output']>;
  durationTemporalAmount?: Maybe<Scalars['Int']['output']>;
  durationTemporalUnit?: Maybe<Scalars['String']['output']>;
}

export type ChildAsset = GeneratedSampleAsset | MidiAsset | PresetAsset | SampleAsset | VideoAsset;

export enum ChromaType {
  ChromaTypeDeep = 'CHROMA_TYPE_DEEP',
  ChromaTypeUnspecified = 'CHROMA_TYPE_UNSPECIFIED'
}

export interface CollectionAsset extends IAsset, IAssetParent, ICollection, ILegacyAsset {
  __typename?: 'CollectionAsset';
  activities?: Maybe<Array<Maybe<AssetActivity>>>;
  allowed_asset_type_child?: Maybe<Array<Maybe<AssetType>>>;
  asset_prices?: Maybe<Array<Maybe<Price>>>;
  asset_status_slug?: Maybe<AssetStatusSlug>;
  asset_type?: Maybe<AssetType>;
  asset_type_slug?: Maybe<AssetTypeSlug>;
  /** Eg. if an asset is rare */
  attributes?: Maybe<Array<AssetAttributeSlug>>;
  /** Eg, if asset is eligible for Presonus free bundled content */
  bundled_content_daws?: Maybe<Array<AssetBundledContentDawSlug>>;
  catalog_uuid?: Maybe<Scalars['GUID']['output']>;
  /** A summary count of all child assets of this asset, grouped by asset type. */
  child_asset_counts?: Maybe<Array<Maybe<RelatedAssetsCounts>>>;
  /** A query for children of this asset. */
  children?: Maybe<AssetPage>;
  collection_asset_images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cost?: Maybe<Array<AssetsCost>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  creator?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  file?: Maybe<AssetFile>;
  files?: Maybe<Array<AssetFile>>;
  /** An array of ingestion issues associated with the asset. */
  ingestion_issues?: Maybe<AssetIngestionIssues>;
  is_subscribed?: Maybe<Scalars['Boolean']['output']>;
  legacy_permalink?: Maybe<Scalars['String']['output']>;
  legacy_uuid?: Maybe<Scalars['GUID']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  marketplace_status_slug?: Maybe<MarketplaceStatusSlug>;
  name?: Maybe<Scalars['String']['output']>;
  owned?: Maybe<Scalars['Boolean']['output']>;
  permalink_base_url?: Maybe<Scalars['String']['output']>;
  permalink_slug?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  provider_sku?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['GUID']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  subscriber_count?: Maybe<Scalars['Int']['output']>;
  subscribers_subset?: Maybe<Array<Maybe<User>>>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}


export interface CollectionAssetChildrenArgs {
  filter: AssetFiltersInput;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<AssetSortInput>;
}


export interface CollectionAssetFileArgs {
  type?: InputMaybe<AssetFileTypeSlug>;
}

export interface ColorContentItem {
  __typename?: 'ColorContentItem';
  hex: Scalars['String']['output'];
  name: Scalars['String']['output'];
}

export interface CompanionPackGroup {
  __typename?: 'CompanionPackGroup';
  members?: Maybe<Array<Maybe<CompanionPackGroupMember>>>;
  parent_pack?: Maybe<CompanionPackGroupMember>;
  uuid?: Maybe<Scalars['ID']['output']>;
}

export interface CompanionPackGroupInput {
  members?: InputMaybe<Array<InputMaybe<CompanionPackGroupMemberInput>>>;
  parent_pack?: InputMaybe<CompanionPackGroupMemberInput>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
}

export interface CompanionPackGroupMember {
  __typename?: 'CompanionPackGroupMember';
  pack?: Maybe<LegacyPack2>;
}

export interface CompanionPackGroupMemberInput {
  pack?: InputMaybe<PackInput>;
}

export interface ContentAsset {
  __typename?: 'ContentAsset';
  asset_id?: Maybe<Scalars['String']['output']>;
  file?: Maybe<ContentAssetFile>;
  locale?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface ContentAssetFile {
  __typename?: 'ContentAssetFile';
  content_type?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<AssetDimensions>;
  filename?: Maybe<Scalars['String']['output']>;
  filesize?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface ContentGroup {
  __typename?: 'ContentGroup';
  description?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<Maybe<ContentGroupEntry>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface ContentGroupEntry {
  __typename?: 'ContentGroupEntry';
  caption?: Maybe<Scalars['String']['output']>;
  main_image_url?: Maybe<Scalars['String']['output']>;
  mobile_image_url?: Maybe<Scalars['String']['output']>;
  sample_pack?: Maybe<ContentGroupSamplePack>;
  sample_pack_uuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  user_premium_set?: Maybe<ContentGroupUserPremiumSet>;
  user_premium_set_uuid?: Maybe<Scalars['String']['output']>;
}

export interface ContentGroupSamplePack {
  __typename?: 'ContentGroupSamplePack';
  cover_url?: Maybe<Scalars['String']['output']>;
  demo_mp3_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  main_genre?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  provider_permalink?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['String']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uuid?: Maybe<Scalars['ID']['output']>;
}

export interface ContentGroupUser {
  __typename?: 'ContentGroupUser';
  avatar_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
}

export interface ContentGroupUserPremiumSet {
  __typename?: 'ContentGroupUserPremiumSet';
  cover_url?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<ContentGroupUser>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  subscription_count?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
}

export enum ContentType {
  Audio = 'audio',
  CuratedCollection = 'curatedCollection',
  DiscoverSectionWithItems = 'discoverSectionWithItems',
  DynamicContent = 'dynamicContent',
  HeroSection = 'heroSection',
  Image = 'image',
  Label = 'label',
  Library = 'library',
  Page = 'page',
  Sound = 'sound',
  Video = 'video'
}

export interface ConversionInfo {
  __typename?: 'ConversionInfo';
  amount_off?: Maybe<Scalars['Int']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  has_valid_coupon?: Maybe<Scalars['Boolean']['output']>;
  plan_cost?: Maybe<Scalars['Int']['output']>;
  plan_credits?: Maybe<Scalars['Int']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  plan_subtotal?: Maybe<Scalars['Int']['output']>;
  plan_tax?: Maybe<Scalars['Int']['output']>;
  plan_term?: Maybe<BillingFrequencySlug>;
  plan_total?: Maybe<Scalars['Int']['output']>;
  tax_type?: Maybe<Scalars['String']['output']>;
}

export interface CosoCustomStackTemplate {
  __typename?: 'CosoCustomStackTemplate';
  defaultLayers?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  layerFilters?: Maybe<Array<CosoLayerFilter>>;
  uuid: Scalars['String']['output'];
  version?: Maybe<CosoTemplateVersion>;
}

export interface CosoCustomStackTemplateInput {
  defaultLayers?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  layerFilters?: InputMaybe<Array<CosoLayerFilterInput>>;
  prompt?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['String']['input'];
  version?: InputMaybe<CosoTemplateVersionInput>;
}

export interface CosoHarmonicModeKey {
  __typename?: 'CosoHarmonicModeKey';
  audioKey?: Maybe<Scalars['String']['output']>;
  chordType?: Maybe<Scalars['String']['output']>;
}

export interface CosoLabelItem {
  __typename?: 'CosoLabelItem';
  label: Scalars['String']['output'];
  slug: Scalars['String']['output'];
}

export interface CosoLayerFilter {
  __typename?: 'CosoLayerFilter';
  bpmMax?: Maybe<Scalars['Int']['output']>;
  bpmMin?: Maybe<Scalars['Int']['output']>;
  layerType: Scalars['String']['output'];
  tagFilter?: Maybe<Scalars['String']['output']>;
}

export interface CosoLayerFilterInput {
  bpmMax?: InputMaybe<Scalars['Int']['input']>;
  bpmMin?: InputMaybe<Scalars['Int']['input']>;
  layerType: Scalars['String']['input'];
  tagFilter?: InputMaybe<Scalars['String']['input']>;
}

export interface CosoPlaybackMetadata {
  __typename?: 'CosoPlaybackMetadata';
  bpm?: Maybe<Scalars['Int']['output']>;
  numBars?: Maybe<Scalars['Int']['output']>;
  playbackBpm?: Maybe<Scalars['Float']['output']>;
  psOffset?: Maybe<Scalars['Int']['output']>;
}

export interface CosoSearchOpts {
  /** harmonicMode is a boolean flag indicating whether or not to return results in harmonic mode */
  harmonic_mode?: InputMaybe<Scalars['Boolean']['input']>;
  /** harmonicWeight value between -1 and 1 to indicate harmonic vs mix embedding */
  harmonic_mode_weight?: InputMaybe<Scalars['Float']['input']>;
}

/**
 * CosoSeedInput is a oneof type for seed input in CoSo new stack queries.
 * Only one field may be set.
 */
export interface CosoSeedInput {
  /** assetUuid specifies an asset in Splice catalog to use as the seed */
  assetUuid?: InputMaybe<Scalars['String']['input']>;
  /** clipUuid specifies a clip to use as the seed */
  clipUuid?: InputMaybe<Scalars['String']['input']>;
  /**
   * seedLayer is a StackLayer to use as the seed, e.g. to provide client-side embedding
   * @deprecated Use seedLayers
   */
  seedLayer?: InputMaybe<StackLayerInput>;
  /** seedLayers is a list of existing StackLayers to use as the seed */
  seedLayers?: InputMaybe<Array<StackLayerInput>>;
  /** userAudioFileHash specifies a user audio file to use as the seed */
  userAudioFileHash?: InputMaybe<Scalars['String']['input']>;
}

export interface CosoStackLayerType {
  __typename?: 'CosoStackLayerType';
  color?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
}

export interface CosoStackTemplate {
  __typename?: 'CosoStackTemplate';
  accessLevel?: Maybe<CosoStackTemplateAccessLevel>;
  collageImageUrls?: Maybe<Array<Scalars['String']['output']>>;
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  genreTagUuids?: Maybe<Array<Scalars['GUID']['output']>>;
  genreTags?: Maybe<Array<Maybe<Tag>>>;
  label: Scalars['String']['output'];
  slug: Scalars['ID']['output'];
}

export enum CosoStackTemplateAccessLevel {
  StackTemplateAccessLevelPremium = 'STACK_TEMPLATE_ACCESS_LEVEL_PREMIUM',
  StackTemplateAccessLevelUnspecified = 'STACK_TEMPLATE_ACCESS_LEVEL_UNSPECIFIED'
}

export interface CosoTemplateVersion {
  __typename?: 'CosoTemplateVersion';
  at?: Maybe<Scalars['String']['output']>;
  userUuid?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
}

export interface CosoTemplateVersionInput {
  at?: InputMaybe<Scalars['String']['input']>;
  userUuid?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
}

export interface CosoTypeMetadata {
  __typename?: 'CosoTypeMetadata';
  layerTypeLabels?: Maybe<Array<CosoLabelItem>>;
  layerTypeMetadata?: Maybe<Array<CosoStackLayerType>>;
  layerTypes?: Maybe<Array<Scalars['String']['output']>>;
  stackTemplateLabels?: Maybe<Array<CosoLabelItem>>;
  stackTemplateMetadata?: Maybe<Array<CosoStackTemplate>>;
  stackTemplates?: Maybe<Array<Scalars['String']['output']>>;
}

export interface CostEstimate {
  __typename?: 'CostEstimate';
  cost: Scalars['Int']['output'];
  userCredits?: Maybe<Scalars['Int']['output']>;
}

export enum CouponType {
  Bulk = 'BULK',
  SingleCode = 'SINGLE_CODE'
}

export interface CreateProofOfLicense {
  __typename?: 'CreateProofOfLicense';
  downloadUrl: Scalars['String']['output'];
  record?: Maybe<ProofOfLicense>;
}

export interface CreateWalletPaymentMethodInput {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  /** Result token from a completed 3D Secure challenge, on a retry. */
  threeDSecureActionResultTokenId?: InputMaybe<Scalars['String']['input']>;
  /** Recurly token for the card, PayPal account, or wallet payment sheet result. */
  token: Scalars['String']['input'];
}

export interface CreditBooster extends IProduct {
  __typename?: 'CreditBooster';
  actions?: Maybe<Array<SubscriptionAction>>;
  /** Underlying credit_booster record uuid */
  credit_booster_uuid: Scalars['GUID']['output'];
  credits: Scalars['Int']['output'];
  currency: Currency;
  full_price: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  product_name: Scalars['String']['output'];
  type: ProductType;
  /** products_catalog uuid — use this when posting to productCheckout */
  uuid: Scalars['ID']['output'];
}

export interface CreditPack {
  __typename?: 'CreditPack';
  credits?: Maybe<Scalars['Int']['output']>;
  is_available?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<CreditPackPrice>;
  uuid: Scalars['GUID']['output'];
}

export interface CreditPackPrice {
  __typename?: 'CreditPackPrice';
  USD?: Maybe<CreditPackPriceDetails>;
}

export interface CreditPackPriceDetails {
  __typename?: 'CreditPackPriceDetails';
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
}

export interface CreditSpend {
  __typename?: 'CreditSpend';
  asset?: Maybe<AnyAsset>;
  assetTypeSlug?: Maybe<Scalars['String']['output']>;
  assetUuid: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  purchased?: Maybe<Scalars['Boolean']['output']>;
}

export interface CreditsPurchaseResponse {
  __typename?: 'CreditsPurchaseResponse';
  credit_balance?: Maybe<Scalars['Int']['output']>;
}

export interface CtaCardLink {
  __typename?: 'CtaCardLink';
  ctaHeaderSubtext: Scalars['String']['output'];
  ctaHeaderText: Scalars['String']['output'];
  ctaPath: Scalars['String']['output'];
  iconName: Scalars['String']['output'];
  subscriberHideGroups?: Maybe<Array<PlanGroupSlug>>;
}

export interface CuratedCollection {
  __typename?: 'CuratedCollection';
  content_id: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  item_ids: Array<Scalars['String']['output']>;
  item_type?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<CuratedCollectionItem>>;
  locale: Scalars['String']['output'];
  revision?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: ContentType;
}

export type CuratedCollectionItem = CuratedCollection | ImageContentItem | InstrumentPack | LabelContentItem | SoundContentItem;

export enum Currency {
  Credits = 'Credits',
  Eur = 'EUR',
  Usd = 'USD'
}

/**
 * Reusable input that provides pagination parameters, useful
 * for any cursor paginated query from the API.
 */
export interface CursorPaginationInput {
  /** An identifier for where in the total results to begin to return records. */
  cursor?: InputMaybe<Scalars['String']['input']>;
  /** Number of records to return in a single request. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** An identifier for where in the total results to begin to return records. */
  page?: InputMaybe<Scalars['Int']['input']>;
}

export interface CustomStackTemplateFromPromptResult {
  __typename?: 'CustomStackTemplateFromPromptResult';
  prompt?: Maybe<Scalars['String']['output']>;
  targetBpm?: Maybe<Scalars['Int']['output']>;
  targetKey?: Maybe<CosoHarmonicModeKey>;
  template?: Maybe<CosoCustomStackTemplate>;
}

export interface DbStack {
  __typename?: 'DBStack';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  ownerUuid?: Maybe<Scalars['GUID']['output']>;
  source?: Maybe<DbStackSource>;
  stack?: Maybe<Stack>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
  version?: Maybe<Scalars['Int']['output']>;
}

export interface DbStackRef {
  __typename?: 'DBStackRef';
  stackUuid: Scalars['GUID']['output'];
  version: Scalars['Int']['output'];
}

export interface DbStackRefInput {
  stackUuid: Scalars['GUID']['input'];
  version: Scalars['Int']['input'];
}

export interface DbStackSource {
  __typename?: 'DBStackSource';
  snapshotUuid?: Maybe<Scalars['GUID']['output']>;
  stackRef?: Maybe<DbStackRef>;
}

export interface DbStackSourceInput {
  snapshotUuid?: InputMaybe<Scalars['GUID']['input']>;
  stackRef?: InputMaybe<DbStackRefInput>;
}

export interface DawDevice extends IDevice {
  __typename?: 'DawDevice';
  asset?: Maybe<AnyAsset>;
  device_type_slug?: Maybe<DeviceTypeSlug>;
  minimum_device_version?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['GUID']['output']>;
}

/** Paged set of Devices */
export interface DevicePage {
  __typename?: 'DevicePage';
  /** Subset of Devices */
  items?: Maybe<Array<Maybe<IDevice>>>;
  response_metadata?: Maybe<ResponseMetadata>;
}

export interface DeviceSummary {
  __typename?: 'DeviceSummary';
  /** The number of results with this device. */
  count?: Maybe<Scalars['Int']['output']>;
  device?: Maybe<IDevice>;
  deviceUuid?: Maybe<Scalars['GUID']['output']>;
}

export enum DeviceTypeSlug {
  Daw = 'daw',
  Plugin = 'plugin'
}

export interface Discount {
  __typename?: 'Discount';
  amount: Scalars['Int']['output'];
  duration?: Maybe<Scalars['Int']['output']>;
  promo_code?: Maybe<Scalars['String']['output']>;
  source: DiscountSource;
  type: DiscountType;
}

export enum DiscountSource {
  Coupon = 'coupon',
  Ramp = 'ramp'
}

export enum DiscountType {
  Fixed = 'fixed',
  Percent = 'percent',
  Ramp = 'ramp'
}

export interface DiscoverSectionWithItems {
  __typename?: 'DiscoverSectionWithItems';
  content_id: Scalars['String']['output'];
  item_ids: Array<Scalars['String']['output']>;
  item_type?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<InstrumentPack>>;
  locale: Scalars['String']['output'];
  revision?: Maybe<Scalars['Int']['output']>;
  strapline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: ContentType;
}

export interface Dismissables {
  __typename?: 'Dismissables';
  dashboard?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  general?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pack_recommendations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sounds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated studio removal */
  studio?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export type DownloadableAsset = GeneratedSampleAsset | PresetAsset | SampleAsset;

export interface EditorialSlideContent {
  __typename?: 'EditorialSlideContent';
  bannerImages: Array<SanityEditorialBannerImages>;
  ctaText: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  header: Scalars['String']['output'];
  id: Scalars['String']['output'];
  packs: Array<PackAsset>;
  samples: Array<SampleAsset>;
}

export interface EstimateStackKeyResult {
  __typename?: 'EstimateStackKeyResult';
  stackKey?: Maybe<StackKey>;
}

export interface ExportStackResult {
  __typename?: 'ExportStackResult';
  /**
   * Archive manifest of the exported result (e.g. of an Ableton project).
   * The manifest should contain everything needed to assemble and deliver
   * the result to the user in a suitable format such as a ZIP file download.
   */
  manifest?: Maybe<ArchiveManifest>;
  /**
   * Copy of the Stack as it was exported, provided so the client can access
   * properties such as BPM, pitch shift, etc. if needed e.g. for stem rendering.
   */
  stack?: Maybe<Stack>;
}

export interface FailedWalletPaymentMethodAssignment {
  __typename?: 'FailedWalletPaymentMethodAssignment';
  error: Scalars['String']['output'];
  type: PaymentMethodAssignmentType;
  uuid: Scalars['ID']['output'];
}

export interface FeaturedPlanContentItem {
  __typename?: 'FeaturedPlanContentItem';
  image: Scalars['String']['output'];
  text: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface FeaturedPlanTermsItem {
  __typename?: 'FeaturedPlanTermsItem';
  image: Scalars['String']['output'];
  mobileText?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface FeaturedPlugin {
  __typename?: 'FeaturedPlugin';
  description: Scalars['String']['output'];
  product?: Maybe<WwwPlugin>;
  src?: Maybe<Scalars['String']['output']>;
  src_2x?: Maybe<Scalars['String']['output']>;
  subhead: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface FloatVector {
  __typename?: 'FloatVector';
  data?: Maybe<Array<Scalars['Float']['output']>>;
  label?: Maybe<Scalars['String']['output']>;
  shape?: Maybe<Array<Scalars['Int']['output']>>;
  uuid: Scalars['GUID']['output'];
}

export interface FloatVectorInput {
  data: Array<Scalars['Float']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  shape?: InputMaybe<Array<Scalars['Int']['input']>>;
}

export interface Gear {
  __typename?: 'Gear';
  canonical_url?: Maybe<Scalars['String']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  is_free?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<Manufacturer>;
  name?: Maybe<Scalars['String']['output']>;
  prerelease?: Maybe<Scalars['Boolean']['output']>;
  tag_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['GUID']['output'];
}

export interface GearComponent {
  __typename?: 'GearComponent';
  gear_data: GearMetaData;
  leasable_data: LeaseData;
  type: Scalars['String']['output'];
}

export interface GearEdition {
  __typename?: 'GearEdition';
  canonical_path: Scalars['String']['output'];
  installment_price: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  plugin_description_id: Scalars['Int']['output'];
}

export interface GearFeatureHighlights {
  __typename?: 'GearFeatureHighlights';
  description?: Maybe<Scalars['String']['output']>;
  items: Array<HighlightMedia>;
  title: Scalars['String']['output'];
}

export enum GearFormat {
  Aax = 'AAX',
  Au = 'AU',
  Standalone = 'Standalone',
  Vst = 'VST',
  Vst3 = 'VST3'
}

export interface GearImage {
  __typename?: 'GearImage';
  alt_text?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: GearMediaType;
  url: Scalars['String']['output'];
}

export type GearMedia = GearImage | GearVideo;

export enum GearMediaType {
  Image = 'image',
  Video = 'video'
}

export interface GearMetaData {
  __typename?: 'GearMetaData';
  canonical_path: Scalars['String']['output'];
  display_name: Scalars['String']['output'];
  hide: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  prerelease: Scalars['Boolean']['output'];
  thumbnail_url: Scalars['String']['output'];
}

export interface GearMiniFeatures {
  __typename?: 'GearMiniFeatures';
  description?: Maybe<Scalars['String']['output']>;
  items: Array<GearImage>;
  title: Scalars['String']['output'];
}

export interface GearPlugin {
  __typename?: 'GearPlugin';
  display_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  /**
   * Map of platform → array of detail objects (filename, registry_key,
   * bundle_identifier, min_version). Typed as JSON for the same reason as
   * `latest_versions`: missing platform keys are omitted rather than null.
   */
  install_details: Scalars['JSON']['output'];
  is_splice: Scalars['Boolean']['output'];
  /**
   * Map of platform → latest version string, e.g.
   * `{ "darwin": "1.2.3", "windows": "1.2.3" }`. Typed as JSON so missing
   * platform keys are omitted rather than serialized as null.
   */
  latest_versions: Scalars['JSON']['output'];
  manufacturer: GearPluginManufacturer;
  plan_status?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
}

/**
 * Signed installer URL for a specific plugin + platform. The signed URL has a
 * short TTL; callers must request a fresh URL per install attempt and must NOT
 * cache the response alongside the `gearPlugins` list.
 */
export interface GearPluginInstaller {
  __typename?: 'GearPluginInstaller';
  url: Scalars['String']['output'];
}

export interface GearPluginManufacturer {
  __typename?: 'GearPluginManufacturer';
  name: Scalars['String']['output'];
}

/** Plugins the authenticated user has access to (via lease or entitlement). */
export interface GearPlugins {
  __typename?: 'GearPlugins';
  plugins: Array<GearPlugin>;
}

export interface GearSeo {
  __typename?: 'GearSeo';
  seo_description: Scalars['String']['output'];
  seo_title: Scalars['String']['output'];
  share_image_path: Scalars['String']['output'];
}

export interface GearSpecifications {
  __typename?: 'GearSpecifications';
  available_formats: Array<GearFormat>;
  manufacturer_url?: Maybe<Scalars['String']['output']>;
  max_activations: Scalars['Int']['output'];
  requirements: Array<Scalars['String']['output']>;
  /** @deprecated Use available_formats and supported_platforms to determine images client side */
  specification_images: Array<Scalars['String']['output']>;
  specification_text: Scalars['String']['output'];
  supported_platforms: Array<Platform>;
  /** @deprecated Use manufacturer_url and requirements instead */
  system_requirements: Scalars['String']['output'];
}

export interface GearVideo {
  __typename?: 'GearVideo';
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  thumbnail_url: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  type: GearMediaType;
  upload_date?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  youtube_id?: Maybe<Scalars['String']['output']>;
}

export interface GeneratedSampleAsset extends IAsset, IAssetChild, IDownloadableAsset, ILegacyAsset, ISample {
  __typename?: 'GeneratedSampleAsset';
  activities?: Maybe<Array<Maybe<AssetActivity>>>;
  allowed_asset_type_child?: Maybe<Array<Maybe<AssetType>>>;
  asset_category_slug?: Maybe<AssetCategorySlug>;
  asset_prices?: Maybe<Array<Maybe<Price>>>;
  asset_status_slug?: Maybe<AssetStatusSlug>;
  asset_type?: Maybe<AssetType>;
  asset_type_slug?: Maybe<AssetTypeSlug>;
  /** Eg. if an asset is rare */
  attributes?: Maybe<Array<AssetAttributeSlug>>;
  bpm?: Maybe<Scalars['Int']['output']>;
  /** Eg, if asset is eligible for Presonus free bundled content */
  bundled_content_daws?: Maybe<Array<AssetBundledContentDawSlug>>;
  catalog_uuid?: Maybe<Scalars['GUID']['output']>;
  chord_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * by default the name for a sample is the full filepath
   * This will just be the path to the file.
   * example: /drums/snares/128/
   */
  display_file_path?: Maybe<Scalars['String']['output']>;
  /**
   * by default the name for a sample is the full filepath
   * This will just be the file name.
   * example: snare_128.wav
   */
  display_name?: Maybe<Scalars['String']['output']>;
  downloaded?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  file?: Maybe<AssetFile>;
  files?: Maybe<Array<AssetFile>>;
  /** Ingestion issues associated with the asset. */
  ingestion_issues?: Maybe<AssetIngestionIssues>;
  instrument?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  legacy_permalink?: Maybe<Scalars['String']['output']>;
  legacy_uuid?: Maybe<Scalars['GUID']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  localInfo?: Maybe<AssetLocalInfo>;
  marketplace_status_slug?: Maybe<MarketplaceStatusSlug>;
  name?: Maybe<Scalars['String']['output']>;
  pack_parent?: Maybe<PackAsset>;
  /** A summary count of all parent assets of this asset, grouped by asset type. */
  parent_asset_counts?: Maybe<Array<Maybe<RelatedAssetsCounts>>>;
  parent_asset_uuids?: Maybe<Array<Maybe<Scalars['GUID']['output']>>>;
  parents?: Maybe<AssetPage>;
  permalink_base_url?: Maybe<Scalars['String']['output']>;
  permalink_slug?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  provider_sku?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['GUID']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}


export interface GeneratedSampleAssetFileArgs {
  type?: InputMaybe<AssetFileTypeSlug>;
}


export interface GeneratedSampleAssetFilesArgs {
  includeSource?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface GeneratedSampleAssetParentsArgs {
  filter: AssetFiltersInput;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<AssetSortInput>;
}

/** Response from the search service */
export interface GetAssetsSearchResponse {
  __typename?: 'GetAssetsSearchResponse';
  folder_summary?: Maybe<Array<Maybe<AssetFolderSummary>>>;
  /** uuids for the requested assets */
  items?: Maybe<Array<Maybe<Scalars['GUID']['output']>>>;
  response_metadata?: Maybe<ResponseMetadata>;
  tag_summary?: Maybe<Array<TagSummary>>;
}

export enum GrantAction {
  ConvertTrial = 'convert_trial',
  Resubscribe = 'resubscribe',
  Resume = 'resume',
  Signin = 'signin',
  Subscribe = 'subscribe',
  UpdatePayment = 'update_payment',
  Upgrade = 'upgrade'
}

export interface HighlightImage {
  __typename?: 'HighlightImage';
  description: Scalars['String']['output'];
  highlight_thumbnail: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: GearMediaType;
  url: Scalars['String']['output'];
}

export type HighlightMedia = HighlightImage | HighlightVideo;

export interface HighlightVideo {
  __typename?: 'HighlightVideo';
  description: Scalars['String']['output'];
  highlight_thumbnail: Scalars['String']['output'];
  thumbnail_url: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: GearMediaType;
  url: Scalars['String']['output'];
}

/** Type representing an HTTP header key/value pair */
export interface HttpHeader {
  __typename?: 'HttpHeader';
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['String']['output']>;
}

export enum HttpMethod {
  Connect = 'CONNECT',
  Delete = 'DELETE',
  Get = 'GET',
  Head = 'HEAD',
  Options = 'OPTIONS',
  Patch = 'PATCH',
  Post = 'POST',
  Put = 'PUT',
  Trace = 'TRACE'
}

/** The common interface on all Assets in Splice's inventory */
export interface IAsset {
  activities?: Maybe<Array<Maybe<AssetActivity>>>;
  asset_prices?: Maybe<Array<Maybe<Price>>>;
  asset_status_slug?: Maybe<AssetStatusSlug>;
  asset_type?: Maybe<AssetType>;
  asset_type_slug?: Maybe<AssetTypeSlug>;
  /** Eg. if an asset is rare */
  attributes?: Maybe<Array<AssetAttributeSlug>>;
  /** Eg, if asset is eligible for Presonus free bundled content */
  bundled_content_daws?: Maybe<Array<AssetBundledContentDawSlug>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file?: Maybe<AssetFile>;
  files?: Maybe<Array<AssetFile>>;
  /** Ingestion issues associated with the asset and its children if applicable. */
  ingestion_issues?: Maybe<AssetIngestionIssues>;
  legacy_permalink?: Maybe<Scalars['String']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  marketplace_status_slug?: Maybe<MarketplaceStatusSlug>;
  name?: Maybe<Scalars['String']['output']>;
  permalink_base_url?: Maybe<Scalars['String']['output']>;
  permalink_slug?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  /** example: NG001 */
  provider_sku?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['GUID']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}


/** The common interface on all Assets in Splice's inventory */
export interface IAssetFileArgs {
  type?: InputMaybe<AssetFileTypeSlug>;
}

/** An `IAssetChild` can have parents, and provides ways to query its parents */
export interface IAssetChild {
  /** A query for the parent of this asset. */
  pack_parent?: Maybe<PackAsset>;
  /** A summary count of all parent assets of this asset, grouped by asset type. */
  parent_asset_counts?: Maybe<Array<Maybe<RelatedAssetsCounts>>>;
  /** A list of parent assets to this child asset */
  parent_asset_uuids?: Maybe<Array<Maybe<Scalars['GUID']['output']>>>;
  /**
   * A query for parents of this asset. Only one asset type may be queried
   * at a time.
   */
  parents?: Maybe<AssetPage>;
  uuid: Scalars['GUID']['output'];
}


/** An `IAssetChild` can have parents, and provides ways to query its parents */
export interface IAssetChildParentsArgs {
  filter: AssetFiltersInput;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<AssetSortInput>;
}

/** An `IAssetParent` can have children, and provides ways to query its children. */
export interface IAssetParent {
  /** An ordered list of which asset types can be children */
  allowed_asset_type_child?: Maybe<Array<Maybe<AssetType>>>;
  /** A summary count of all child assets of this asset, grouped by asset type. */
  child_asset_counts?: Maybe<Array<Maybe<RelatedAssetsCounts>>>;
  /** A query for children of this asset. */
  children?: Maybe<AssetPage>;
  cost?: Maybe<Array<AssetsCost>>;
  uuid: Scalars['GUID']['output'];
}


/** An `IAssetParent` can have children, and provides ways to query its children. */
export interface IAssetParentChildrenArgs {
  filter: AssetFiltersInput;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<AssetSortInput>;
}

export interface ICollection {
  creator?: Maybe<User>;
  owned?: Maybe<Scalars['Boolean']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  subscriber_count?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['GUID']['output'];
}

export interface IDevice {
  device_type_slug?: Maybe<DeviceTypeSlug>;
  /** @deprecated this never worked */
  minimum_device_version?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['GUID']['output']>;
}

export interface IDownloadableAsset {
  downloaded?: Maybe<Scalars['Boolean']['output']>;
  localInfo?: Maybe<AssetLocalInfo>;
}

/** Additional fields on Assets existing in both legacy and catalog */
export interface ILegacyAsset {
  /** Catalog asset UUID (if available) */
  catalog_uuid?: Maybe<Scalars['GUID']['output']>;
  /** Identifier (UUID or file hash) for this asset in Legacy API */
  legacy_uuid?: Maybe<Scalars['GUID']['output']>;
}

export interface IPreset {
  /** The plugin that this preset is compatible with. */
  device?: Maybe<PluginDevice>;
}

export interface IProduct {
  currency?: Maybe<Currency>;
  full_price: Scalars['Int']['output'];
  product_name: Scalars['String']['output'];
  type: ProductType;
  uuid: Scalars['ID']['output'];
}

export interface IReportableAsset {
  reported?: Maybe<Scalars['Boolean']['output']>;
}

export interface ISample {
  asset_category_slug?: Maybe<AssetCategorySlug>;
  /** example: 174 */
  bpm?: Maybe<Scalars['Int']['output']>;
  /** example: minor */
  chord_type?: Maybe<Scalars['String']['output']>;
  /** Duration in milliseconds */
  duration?: Maybe<Scalars['Int']['output']>;
  instrument?: Maybe<Scalars['String']['output']>;
  /** example: f# */
  key?: Maybe<Scalars['String']['output']>;
}

export interface ImageContentItem {
  __typename?: 'ImageContentItem';
  content_id?: Maybe<Scalars['String']['output']>;
  credit?: Maybe<Scalars['String']['output']>;
  image_asset?: Maybe<ContentAsset>;
  image_id?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  type: ContentType;
}

export interface InfluenceGenre {
  __typename?: 'InfluenceGenre';
  bpm_high?: Maybe<Scalars['Int']['output']>;
  bpm_low?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  seo_description?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['GUID']['output'];
  year?: Maybe<Scalars['Int']['output']>;
}

export interface Instructor {
  __typename?: 'Instructor';
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['GUID']['output'];
}

export interface InstructorCreateInput {
  name?: InputMaybe<Scalars['String']['input']>;
}

/** Paged set of Instructors */
export interface InstructorPage {
  __typename?: 'InstructorPage';
  /** Subset of Instructors */
  items?: Maybe<Array<Maybe<Instructor>>>;
  response_metadata?: Maybe<ResponseMetadata>;
}

export interface InstrumentPack {
  __typename?: 'InstrumentPack';
  additional_audio_demo_ids: Array<Scalars['String']['output']>;
  additional_audio_demos?: Maybe<Array<Maybe<AudioContentItem>>>;
  audio_demo?: Maybe<AudioContentItem>;
  audio_demo_id: Scalars['String']['output'];
  brand: Scalars['String']['output'];
  content_id: Scalars['String']['output'];
  free?: Maybe<Scalars['Boolean']['output']>;
  hero_image?: Maybe<ImageContentItem>;
  hero_image_id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<ImageContentItem>;
  image_id: Scalars['String']['output'];
  is_new?: Maybe<Scalars['Boolean']['output']>;
  label_ids: Array<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<LabelContentItem>>>;
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  number_of_sounds: Scalars['Int']['output'];
  primary_color?: Maybe<ColorContentItem>;
  provider: Scalars['String']['output'];
  recommended_libraries?: Maybe<Array<Maybe<InstrumentPack>>>;
  recommended_library_ids: Array<Scalars['String']['output']>;
  release_date?: Maybe<Scalars['String']['output']>;
  secondary_color?: Maybe<ColorContentItem>;
  secondary_image?: Maybe<ImageContentItem>;
  secondary_image_id?: Maybe<Scalars['String']['output']>;
  seo_summary: Scalars['String']['output'];
  slab_instrument_image?: Maybe<ImageContentItem>;
  slab_instrument_image_id?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  sound_ids: Array<Scalars['String']['output']>;
  sounds?: Maybe<Array<Maybe<SoundContentItem>>>;
  square_hero_image?: Maybe<ImageContentItem>;
  square_hero_image_id?: Maybe<Scalars['String']['output']>;
  square_instrument_image?: Maybe<ImageContentItem>;
  square_instrument_image_id?: Maybe<Scalars['String']['output']>;
  summary: Scalars['String']['output'];
  tall_card_video_id?: Maybe<Scalars['String']['output']>;
  tertiary_image?: Maybe<ImageContentItem>;
  tertiary_image_id?: Maybe<Scalars['String']['output']>;
  type: ContentType;
}

export interface InstrumentPackFiltersInput {
  brand?: InputMaybe<Brand>;
  free?: InputMaybe<Scalars['Boolean']['input']>;
  labelId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}

export interface InstrumentPacksWithPagination {
  __typename?: 'InstrumentPacksWithPagination';
  packs: Array<InstrumentPack>;
  pagination: Pagination;
}

export interface IntercomUser {
  __typename?: 'IntercomUser';
  hash?: Maybe<Scalars['String']['output']>;
}

export interface LabelContentItem {
  __typename?: 'LabelContentItem';
  content_id: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  primary_color?: Maybe<ColorContentItem>;
  revision?: Maybe<Scalars['Int']['output']>;
  secondary_color?: Maybe<ColorContentItem>;
  slug: Scalars['String']['output'];
  type: ContentType;
}

/**
 * Partial region spec for a StackLayer's contribution to CoSo compatibility.
 * Beat indices are 0-indexed over the fixed 32-beat (8-bar) stack canvas ([0, 32)).
 * 4 beats per bar — e.g. bar 5 starts at beat 20.
 */
export interface LayerRegion {
  __typename?: 'LayerRegion';
  /**
   * Non-empty list of beat segments. Beats outside the union of dest ranges are
   * silence. Dest ranges must not overlap; source ranges may overlap.
   */
  segments: Array<LayerRegionSegment>;
}

export interface LayerRegionInput {
  segments: Array<LayerRegionSegmentInput>;
}

export interface LayerRegionSegment {
  __typename?: 'LayerRegionSegment';
  /** Destination beat offset in the 32-beat stack canvas. Range: [0, 31]. */
  destStartBeat: Scalars['Int']['output'];
  /**
   * Width in beats. Must be > 0 and satisfy
   * sourceStartBeat + numBeats <= 32 and destStartBeat + numBeats <= 32.
   */
  numBeats: Scalars['Int']['output'];
  /**
   * Source beat offset into the layer's 32-beat canvas. Range: [0, 31].
   * The 32-beat canvas is the post-BPM-multiplier, post-tile view of the native
   * sample (a 1-bar sample tiles 8×, 2-bar tiles 4×, etc.).
   */
  sourceStartBeat: Scalars['Int']['output'];
}

export interface LayerRegionSegmentInput {
  destStartBeat: Scalars['Int']['input'];
  numBeats: Scalars['Int']['input'];
  sourceStartBeat: Scalars['Int']['input'];
}

export enum LeasableGearCategoryInput {
  Essentials = 'essentials',
  New = 'new'
}

export interface LeaseData {
  __typename?: 'LeaseData';
  created_at: Scalars['DateTime']['output'];
  discount_text?: Maybe<Scalars['String']['output']>;
  edition_level?: Maybe<Scalars['String']['output']>;
  full_price: Scalars['Int']['output'];
  has_upgrade?: Maybe<Scalars['Boolean']['output']>;
  installment_price: Scalars['Int']['output'];
  marketing_opt_in?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  plugin_description_id: Scalars['String']['output'];
  plugin_seller_code: Scalars['String']['output'];
  total_installments: Scalars['Int']['output'];
  trial_period_days?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['GUID']['output'];
}

/**
 * One segment of an upgrade chain. A lease that was never upgraded has no
 * `lease_info` and is described entirely by the fields on `WwwPluginLease`.
 */
export interface LeaseInfo {
  __typename?: 'LeaseInfo';
  installment_price: Scalars['Int']['output'];
  installments_paid: Scalars['Int']['output'];
  plugin_display_name: Scalars['String']['output'];
  /**
   * Licence serials for this segment. Issued asynchronously after payoff, so an
   * entry can exist with an empty `serial` while the licence is still pending.
   */
  serials?: Maybe<Array<LeaseSerial>>;
  total_installments: Scalars['Int']['output'];
}

/**
 * Card expiry confirmation for a plugin lease payoff. An input object because
 * the upstream contract is "both or neither".
 */
export interface LeasePayoffCardExpiryInput {
  /** Expiry month of the card on file, 1-12. */
  expMonth: Scalars['Int']['input'];
  /** Four-digit expiry year of the card on file. */
  expYear: Scalars['Int']['input'];
}

export interface LeaseSerial {
  __typename?: 'LeaseSerial';
  display_name?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  serial: Scalars['String']['output'];
}

export interface LeaseUpgrade {
  __typename?: 'LeaseUpgrade';
  additional_months?: Maybe<Scalars['Int']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  installment_price?: Maybe<Scalars['Int']['output']>;
  installments_left?: Maybe<Scalars['Int']['output']>;
  original_lease_uuid?: Maybe<Scalars['String']['output']>;
  plan_name?: Maybe<Scalars['String']['output']>;
  seller_code?: Maybe<Scalars['String']['output']>;
  total_installments?: Maybe<Scalars['Int']['output']>;
  upgrade_installment_price?: Maybe<Scalars['Int']['output']>;
  upgrade_plan_name?: Maybe<Scalars['String']['output']>;
  upgrade_seller_code?: Maybe<Scalars['String']['output']>;
}

export interface LegacyAdminMutation {
  __typename?: 'LegacyAdminMutation';
  addCompanionPack?: Maybe<CompanionPackGroup>;
  addPackStory?: Maybe<LegacyPack2>;
  addPackStoryVideo?: Maybe<PackStoryVideo>;
  deletePackStory?: Maybe<Scalars['Boolean']['output']>;
  publishPack?: Maybe<LegacyPack2>;
  removeCompanionPack?: Maybe<CompanionPackGroup>;
  reorderCompanionPackMembers?: Maybe<CompanionPackGroup>;
  unpublishPack?: Maybe<LegacyPack2>;
  updatePackSamples?: Maybe<Scalars['Boolean']['output']>;
  updatePackStory?: Maybe<PackStory>;
  updateSample?: Maybe<Sample>;
  updateSamples?: Maybe<Scalars['Boolean']['output']>;
}


export interface LegacyAdminMutationAddCompanionPackArgs {
  group?: InputMaybe<CompanionPackGroupInput>;
  pack: PackInput;
  parentPackUuid: Scalars['ID']['input'];
}


export interface LegacyAdminMutationAddPackStoryArgs {
  story: PackStoryInput;
  uuid: Scalars['ID']['input'];
}


export interface LegacyAdminMutationAddPackStoryVideoArgs {
  uuid: Scalars['ID']['input'];
  video?: InputMaybe<PackStoryVideoInput>;
}


export interface LegacyAdminMutationDeletePackStoryArgs {
  uuid: Scalars['ID']['input'];
}


export interface LegacyAdminMutationPublishPackArgs {
  uuid: Scalars['ID']['input'];
}


export interface LegacyAdminMutationRemoveCompanionPackArgs {
  group: CompanionPackGroupInput;
  pack: PackInput;
}


export interface LegacyAdminMutationReorderCompanionPackMembersArgs {
  group: CompanionPackGroupInput;
}


export interface LegacyAdminMutationUnpublishPackArgs {
  uuid: Scalars['ID']['input'];
}


export interface LegacyAdminMutationUpdatePackSamplesArgs {
  attributes: SampleInput;
  mode?: InputMaybe<UpdateMode>;
  packUuid: Scalars['ID']['input'];
}


export interface LegacyAdminMutationUpdatePackStoryArgs {
  story: PackStoryInput;
  uuid: Scalars['ID']['input'];
}


export interface LegacyAdminMutationUpdateSampleArgs {
  sample: SampleInput;
}


export interface LegacyAdminMutationUpdateSamplesArgs {
  attributes: SampleInput;
  hashes?: InputMaybe<Array<Scalars['ID']['input']>>;
  mode?: InputMaybe<UpdateMode>;
}

export interface LegacyAdminQuery {
  __typename?: 'LegacyAdminQuery';
  pack?: Maybe<LegacyPack2>;
  packSamples?: Maybe<Array<Maybe<Sample>>>;
  provider?: Maybe<LegacyProvider>;
  providerPacks?: Maybe<PackSearchResponse>;
}


export interface LegacyAdminQueryPackArgs {
  uuid?: InputMaybe<Scalars['ID']['input']>;
}


export interface LegacyAdminQueryPackSamplesArgs {
  uuid: Scalars['ID']['input'];
}


export interface LegacyAdminQueryProviderArgs {
  uuid: Scalars['ID']['input'];
}


export interface LegacyAdminQueryProviderPacksArgs {
  filter: Scalars['String']['input'];
  order: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  search: Scalars['String']['input'];
  sort: Scalars['String']['input'];
  uuid: Scalars['ID']['input'];
}

export interface LegacyPack {
  __typename?: 'LegacyPack';
  cover_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
}

export interface LegacyPack2 {
  __typename?: 'LegacyPack2';
  companion_pack_group?: Maybe<CompanionPackGroup>;
  cover_path?: Maybe<Scalars['String']['output']>;
  cover_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  provider?: Maybe<LegacyProvider>;
  provider_uuid?: Maybe<Scalars['String']['output']>;
  published_at?: Maybe<Scalars['String']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  story?: Maybe<PackStory>;
  unpublished_sample_count?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
}

export interface LegacyPlanSubscription {
  __typename?: 'LegacyPlanSubscription';
  name?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
}

export interface LegacyProvider {
  __typename?: 'LegacyProvider';
  description?: Maybe<Scalars['String']['output']>;
  external_service?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  image_path?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pack_count?: Maybe<Scalars['Int']['output']>;
  packs?: Maybe<PackSearchResponse>;
  permalink?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  twitter_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
  visible?: Maybe<Scalars['Boolean']['output']>;
}


export interface LegacyProviderPacksArgs {
  filter: Scalars['String']['input'];
  order: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  search: Scalars['String']['input'];
  sort: Scalars['String']['input'];
}

export interface LegacyRelease {
  __typename?: 'LegacyRelease';
  advertised?: Maybe<Scalars['Boolean']['output']>;
  artwork_background_url?: Maybe<Scalars['String']['output']>;
  artwork_url?: Maybe<Scalars['String']['output']>;
  canonical_path?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  collaborators?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  created_at?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  is_published?: Maybe<Scalars['Boolean']['output']>;
  is_remix?: Maybe<Scalars['Boolean']['output']>;
  license?: Maybe<Scalars['String']['output']>;
  license_count?: Maybe<Scalars['Int']['output']>;
  like_count?: Maybe<Scalars['Int']['output']>;
  parent?: Maybe<LegacyReleaseParent>;
  permalink?: Maybe<Scalars['String']['output']>;
  play_count?: Maybe<Scalars['Int']['output']>;
  player_background_url?: Maybe<Scalars['String']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  preview_uuid?: Maybe<Scalars['String']['output']>;
  read_only?: Maybe<Scalars['Boolean']['output']>;
  related_sources?: Maybe<Array<Maybe<LegacyReleaseRelatedSource>>>;
  stem_count?: Maybe<Scalars['Int']['output']>;
  stems?: Maybe<Array<Maybe<LegacyReleaseStem>>>;
  tags?: Maybe<Scalars['Void']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  user_avatar_url?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['Int']['output']>;
  user_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  username?: Maybe<Scalars['String']['output']>;
  usernames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uuid: Scalars['String']['output'];
  vanity_url?: Maybe<Scalars['String']['output']>;
  waveform_url?: Maybe<Scalars['String']['output']>;
}

export interface LegacyReleaseParent {
  __typename?: 'LegacyReleaseParent';
  canonical_path?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
  vanity_url?: Maybe<Scalars['String']['output']>;
}

export interface LegacyReleasePlugin {
  __typename?: 'LegacyReleasePlugin';
  canonical_path?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  is_free?: Maybe<Scalars['Boolean']['output']>;
  is_native?: Maybe<Scalars['Boolean']['output']>;
  is_purchasable?: Maybe<Scalars['Boolean']['output']>;
  manufacturer?: Maybe<LegacyProvider>;
  manufacturer_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  screenshot_url?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
}

export interface LegacyReleaseRelatedSource {
  __typename?: 'LegacyReleaseRelatedSource';
  bpm?: Maybe<Scalars['Int']['output']>;
  daw?: Maybe<Scalars['String']['output']>;
  daw_version?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  is_origin?: Maybe<Scalars['Boolean']['output']>;
  plugins?: Maybe<Array<Maybe<LegacyReleasePlugin>>>;
  plugins_count?: Maybe<Scalars['Int']['output']>;
  project_uuid?: Maybe<Scalars['String']['output']>;
  release_uuid?: Maybe<Scalars['String']['output']>;
  revision_uuid?: Maybe<Scalars['String']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  samples_size?: Maybe<Scalars['Int']['output']>;
  seq_url?: Maybe<Scalars['String']['output']>;
}

export interface LegacyReleaseStem {
  __typename?: 'LegacyReleaseStem';
  api_path?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  track_id?: Maybe<Scalars['Int']['output']>;
  uuid: Scalars['String']['output'];
  waveform_url?: Maybe<Scalars['String']['output']>;
}

export interface LegacyStudioFileEncoding {
  __typename?: 'LegacyStudioFileEncoding';
  decoded_format?: Maybe<Scalars['String']['output']>;
  decoded_hash?: Maybe<Scalars['String']['output']>;
  decoded_size?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
}

export interface LegacyStudioProjectFile {
  __typename?: 'LegacyStudioProjectFile';
  encoding?: Maybe<LegacyStudioFileEncoding>;
  file_hash?: Maybe<Scalars['String']['output']>;
  file_size?: Maybe<Scalars['Int']['output']>;
  old_file_hash?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  sas_id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
}

export interface LegacyStudioProjectFileCollection {
  __typename?: 'LegacyStudioProjectFileCollection';
  misc?: Maybe<Array<Maybe<LegacyStudioProjectFile>>>;
  samples?: Maybe<Array<Maybe<LegacyStudioProjectFile>>>;
  session?: Maybe<Array<Maybe<LegacyStudioProjectFile>>>;
}

export interface LegacyStudioRevision {
  __typename?: 'LegacyStudioRevision';
  at?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['GUID']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
}

export interface LegacyStudioUser {
  __typename?: 'LegacyStudioUser';
  avatar_url?: Maybe<Scalars['URL']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
}

export interface LegacySubscriptionResponse {
  __typename?: 'LegacySubscriptionResponse';
  next?: Maybe<LegacyPlanSubscription>;
}

export interface LessonAsset extends IAsset, IAssetParent {
  __typename?: 'LessonAsset';
  activities?: Maybe<Array<Maybe<AssetActivity>>>;
  allowed_asset_type_child?: Maybe<Array<Maybe<AssetType>>>;
  asset_prices?: Maybe<Array<Maybe<Price>>>;
  asset_status_slug?: Maybe<AssetStatusSlug>;
  asset_type?: Maybe<AssetType>;
  asset_type_slug?: Maybe<AssetTypeSlug>;
  /** Eg. if an asset is rare */
  attributes?: Maybe<Array<AssetAttributeSlug>>;
  /** Eg, if asset is eligible for Presonus free bundled content */
  bundled_content_daws?: Maybe<Array<AssetBundledContentDawSlug>>;
  child_asset_counts?: Maybe<Array<Maybe<RelatedAssetsCounts>>>;
  children?: Maybe<AssetPage>;
  cost?: Maybe<Array<AssetsCost>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use devices_v2 */
  devices?: Maybe<DevicePage>;
  /** Devices associated with the Lesson */
  devices_v2?: Maybe<Array<Maybe<IDevice>>>;
  file?: Maybe<AssetFile>;
  files?: Maybe<Array<AssetFile>>;
  /** Ingestion issues associated with the asset and its children. */
  ingestion_issues?: Maybe<AssetIngestionIssues>;
  instructor_uuids?: Maybe<Array<Maybe<Scalars['GUID']['output']>>>;
  /** Instructor will be used to represent the instructors */
  instructors?: Maybe<Array<Maybe<Instructor>>>;
  legacy_permalink?: Maybe<Scalars['String']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  marketplace_status_slug?: Maybe<MarketplaceStatusSlug>;
  name?: Maybe<Scalars['String']['output']>;
  permalink_base_url?: Maybe<Scalars['String']['output']>;
  permalink_slug?: Maybe<Scalars['String']['output']>;
  playlist?: Maybe<Array<Maybe<Scalars['GUID']['output']>>>;
  playlistVideos?: Maybe<Array<Maybe<VideoAsset>>>;
  provider?: Maybe<Provider>;
  provider_sku?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['GUID']['output']>;
  similar_assets?: Maybe<AssetPage>;
  subheader?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}


export interface LessonAssetChildrenArgs {
  filter: AssetFiltersInput;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<AssetSortInput>;
}


export interface LessonAssetFileArgs {
  type?: InputMaybe<AssetFileTypeSlug>;
}


export interface LessonAssetSimilar_AssetsArgs {
  asset_type_slug: SimilarAssetTypeSlug;
  limit?: InputMaybe<Scalars['Int']['input']>;
}

export interface LicenseAssetChildrenResponse {
  __typename?: 'LicenseAssetChildrenResponse';
  assets: Array<ChildAsset>;
  count: Scalars['Int']['output'];
  creditSpends?: Maybe<Array<CreditSpend>>;
}

export enum LineItemType {
  Item = 'item',
  Plan = 'plan',
  SetupFee = 'setup_fee'
}

export interface ListPlansPage {
  __typename?: 'ListPlansPage';
  cards: Array<PlanCard>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
}

export interface LoggedInHomeContent {
  __typename?: 'LoggedInHomeContent';
  essentialCtaCardLinks?: Maybe<Array<CtaCardLink>>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  headerText: Scalars['String']['output'];
  hideHeaderSearch?: Maybe<Scalars['Boolean']['output']>;
  hideSearchTags?: Maybe<Scalars['Boolean']['output']>;
  instrumentCallout?: Maybe<SanityMediaTextBlock>;
  planGroup?: Maybe<LoggedInHomePlanGroup>;
  pluginsRailHeader?: Maybe<Scalars['String']['output']>;
  pluginsRailTextBlocks?: Maybe<Array<SanityMediaTextBlock>>;
  recommendedPresetsInfoCard?: Maybe<SanityPlainTextBlock>;
  recommendedSamplesInfoCard?: Maybe<SanityPlainTextBlock>;
  workflowCards?: Maybe<Array<WorkflowCard>>;
  workflowHeader?: Maybe<Scalars['String']['output']>;
}

export enum LoggedInHomePlanGroup {
  Daw = 'daw',
  Instrument = 'instrument',
  Registered = 'registered',
  Sounds = 'sounds',
  Splice = 'splice'
}

export interface Manufacturer {
  __typename?: 'Manufacturer';
  canonical_path?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  requires_email_confirmation?: Maybe<Scalars['Boolean']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface ManufacturerUserAccount {
  __typename?: 'ManufacturerUserAccount';
  account_id?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
}

export enum MarketplaceStatusSlug {
  Available = 'available',
  Unavailable = 'unavailable'
}

export interface MerchContentBlock {
  __typename?: 'MerchContentBlock';
  blockContentType?: Maybe<MerchContentBlockContentType>;
  contentBlockStatus?: Maybe<MerchContentBlockStatus>;
  contentItems?: Maybe<Array<Maybe<MerchContentItem>>>;
  /** @deprecated Use blockContentType */
  contentType?: Maybe<MerchContentType>;
  /** @deprecated Use contentBlockStatus */
  content_block_status?: Maybe<MerchContentBlockStatus>;
  /** @deprecated Use contentBlockStatus.slug */
  content_block_status_slug?: Maybe<MerchContentBlockStatusSlug>;
  /** @deprecated Use contentItems */
  content_items?: Maybe<Array<Maybe<MerchContentItem>>>;
  /** @deprecated Use contentType */
  content_type?: Maybe<MerchContentType>;
  /** @deprecated Use contentType.slug */
  content_type_slug?: Maybe<MerchContentTypeSlug>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use createdAt */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<MerchContentBlockDisplayType>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unpublishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use updatedAt */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}

export interface MerchContentBlockContentType {
  __typename?: 'MerchContentBlockContentType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  label: Scalars['String']['output'];
  slug: MerchContentBlockContentTypeSlug;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export enum MerchContentBlockContentTypeSlug {
  Default = 'default',
  RecommendedForYou = 'recommended_for_you',
  TrendingNearYou = 'trending_near_you'
}

/** Input values used when creating a brand new Content Block. */
export interface MerchContentBlockCreateInput {
  /** content_block_status_slug will default to unpublished */
  content_block_status_slug?: InputMaybe<MerchContentBlockStatusSlug>;
  content_type_slug: MerchContentTypeSlug;
  /** Pass content_uuids in sorted order */
  content_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  display_type_slug?: InputMaybe<MerchContentBlockDisplayTypeSlug>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  unpublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface MerchContentBlockDisplayType {
  __typename?: 'MerchContentBlockDisplayType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  label: Scalars['String']['output'];
  slug: MerchContentBlockDisplayTypeSlug;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export enum MerchContentBlockDisplayTypeSlug {
  BannerCarousel = 'banner_carousel',
  CardCarousel = 'card_carousel'
}

export interface MerchContentBlockStatus {
  __typename?: 'MerchContentBlockStatus';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use createdAt */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use slug */
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<MerchContentBlockStatusSlug>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use updatedAt */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
}

export enum MerchContentBlockStatusSlug {
  Published = 'published',
  Unpublished = 'unpublished'
}

/** Input values used when updating Content Block. */
export interface MerchContentBlockUpdateInput {
  /** content_block_status_slug will default to unpublished */
  content_block_status_slug?: InputMaybe<MerchContentBlockStatusSlug>;
  content_type_slug: MerchContentTypeSlug;
  description?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
  unpublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['GUID']['input'];
}

export interface MerchContentItem {
  __typename?: 'MerchContentItem';
  bannerImagePath?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use image field */
  bannerImageUrl?: Maybe<Scalars['String']['output']>;
  cardImagePath?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use image field */
  cardImageUrl?: Maybe<Scalars['String']['output']>;
  content?: Maybe<AnyAsset>;
  /** @deprecated Use itemContentType */
  contentType?: Maybe<MerchContentType>;
  contentUrl?: Maybe<Scalars['String']['output']>;
  contentUuid?: Maybe<Scalars['GUID']['output']>;
  /** @deprecated Use contentType */
  content_type?: Maybe<MerchContentType>;
  /** @deprecated Use contentType.slug */
  content_type_slug?: Maybe<MerchContentTypeSlug>;
  /** @deprecated Use contentUuid */
  content_uuid?: Maybe<Scalars['GUID']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use createdAt */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<SanityResponsiveImage>;
  itemContentType?: Maybe<MerchContentItemContentType>;
  /** @deprecated Use image field */
  mobileImageUrl?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  unpublishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use updatedAt */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}

export interface MerchContentItemContentType {
  __typename?: 'MerchContentItemContentType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  label: Scalars['String']['output'];
  slug: MerchContentItemContentTypeSlug;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
}

export enum MerchContentItemContentTypeSlug {
  CollectionAsset = 'collection_asset',
  FeatureUrl = 'feature_url',
  LessonAsset = 'lesson_asset',
  PackAsset = 'pack_asset',
  VideoAsset = 'video_asset'
}

/** Input values used when creating a brand new Content Item. */
export interface MerchContentItemCreateInput {
  bannerImagePath?: InputMaybe<Scalars['String']['input']>;
  cardImagePath?: InputMaybe<Scalars['String']['input']>;
  contentItemContentTypeSlug: MerchContentItemContentTypeSlug;
  contentUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * contentUuid optionally references an existing catalog asset_uuid
   * and is not needed for feature_url type content items.
   */
  contentUuid?: InputMaybe<Scalars['GUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  unpublishedAt?: InputMaybe<Scalars['DateTime']['input']>;
}

export interface MerchContentLookup {
  __typename?: 'MerchContentLookup';
  refType: MerchContentRefType;
  uuid?: Maybe<Scalars['GUID']['output']>;
}

export enum MerchContentRefType {
  Collection = 'collection',
  Lesson = 'lesson',
  Pack = 'pack',
  Tag = 'tag',
  Unspecified = 'unspecified',
  Video = 'video'
}

export interface MerchContentType {
  __typename?: 'MerchContentType';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use createdAt */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Clients do not need ID fields on enums. Use slug instead. */
  id?: Maybe<Scalars['Int']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<MerchContentTypeSlug>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use updatedAt */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
}

export enum MerchContentTypeSlug {
  LessonAsset = 'lesson_asset',
  VideoAsset = 'video_asset'
}

export interface MerchGetPagesInput {
  /** UUID of Asset, Tag, or other Content associated with a page */
  contentUuid?: InputMaybe<Scalars['String']['input']>;
  pageTypeSlug?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
}

export interface MerchPage {
  __typename?: 'MerchPage';
  contentBlocks?: Maybe<Array<Maybe<MerchContentBlock>>>;
  contentLookup?: Maybe<MerchContentLookup>;
  /** @deprecated Use contentBlocks */
  content_blocks?: Maybe<Array<Maybe<MerchContentBlock>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use createdAt */
  created_at?: Maybe<Scalars['DateTime']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  onPageCopy?: Maybe<Scalars['String']['output']>;
  pageType?: Maybe<MerchPageType>;
  seoDescription?: Maybe<Scalars['String']['output']>;
  seoTitle?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  subheading?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use updatedAt */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}

/** Input values used when updating Pages. */
export interface MerchPageCreateInput {
  /** contentUuid associates page with an asset, tag, or other piece of content (specified through PageType) */
  contentUuid?: InputMaybe<Scalars['GUID']['input']>;
  heading?: InputMaybe<Scalars['String']['input']>;
  onPageCopy?: InputMaybe<Scalars['String']['input']>;
  pageType?: InputMaybe<MerchPageType>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  subheading?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
}

export interface MerchPageDeleteInput {
  slug: Scalars['String']['input'];
}

export interface MerchPagePage {
  __typename?: 'MerchPagePage';
  items?: Maybe<Array<Maybe<MerchPage>>>;
}

export enum MerchPageType {
  Collection = 'collection',
  Genre = 'genre',
  Instrument = 'instrument',
  Lesson = 'lesson',
  Pack = 'pack',
  Unspecified = 'unspecified',
  Video = 'video'
}

export interface MerchPageUpdateInput {
  heading?: InputMaybe<Scalars['String']['input']>;
  onPageCopy?: InputMaybe<Scalars['String']['input']>;
  seoDescription?: InputMaybe<Scalars['String']['input']>;
  seoTitle?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
  subheading?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
}

export interface MidiAsset extends IAsset, IAssetChild, IDownloadableAsset {
  __typename?: 'MidiAsset';
  activities?: Maybe<Array<Maybe<AssetActivity>>>;
  asset_prices?: Maybe<Array<Maybe<Price>>>;
  asset_status_slug?: Maybe<AssetStatusSlug>;
  asset_type?: Maybe<AssetType>;
  asset_type_slug?: Maybe<AssetTypeSlug>;
  /** Eg. if an asset is rare */
  attributes?: Maybe<Array<AssetAttributeSlug>>;
  bpm?: Maybe<Scalars['Int']['output']>;
  /** Eg, if asset is eligible for Presonus free bundled content */
  bundled_content_daws?: Maybe<Array<AssetBundledContentDawSlug>>;
  catalog_uuid?: Maybe<Scalars['GUID']['output']>;
  chord_type?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  downloaded?: Maybe<Scalars['Boolean']['output']>;
  file?: Maybe<AssetFile>;
  files?: Maybe<Array<AssetFile>>;
  /** Ingestion issues associated with the asset. */
  ingestion_issues?: Maybe<AssetIngestionIssues>;
  key?: Maybe<Scalars['String']['output']>;
  legacy_permalink?: Maybe<Scalars['String']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  localInfo?: Maybe<AssetLocalInfo>;
  marketplace_status_slug?: Maybe<MarketplaceStatusSlug>;
  name?: Maybe<Scalars['String']['output']>;
  pack_parent?: Maybe<PackAsset>;
  parent_asset_counts?: Maybe<Array<Maybe<RelatedAssetsCounts>>>;
  parent_asset_uuids?: Maybe<Array<Maybe<Scalars['GUID']['output']>>>;
  parents?: Maybe<AssetPage>;
  permalink_base_url?: Maybe<Scalars['String']['output']>;
  permalink_slug?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  provider_sku?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['GUID']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}


export interface MidiAssetFileArgs {
  type?: InputMaybe<AssetFileTypeSlug>;
}


export interface MidiAssetFilesArgs {
  includeSource?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface MidiAssetParentsArgs {
  filter: AssetFiltersInput;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<AssetSortInput>;
}

export interface Mutation {
  __typename?: 'Mutation';
  /** Adds an Asset to a collection */
  addAssetToCollection?: Maybe<AddAssetToCollection>;
  asyncBulkPublish?: Maybe<PublishAssetResponse>;
  /**
   * Triggers publishing job for list of assets.
   * Check the status of the job by calling the `catalogJob` Query.
   */
  asyncPublish?: Maybe<PublishAssetResponse>;
  /**
   * Generate a MIDI file for the given beat content. Returns the file's
   * bytes base64-encoded, since GraphQL has no binary scalar.
   */
  beatToMidi: Scalars['String']['output'];
  /** Bulk adds assets to a collection */
  bulkAddAssetsToCollection?: Maybe<BulkAddAssetsToCollection>;
  /** Bulk deletes Assets with a Delete */
  bulkDeleteAssets?: Maybe<Scalars['Void']['output']>;
  /** Bulk likes assets */
  bulkLikeAssets?: Maybe<Scalars['Void']['output']>;
  /** Bulk Publish Asset with a PUT */
  bulkPublishAssets?: Maybe<BulkPublishResponse>;
  /** Bulk Updates Asset with a PUT */
  bulkUpdateAssets?: Maybe<Scalars['Void']['output']>;
  /**
   * Cancel a plugin lease, recording why. Returns the lease re-read after
   * cancellation, since the upstream call replies 204 No Content.
   */
  cancelPluginLease?: Maybe<WwwPluginLease>;
  /** Converts the subscription for the given uuid to one scheduled to cancel */
  cancelSubscription?: Maybe<PlanSubscription>;
  /** Upgrades, downgrades, or converts any existing subsciption */
  changeSubscription?: Maybe<PlanSubscription>;
  clearErrorsForAsset?: Maybe<Scalars['Void']['output']>;
  /** Converts the trial subscription for the given uuid to an active one */
  convertTrialToSubscription?: Maybe<PlanSubscription>;
  createAbletonLiveUploadJob?: Maybe<UserAudioUploadUrl>;
  /** Creates a new Asset */
  createAsset?: Maybe<AnyAsset>;
  /** Creates files like cover image or waveform for an Asset */
  createAssetFile?: Maybe<AnyAsset>;
  /**
   * Create a new Beatmaker kit (repack) with the given name. Returns the
   * newly-created kit's metadata. Samples are added via `updateBeatmakerKit`.
   */
  createBeatmakerKit?: Maybe<BeatmakerKitSet>;
  /** Creates a new Collection */
  createCollection?: Maybe<CollectionAsset>;
  /** Creates a new Device */
  createDevice?: Maybe<IDevice>;
  /** Creates a new Instructor */
  createInstructor?: Maybe<Instructor>;
  /** Saves billing information */
  createPaymentMethod?: Maybe<PaymentMethod>;
  createProToolsUploadJob?: Maybe<UserAudioUploadUrl>;
  createProofOfLicense?: Maybe<CreateProofOfLicense>;
  createStack?: Maybe<DbStack>;
  createStacksClip?: Maybe<StacksClip>;
  createStacksSession?: Maybe<StacksSession>;
  createStudioOneUploadJob?: Maybe<UserAudioUploadUrl>;
  /** Creates a new tag */
  createTag?: Maybe<Tag>;
  /** Creates a new taxonomy */
  createTaxonomy?: Maybe<Taxonomy>;
  /** Creates a UserAudioFileUploadJob and returns a signed upload url and job_uuid */
  createUserAudioUploadJob?: Maybe<UserAudioUploadUrl>;
  createUserPersonalizationProfile: UserPersonalizationProfile;
  /** Adds a payment method to the user's wallet */
  createWalletPaymentMethod?: Maybe<PaymentMethod>;
  /** Deletes an Asset with a Delete */
  deleteAsset?: Maybe<Scalars['Void']['output']>;
  /** Deletes a file like cover image or waveform for an Asset */
  deleteAssetFile?: Maybe<AnyAsset>;
  /** Deletes a Collection */
  deleteCollection?: Maybe<Scalars['Void']['output']>;
  deleteStack?: Maybe<Scalars['Void']['output']>;
  deleteStacksClip?: Maybe<Scalars['Void']['output']>;
  deleteStacksClips?: Maybe<Scalars['Void']['output']>;
  deleteStacksSession?: Maybe<Scalars['Void']['output']>;
  deleteUser?: Maybe<Scalars['Void']['output']>;
  /** Removes a payment method from the user's wallet. */
  deleteWalletPaymentMethod?: Maybe<Scalars['Void']['output']>;
  /** Downgrades to the given plan. */
  downgradeSubscription?: Maybe<PlanSubscription>;
  duplicateStack?: Maybe<DbStack>;
  /** exportStack exports the given stack e.g. as a DAW project manifest */
  exportStack?: Maybe<ExportStackResult>;
  legacyAdmin?: Maybe<LegacyAdminMutation>;
  /** License multiple assets from a pack or collection of assets */
  licenseAssetChildren?: Maybe<LicenseAssetChildrenResponse>;
  /** Likes an Asset */
  likeAsset?: Maybe<AnyAsset>;
  /** Pauses the given subscription for the given duration */
  pauseSubscription?: Maybe<PlanSubscription>;
  /**
   * Pay off the remaining balance of a plugin lease, charging the payment method
   * on file. Returns the lease re-read after the upstream 204.
   *
   * `cardExpiry` is required for card-funded leases and forbidden for PayPal;
   * each failed expiry verification spends one of five attempts per 24h.
   *
   * `paymentMethodUuid` names the wallet entry to charge. Omitted, the upstream
   * charges the payment method assigned to the lease.
   */
  payoffPluginLease?: Maybe<WwwPluginLease>;
  /** Makes a purchase of one or more products and returns an invoice */
  productCheckout: ProductCheckoutResults;
  /** Purchase an Asset */
  purchaseAsset?: Maybe<AnyAsset>;
  /**
   * Purchase a list of Assets
   *
   * Note: this is not just a plural version of purchaseAsset. This query accepts _only_
   * catalog/platform UUIDs, and returns a list of CreditSpend objects rather than assets.
   * The assets themselves are available via the CreditSpend.asset resolver if needed.
   */
  purchaseAssets?: Maybe<Array<Maybe<CreditSpend>>>;
  /**
   * Initiates the purchase of credits
   * @deprecated Use productCheckout with the credit booster's products_catalog uuid.
   */
  purchaseCredits?: Maybe<CreditsPurchaseResponse>;
  /**
   * Purchase or download an Asset and return the resulting CreditSpend directly.
   *
   * Thin wrapper over CreditLedgerService.PurchaseOrDownloadAsset. Unlike
   * purchaseAsset, this does not re-fetch the asset to hydrate the response —
   * callers that need the asset can request it via the CreditSpend.asset
   * field resolver. Skipping the re-fetch is the point: it removes ~200ms of
   * p95 latency from the download path.
   */
  purchaseOrDownloadAsset: CreditSpend;
  /**
   * Resume a cancelled or pending-cancellation plugin lease. Returns the lease
   * re-read after reactivation, since the upstream call replies 204 No Content.
   */
  reactivatePluginLease?: Maybe<WwwPluginLease>;
  /** Moves subscriptions and leases to the wallet payment method `uuid` */
  reassignWalletPaymentMethod?: Maybe<ReassignWalletPaymentMethodResult>;
  /** Removes an Asset from a collection */
  removeAssetFromCollection?: Maybe<RemoveAssetFromCollection>;
  resetPassword?: Maybe<Scalars['Void']['output']>;
  /** Resuscribe to a new plan */
  resubscribe?: Maybe<PlanSubscription>;
  /**
   * Save (create or update) a Beatmaker beat at the given uuid. Returns the
   * saved beat including its content.
   */
  saveBeatmakerBeat?: Maybe<BeatmakerBeat>;
  selectPlan: Plan;
  sendAuth0VerificationEmail?: Maybe<Scalars['Void']['output']>;
  setAssetUploadStatus?: Maybe<AssetUploadStatus>;
  shareStack?: Maybe<ShareStackResult>;
  /** Converts and downgrades the trial subscription to an active one on the given plan */
  startAndDowngradeSubscription?: Maybe<PlanSubscription>;
  /** Converts and upgrades the trial subscription to an active one on the given plan */
  startAndUpgradeSubscription?: Maybe<PlanSubscription>;
  /** Converts the trial subscription for the given uuid to an active one */
  startSubscription?: Maybe<PlanSubscription>;
  /** Starts a new subscription in trial for the given plan */
  startTrial?: Maybe<PlanSubscription>;
  studioTemplatesClone?: Maybe<V2ProjectManifest>;
  /**
   * Submits an application to the Splice Soundcheck beta program. The
   * applicant's identity (email, Splice user id, and username) is taken from
   * the caller's own session, never from the input.
   */
  submitSoundcheckApplication?: Maybe<Scalars['Void']['output']>;
  /** Starts a new subscription in trial for the given plan */
  subscribe?: Maybe<PlanSubscription>;
  /** Subscribe To Collection */
  subscribeToCollection?: Maybe<CollectionAsset>;
  /** Switches a sounds plan to a splice plan */
  switchToSplicePlan?: Maybe<PlanSubscription>;
  sync?: Maybe<TaxonomySync>;
  /**
   * Updates a Splice User with a connected Discord account to have a role that matches
   * their plan state.
   */
  syncDiscordRoleWithSubscription?: Maybe<SyncDiscordRoleWithSubscriptionResult>;
  /**
   * Uncancels a currently canceled or cancellation-scheduled subscription for the
   * given uuid and subscribes to a new lower plan.
   */
  uncancelAndDowngradeSubscription?: Maybe<PlanSubscription>;
  /**
   * Uncancels a currently canceled or cancellation-scheduled subscription for the
   * given uuid and subscribes to a new higher plan.
   */
  uncancelAndUpgradeSubscription?: Maybe<PlanSubscription>;
  /**
   * Uncancels a currently canceled or cancellation-scheduled subscription for the
   * given uuid and returns an active one
   */
  uncancelSubscription?: Maybe<PlanSubscription>;
  /** Unlikes an Asset */
  unlikeAsset?: Maybe<AnyAsset>;
  /**
   * Unlinks a Discord Account from a Splice User UUID and removes all plan-related roles from the previously
   * linked Discord Account
   */
  unlinkDiscordUser?: Maybe<Scalars['Void']['output']>;
  /**
   * Unpauses a currently paused or pause-scheduled subscription and returns an
   * active one
   */
  unpauseSubscription?: Maybe<PlanSubscription>;
  /** Unsubscribe From Collection */
  unsubscribeFromCollection?: Maybe<CollectionAsset>;
  /** Updates an Asset with a Put */
  updateAsset?: Maybe<UpdateAssetResponse>;
  /** Updates Activity Status with a Post */
  updateAssetActivityStatus?: Maybe<Scalars['Void']['output']>;
  updateAssetStatus?: Maybe<PublishResponse>;
  /**
   * Replace the samples of a Beatmaker kit with the given list of sample
   * file hashes (positionally — the array index is the pad position).
   */
  updateBeatmakerKit?: Maybe<Scalars['Boolean']['output']>;
  /** Updates a Collection */
  updateCollection?: Maybe<CollectionAsset>;
  updateStack?: Maybe<DbStack>;
  updateStacksClip?: Maybe<StacksClip>;
  updateStacksSession?: Maybe<StacksSession>;
  /** Updates an existing taxonomy */
  updateTag?: Maybe<Tag>;
  updateUser?: Maybe<User>;
  updateUserPersonalizationProfile: UserPersonalizationProfile;
  /**
   * Updates name, billing address, label, or default flag on a wallet payment
   * method
   */
  updateWalletPaymentMethod?: Maybe<PaymentMethod>;
  /** Upgrades to the given plan. */
  upgradeSubscription?: Maybe<PlanSubscription>;
  /** Uploads an Asset with a Post */
  uploadAsset?: Maybe<Scalars['Void']['output']>;
  v2ProjectCollaboratorsDelete?: Maybe<Scalars['Void']['output']>;
  v2ProjectCollaboratorsPost?: Maybe<Scalars['Void']['output']>;
  v2ProjectDelete?: Maybe<Scalars['Void']['output']>;
  v2ProjectRevisionPatch?: Maybe<Scalars['Void']['output']>;
  wwwDevicesLinkPost?: Maybe<Scalars['Void']['output']>;
  wwwLicenseFreePlugin?: Maybe<Scalars['Void']['output']>;
  wwwLikePack?: Maybe<WwwPack>;
  wwwMeFollowingDelete?: Maybe<Scalars['Void']['output']>;
  wwwMeFollowingPost?: Maybe<Scalars['Void']['output']>;
  wwwReleasesLikesDelete?: Maybe<Scalars['Void']['output']>;
  wwwReleasesLikesPost?: Maybe<Scalars['Void']['output']>;
  wwwReleasesPlaysPost?: Maybe<Scalars['Void']['output']>;
  wwwUnLikePack?: Maybe<WwwPack>;
}


export interface MutationAddAssetToCollectionArgs {
  assetUuid: Scalars['GUID']['input'];
  collectionUuid: Scalars['GUID']['input'];
  legacy?: InputMaybe<AssetLegacyInput>;
}


export interface MutationAsyncBulkPublishArgs {
  filters: BulkAssetUpdateFilters;
}


export interface MutationAsyncPublishArgs {
  uuid: Scalars['GUID']['input'];
}


export interface MutationBeatToMidiArgs {
  beat: BeatmakerBeatContentInput;
}


export interface MutationBulkAddAssetsToCollectionArgs {
  assets: BulkAssetActionInput;
  collectionUuid: Scalars['GUID']['input'];
  legacy?: InputMaybe<AssetLegacyInput>;
}


export interface MutationBulkDeleteAssetsArgs {
  filters: BulkAssetUpdateFilters;
}


export interface MutationBulkLikeAssetsArgs {
  assets?: InputMaybe<BulkAssetActionInput>;
  legacy?: InputMaybe<AssetLegacyInput>;
}


export interface MutationBulkPublishAssetsArgs {
  asset_status_slug: AssetStatusSlug;
  filters: BulkAssetUpdateFilters;
}


export interface MutationBulkUpdateAssetsArgs {
  changes: BulkAssetUpdateInput;
  filters: BulkAssetUpdateFilters;
}


export interface MutationCancelPluginLeaseArgs {
  cancellationReason: PluginLeaseCancelReasonInput;
  uuid: Scalars['String']['input'];
}


export interface MutationCancelSubscriptionArgs {
  cancelReasons?: InputMaybe<PlanSubscriptionCancelReasonInput>;
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationChangeSubscriptionArgs {
  action: SubscriptionAction;
  planUUID?: InputMaybe<Scalars['ID']['input']>;
  promoCode?: InputMaybe<Scalars['String']['input']>;
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationClearErrorsForAssetArgs {
  assetUuid: Scalars['GUID']['input'];
  errorLevel: AssetErrorLevel;
}


export interface MutationConvertTrialToSubscriptionArgs {
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationCreateAbletonLiveUploadJobArgs {
  bpm?: InputMaybe<Scalars['Int']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  fileName: Scalars['String']['input'];
}


export interface MutationCreateAssetArgs {
  asset: AssetCreateInput;
  legacy?: InputMaybe<AssetLegacyInput>;
}


export interface MutationCreateAssetFileArgs {
  file: Scalars['Upload']['input'];
  slug: Scalars['String']['input'];
  uuid: Scalars['GUID']['input'];
}


export interface MutationCreateBeatmakerKitArgs {
  name: Scalars['String']['input'];
}


export interface MutationCreateCollectionArgs {
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
}


export interface MutationCreateDeviceArgs {
  device_type_slug?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationCreateInstructorArgs {
  name?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationCreatePaymentMethodArgs {
  three_d_secure_action_result_token_id?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
}


export interface MutationCreateProToolsUploadJobArgs {
  bpm?: InputMaybe<Scalars['Int']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  fileName: Scalars['String']['input'];
}


export interface MutationCreateProofOfLicenseArgs {
  artistName: Scalars['String']['input'];
  assetUuids: Array<Scalars['String']['input']>;
  fullLegalName: Scalars['String']['input'];
}


export interface MutationCreateStackArgs {
  source?: InputMaybe<DbStackSourceInput>;
  stack: StackInput;
}


export interface MutationCreateStacksClipArgs {
  clip: StacksClipInput;
}


export interface MutationCreateStacksSessionArgs {
  session: StacksSessionInput;
}


export interface MutationCreateStudioOneUploadJobArgs {
  bpm?: InputMaybe<Scalars['Int']['input']>;
  durationMs?: InputMaybe<Scalars['Int']['input']>;
  fileName: Scalars['String']['input'];
}


export interface MutationCreateTagArgs {
  tag: TagInput;
}


export interface MutationCreateTaxonomyArgs {
  taxonomy: TaxonomyCreateInput;
}


export interface MutationCreateUserAudioUploadJobArgs {
  bpm?: InputMaybe<Scalars['Int']['input']>;
  fileName: Scalars['String']['input'];
  source?: InputMaybe<UserAudioFileSource>;
}


export interface MutationCreateUserPersonalizationProfileArgs {
  input: UpdateUserPersonalizationProfileInput;
}


export interface MutationCreateWalletPaymentMethodArgs {
  input: CreateWalletPaymentMethodInput;
}


export interface MutationDeleteAssetArgs {
  asset: Scalars['GUID']['input'];
  legacy?: InputMaybe<AssetLegacyInput>;
}


export interface MutationDeleteAssetFileArgs {
  asset_file_uuid?: InputMaybe<Scalars['GUID']['input']>;
  uuid?: InputMaybe<Scalars['GUID']['input']>;
}


export interface MutationDeleteCollectionArgs {
  uuid: Scalars['GUID']['input'];
}


export interface MutationDeleteStackArgs {
  uuid: Scalars['GUID']['input'];
}


export interface MutationDeleteStacksClipArgs {
  uuid: Scalars['GUID']['input'];
}


export interface MutationDeleteStacksClipsArgs {
  uuids: Array<Scalars['GUID']['input']>;
}


export interface MutationDeleteStacksSessionArgs {
  uuid: Scalars['GUID']['input'];
}


export interface MutationDeleteWalletPaymentMethodArgs {
  uuid: Scalars['ID']['input'];
}


export interface MutationDowngradeSubscriptionArgs {
  planUUID: Scalars['ID']['input'];
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationDuplicateStackArgs {
  newStackName?: InputMaybe<Scalars['String']['input']>;
  stackUuid: Scalars['GUID']['input'];
}


export interface MutationExportStackArgs {
  exportTypeSlug?: InputMaybe<Scalars['String']['input']>;
  stackUuid: Scalars['GUID']['input'];
}


export interface MutationLicenseAssetChildrenArgs {
  children_types: Array<AssetTypeSlug>;
  parent_type: AssetTypeSlug;
  uuid: Scalars['GUID']['input'];
}


export interface MutationLikeAssetArgs {
  legacy?: InputMaybe<AssetLegacyInput>;
  uuid: Scalars['GUID']['input'];
}


export interface MutationPauseSubscriptionArgs {
  pauseDuration?: InputMaybe<Scalars['Int']['input']>;
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationPayoffPluginLeaseArgs {
  cardExpiry?: InputMaybe<LeasePayoffCardExpiryInput>;
  paymentMethodUuid?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['String']['input'];
}


export interface MutationProductCheckoutArgs {
  checkoutProducts?: InputMaybe<Array<ProductCheckoutInput>>;
  currency?: InputMaybe<Currency>;
  paymentMethodUuid?: InputMaybe<Scalars['ID']['input']>;
  three_d_secure_action_result_token_id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationPurchaseAssetArgs {
  legacy?: InputMaybe<AssetLegacyInput>;
  uuid: Scalars['GUID']['input'];
}


export interface MutationPurchaseAssetsArgs {
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  uuids: Array<Scalars['GUID']['input']>;
}


export interface MutationPurchaseCreditsArgs {
  creditsNeeded?: InputMaybe<Scalars['Int']['input']>;
  packUUID: Scalars['GUID']['input'];
}


export interface MutationPurchaseOrDownloadAssetArgs {
  uuid: Scalars['GUID']['input'];
}


export interface MutationReactivatePluginLeaseArgs {
  uuid: Scalars['String']['input'];
}


export interface MutationReassignWalletPaymentMethodArgs {
  input: ReassignWalletPaymentMethodInput;
  uuid: Scalars['ID']['input'];
}


export interface MutationRemoveAssetFromCollectionArgs {
  assetUuid: Scalars['GUID']['input'];
  collectionUuid: Scalars['GUID']['input'];
  legacy?: InputMaybe<AssetLegacyInput>;
}


export interface MutationResetPasswordArgs {
  email: Scalars['String']['input'];
}


export interface MutationResubscribeArgs {
  planUUID: Scalars['ID']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationSaveBeatmakerBeatArgs {
  beat: BeatmakerBeatContentInput;
  uuid: Scalars['String']['input'];
}


export interface MutationSelectPlanArgs {
  display_name?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['GUID']['input']>;
}


export interface MutationSetAssetUploadStatusArgs {
  assetJobState: AssetJobState;
  assetUuid: Scalars['GUID']['input'];
  jobUuid?: InputMaybe<Scalars['GUID']['input']>;
}


export interface MutationShareStackArgs {
  input: ShareStackInput;
}


export interface MutationStartAndDowngradeSubscriptionArgs {
  planUUID: Scalars['ID']['input'];
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationStartAndUpgradeSubscriptionArgs {
  planUUID: Scalars['ID']['input'];
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationStartSubscriptionArgs {
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationStartTrialArgs {
  planUUID: Scalars['ID']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationStudioTemplatesCloneArgs {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
}


export interface MutationSubmitSoundcheckApplicationArgs {
  input: SoundcheckApplicationInput;
}


export interface MutationSubscribeArgs {
  planUUID: Scalars['ID']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
}


export interface MutationSubscribeToCollectionArgs {
  permalink: Scalars['String']['input'];
  uuid: Scalars['GUID']['input'];
}


export interface MutationSwitchToSplicePlanArgs {
  planUUID: Scalars['ID']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationSyncArgs {
  version: Scalars['Int']['input'];
}


export interface MutationSyncDiscordRoleWithSubscriptionArgs {
  userUUID: Scalars['GUID']['input'];
}


export interface MutationUncancelAndDowngradeSubscriptionArgs {
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationUncancelAndUpgradeSubscriptionArgs {
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationUncancelSubscriptionArgs {
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationUnlikeAssetArgs {
  legacy?: InputMaybe<AssetLegacyInput>;
  uuid: Scalars['GUID']['input'];
}


export interface MutationUnlinkDiscordUserArgs {
  userUUID: Scalars['GUID']['input'];
}


export interface MutationUnpauseSubscriptionArgs {
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationUnsubscribeFromCollectionArgs {
  permalink: Scalars['String']['input'];
  uuid: Scalars['GUID']['input'];
}


export interface MutationUpdateAssetArgs {
  asset: AssetUpdateInput;
  legacy?: InputMaybe<AssetLegacyInput>;
}


export interface MutationUpdateAssetActivityStatusArgs {
  legacy?: InputMaybe<AssetLegacyInput>;
  status: ActivityTypeSlug;
  uuid: Scalars['GUID']['input'];
}


export interface MutationUpdateAssetStatusArgs {
  status: AssetStatusSlug;
  uuid: Scalars['GUID']['input'];
}


export interface MutationUpdateBeatmakerKitArgs {
  sampleHashes: Array<Scalars['String']['input']>;
  uuid: Scalars['GUID']['input'];
}


export interface MutationUpdateCollectionArgs {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['String']['input'];
}


export interface MutationUpdateStackArgs {
  latestVersion: Scalars['Int']['input'];
  stack: StackInput;
  uuid: Scalars['GUID']['input'];
}


export interface MutationUpdateStacksClipArgs {
  input: StacksClipUpdateInput;
}


export interface MutationUpdateStacksSessionArgs {
  session: StacksSessionInput;
}


export interface MutationUpdateTagArgs {
  tag: TagInput;
}


export interface MutationUpdateUserArgs {
  user: UserUpdateInput;
}


export interface MutationUpdateUserPersonalizationProfileArgs {
  input: UpdateUserPersonalizationProfileInput;
}


export interface MutationUpdateWalletPaymentMethodArgs {
  input: UpdateWalletPaymentMethodInput;
  uuid: Scalars['ID']['input'];
}


export interface MutationUpgradeSubscriptionArgs {
  planUUID: Scalars['ID']['input'];
  promoCode?: InputMaybe<Scalars['String']['input']>;
  subscriptionUUID: Scalars['ID']['input'];
}


export interface MutationUploadAssetArgs {
  asset: AssetUploadInput;
}


export interface MutationV2ProjectCollaboratorsDeleteArgs {
  username: Scalars['String']['input'];
  uuid: Scalars['GUID']['input'];
}


export interface MutationV2ProjectCollaboratorsPostArgs {
  username: Scalars['String']['input'];
  uuid: Scalars['GUID']['input'];
}


export interface MutationV2ProjectDeleteArgs {
  uuid: Scalars['GUID']['input'];
}


export interface MutationV2ProjectRevisionPatchArgs {
  description: Scalars['String']['input'];
  revId: Scalars['GUID']['input'];
  starred?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['GUID']['input'];
}


export interface MutationWwwDevicesLinkPostArgs {
  short_code: Scalars['String']['input'];
}


export interface MutationWwwLicenseFreePluginArgs {
  id: Scalars['Int']['input'];
}


export interface MutationWwwLikePackArgs {
  permalink?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationWwwMeFollowingDeleteArgs {
  id: Scalars['Int']['input'];
}


export interface MutationWwwMeFollowingPostArgs {
  captcha_token?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['Int']['input'];
}


export interface MutationWwwReleasesLikesDeleteArgs {
  uuid?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationWwwReleasesLikesPostArgs {
  captcha_token?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationWwwReleasesPlaysPostArgs {
  uuid?: InputMaybe<Scalars['ID']['input']>;
}


export interface MutationWwwUnLikePackArgs {
  permalink?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
}

export interface NavFeaturedGear {
  __typename?: 'NavFeaturedGear';
  ctaText: Scalars['String']['output'];
  gear: SanityGear;
  header?: Maybe<Scalars['String']['output']>;
}

export interface NavGearSidebar {
  __typename?: 'NavGearSidebar';
  ctaLink: Scalars['String']['output'];
  ctaText: Scalars['String']['output'];
  gears: Array<SanityGear>;
  header: Scalars['String']['output'];
}

export interface NewStackInput {
  customStackTemplate?: InputMaybe<CosoCustomStackTemplateInput>;
  estimateKey?: InputMaybe<Scalars['Boolean']['input']>;
  harmonicMode?: InputMaybe<Scalars['Boolean']['input']>;
  harmonicModeAudioKey?: InputMaybe<Scalars['String']['input']>;
  harmonicModeChordType?: InputMaybe<Scalars['String']['input']>;
  harmonicModeFirstLayerWeight?: InputMaybe<Scalars['Float']['input']>;
  harmonicModeOffset?: InputMaybe<Scalars['Int']['input']>;
  harmonicModePersistWeight?: InputMaybe<Scalars['Float']['input']>;
  harmonicModeVersion?: InputMaybe<Scalars['String']['input']>;
  numLayers?: InputMaybe<Scalars['Int']['input']>;
  randomize?: InputMaybe<Scalars['Boolean']['input']>;
  randomizeDefaultLayerOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** below are experimental parameters */
  randomizeTopHitOffsetMax?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<CosoSeedInput>;
  stackBpm?: InputMaybe<Scalars['Int']['input']>;
  stackTemplate?: InputMaybe<Scalars['String']['input']>;
}

export interface NewStackLayerV2Result {
  __typename?: 'NewStackLayerV2Result';
  /**
   * Populated when queryString was provided and resolved successfully. Clients
   * should cache and pass this back via customLayerFilter on subsequent
   * newStackLayerV2/swapStackLayerV2 calls to skip the prompt pipeline.
   */
  customLayerFilter?: Maybe<CosoLayerFilter>;
  layers?: Maybe<Array<Maybe<StackLayer>>>;
  stackKey?: Maybe<StackKey>;
}

export interface NewStackWithPromptResult {
  __typename?: 'NewStackWithPromptResult';
  prompt?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Stack>;
  template?: Maybe<CosoCustomStackTemplate>;
}

export interface PackAsset extends IAsset, IAssetParent, ILegacyAsset {
  __typename?: 'PackAsset';
  activities?: Maybe<Array<Maybe<AssetActivity>>>;
  allowed_asset_type_child?: Maybe<Array<Maybe<AssetType>>>;
  asset_prices?: Maybe<Array<Maybe<Price>>>;
  asset_status_slug?: Maybe<AssetStatusSlug>;
  asset_type?: Maybe<AssetType>;
  asset_type_slug?: Maybe<AssetTypeSlug>;
  /** Eg. if an asset is rare */
  attributes?: Maybe<Array<AssetAttributeSlug>>;
  /** Eg, if asset is eligible for Presonus free bundled content */
  bundled_content_daws?: Maybe<Array<AssetBundledContentDawSlug>>;
  catalog_uuid?: Maybe<Scalars['GUID']['output']>;
  child_asset_counts?: Maybe<Array<Maybe<RelatedAssetsCounts>>>;
  children?: Maybe<AssetPage>;
  companion_packs?: Maybe<Array<PackAsset>>;
  cost?: Maybe<Array<AssetsCost>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  current_global_chart_pos?: Maybe<Scalars['Int']['output']>;
  current_label_chart_pos?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file?: Maybe<AssetFile>;
  files?: Maybe<Array<AssetFile>>;
  /** Ingestion issues associated with the asset and its children. */
  ingestion_issues?: Maybe<AssetIngestionIssues>;
  last_global_chart_pos?: Maybe<Scalars['Int']['output']>;
  last_label_chart_pos?: Maybe<Scalars['Int']['output']>;
  legacy_permalink?: Maybe<Scalars['String']['output']>;
  legacy_uuid?: Maybe<Scalars['GUID']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  main_genre?: Maybe<Scalars['String']['output']>;
  main_tag_permalink?: Maybe<Scalars['String']['output']>;
  marketplace_status_slug?: Maybe<MarketplaceStatusSlug>;
  name?: Maybe<Scalars['String']['output']>;
  permalink_base_url?: Maybe<Scalars['String']['output']>;
  permalink_slug?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  provider_sku?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['GUID']['output']>;
  story?: Maybe<PackAssetStory>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}


export interface PackAssetChildrenArgs {
  filter: AssetFiltersInput;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<AssetSortInput>;
}


export interface PackAssetFileArgs {
  type?: InputMaybe<AssetFileTypeSlug>;
}

export interface PackAssetStory {
  __typename?: 'PackAssetStory';
  background_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
  videos?: Maybe<Array<PackAssetStoryVideo>>;
}

export interface PackAssetStoryVideo {
  __typename?: 'PackAssetStoryVideo';
  background_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface PackInput {
  name?: InputMaybe<Scalars['String']['input']>;
  permalink?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
}

export interface PackSearchParams {
  likes?: InputMaybe<Scalars['Boolean']['input']>;
  packsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
  providerPermalink?: InputMaybe<Scalars['String']['input']>;
  requiresPresets?: InputMaybe<Scalars['Boolean']['input']>;
  requiresSamples?: InputMaybe<Scalars['Boolean']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
  withSamples?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface PackSearchResponse {
  __typename?: 'PackSearchResponse';
  filtered_count: Scalars['Int']['output'];
  packs?: Maybe<Array<Maybe<LegacyPack2>>>;
  total_count: Scalars['Int']['output'];
}

export interface PackStory {
  __typename?: 'PackStory';
  background_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
  videos?: Maybe<Array<Maybe<PackStoryVideo>>>;
}

export interface PackStoryInput {
  background_url?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
}

export interface PackStoryVideo {
  __typename?: 'PackStoryVideo';
  background_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
}

export interface PackStoryVideoInput {
  background_url?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['ID']['input']>;
}

export interface PaginatedContentBlocks {
  __typename?: 'PaginatedContentBlocks';
  contentBlocks: Array<MerchContentBlock>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalResults: Scalars['Int']['output'];
}

export interface PaginatedContentItems {
  __typename?: 'PaginatedContentItems';
  contentBlockUuid: Scalars['GUID']['output'];
  contentItems: Array<MerchContentItem>;
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
  totalResults: Scalars['Int']['output'];
}

export interface Pagination {
  __typename?: 'Pagination';
  current_page: Scalars['Int']['output'];
  from?: Maybe<Scalars['Int']['output']>;
  last_page: Scalars['Int']['output'];
  per_page: Scalars['Int']['output'];
  to?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
}

/** Pagination metadata response. */
export interface PaginationMetadata {
  __typename?: 'PaginationMetadata';
  /** Current Page */
  currentPage?: Maybe<Scalars['Int']['output']>;
  /** Total Number of Pages */
  totalPages?: Maybe<Scalars['Int']['output']>;
}

export type ParentAsset = CollectionAsset | LessonAsset | PackAsset;

export interface PartialCheckoutFailure {
  __typename?: 'PartialCheckoutFailure';
  message: Scalars['String']['output'];
  product_catalog_uuid: Scalars['ID']['output'];
}

export interface PaymentMethod {
  __typename?: 'PaymentMethod';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  /**
   * What this payment method is currently paying for. Null when the assignments
   * cannot be read; an empty list means the method is unassigned.
   */
  assignments?: Maybe<Array<PaymentMethodAssignment>>;
  brand?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  isTaxable?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uuid: Scalars['ID']['output'];
}

export interface PaymentMethodAddress {
  __typename?: 'PaymentMethodAddress';
  address_country: Scalars['String']['output'];
  address_zip: Scalars['String']['output'];
}

export interface PaymentMethodAssignment {
  __typename?: 'PaymentMethodAssignment';
  /**
   * The assigned subscription or lease, or null when the reference cannot be
   * hydrated — the wallet can still report an assignment whose subscription or
   * lease is no longer returned by its own service.
   */
  detail?: Maybe<PaymentMethodAssignmentDetail>;
  type: PaymentMethodAssignmentType;
  uuid: Scalars['ID']['output'];
}

export type PaymentMethodAssignmentDetail = PlanSubscription | WwwPluginLease;

export enum PaymentMethodAssignmentType {
  PluginLease = 'plugin_lease',
  SoundsSubscription = 'sounds_subscription'
}

export interface Permission {
  __typename?: 'Permission';
  flag?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<Scalars['String']['output']>>;
  grantActions?: Maybe<Array<GrantAction>>;
  name: Scalars['String']['output'];
  value: Scalars['Boolean']['output'];
}

export interface PermissionsResponse {
  __typename?: 'PermissionsResponse';
  permissions?: Maybe<Array<Permission>>;
}

/**
 * Pitch class profile stored by Casa for a catalog sample: extractor version
 * and twelve chromatic weights from C through B.
 */
export interface PitchClassProfile {
  __typename?: 'PitchClassProfile';
  /** 12 chromatic weights C through B, each in [0, 1] */
  values: Array<Scalars['Float']['output']>;
  /** Extractor/feature version, e.g. 1.0.0 */
  version: Scalars['String']['output'];
}

export interface Plan {
  __typename?: 'Plan';
  billing_frequency?: Maybe<BillingFrequencySlug>;
  code?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use monthly_credits */
  credits?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use plan_details.description */
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use plan_details.plan_features instead */
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated Use plan_details.features_title */
  features_title?: Maybe<Scalars['String']['output']>;
  group?: Maybe<PlanGroup>;
  monthly_credits?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plan_details?: Maybe<PlanDetails>;
  /** @deprecated Use plan_details.plan_features instead */
  plan_features?: Maybe<Array<PlanFeature>>;
  plan_select_table_values?: Maybe<Array<Maybe<PlanSelectTableValues>>>;
  price?: Maybe<PlanPrices>;
  pricing_model?: Maybe<Scalars['String']['output']>;
  promo_codes?: Maybe<Array<Maybe<PromoCode>>>;
  ramp_discount?: Maybe<Scalars['Int']['output']>;
  ramp_duration?: Maybe<Scalars['Int']['output']>;
  ramp_price?: Maybe<PlanPrices>;
  show_disclaimer?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use plan_details.thumbnail_url */
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  tier?: Maybe<Scalars['Int']['output']>;
  trial_length_days?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
}


export interface PlanPromo_CodesArgs {
  campaign?: InputMaybe<Scalars['String']['input']>;
}

export interface PlanCard {
  __typename?: 'PlanCard';
  afterSubscribeUrl?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<PlanCardFeatureItem>>;
  includesInstrument?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated never needed this */
  planDisplayName?: Maybe<Scalars['String']['output']>;
  productName: Scalars['String']['output'];
}

export interface PlanCardFeatureItem {
  __typename?: 'PlanCardFeatureItem';
  badges?: Maybe<Array<Scalars['String']['output']>>;
  included?: Maybe<Scalars['Boolean']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
}

export interface PlanDetails {
  __typename?: 'PlanDetails';
  description?: Maybe<Scalars['String']['output']>;
  experiment?: Maybe<Scalars['String']['output']>;
  features_title?: Maybe<Scalars['String']['output']>;
  plan_features?: Maybe<Array<PlanFeature>>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
}

export interface PlanFeature {
  __typename?: 'PlanFeature';
  flags?: Maybe<Array<Scalars['String']['output']>>;
  text: Scalars['String']['output'];
}

export interface PlanGroup {
  __typename?: 'PlanGroup';
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  exclusions?: Maybe<Array<Maybe<PlanGroupSlug>>>;
  name?: Maybe<PlanGroupSlug>;
}

export enum PlanGroupSlug {
  Daw = 'daw',
  Gear = 'gear',
  Instrument = 'instrument',
  Sounds = 'sounds',
  Splice = 'splice'
}

export interface PlanPrices {
  __typename?: 'PlanPrices';
  usd?: Maybe<Scalars['Int']['output']>;
}

/**
 * Plan Select encaspulates marketing details for plans.
 * Focusing on presentation of features without regard to subscription management or processing.
 */
export interface PlanSelectTableHeader {
  __typename?: 'PlanSelectTableHeader';
  header?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
}

export interface PlanSelectTableValues {
  __typename?: 'PlanSelectTableValues';
  info?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
}

export interface PlanSubscription {
  __typename?: 'PlanSubscription';
  account_type?: Maybe<Scalars['String']['output']>;
  account_uuid?: Maybe<Scalars['String']['output']>;
  credits?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['String']['output']>;
  next?: Maybe<LegacyPlanSubscription>;
  payment_method?: Maybe<PaymentMethod>;
  payment_method_uuid?: Maybe<Scalars['ID']['output']>;
  plan?: Maybe<Plan>;
  plan_uuid: Scalars['ID']['output'];
  product_plan?: Maybe<ProductPlan>;
  resume_at?: Maybe<Scalars['String']['output']>;
  state: SubscriptionState;
  trial_converted_at?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['ID']['output'];
}

export interface PlanSubscriptionCancelReasonInput {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  user_text?: InputMaybe<Scalars['String']['input']>;
}

export interface PlansAllPlansInclude {
  __typename?: 'PlansAllPlansInclude';
  heading?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<PlansAllPlansIncludeItem>>;
}

export interface PlansAllPlansIncludeItem {
  __typename?: 'PlansAllPlansIncludeItem';
  text?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
}

export interface PlansBillingToggle {
  __typename?: 'PlansBillingToggle';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  savingsLabel?: Maybe<Scalars['String']['output']>;
}

export interface PlansCardFeature {
  __typename?: 'PlansCardFeature';
  badges?: Maybe<Array<Scalars['String']['output']>>;
  /** The feature the plan is sold on; its bullet takes the accent colour. */
  highlighted?: Maybe<Scalars['Boolean']['output']>;
  /** Optional design-system icon name overriding the default bullet icon. */
  icon?: Maybe<Scalars['String']['output']>;
  included?: Maybe<Scalars['Boolean']['output']>;
  /** Portable text; planField tokens have their resolvedPlan injected by the resolver. */
  text?: Maybe<Scalars['JSON']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
}

export interface PlansCardSectionModule {
  __typename?: 'PlansCardSectionModule';
  allPlansInclude?: Maybe<PlansAllPlansInclude>;
  billingToggle?: Maybe<PlansBillingToggle>;
  cards?: Maybe<Array<RichPlanCard>>;
  heading?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<Scalars['JSON']['output']>;
}

export interface PlansCtaBannerModule {
  __typename?: 'PlansCtaBannerModule';
  cta?: Maybe<SanityCtaContent>;
  heading?: Maybe<Scalars['String']['output']>;
  reassurances?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<Scalars['JSON']['output']>;
}

export interface PlansHeroModule {
  __typename?: 'PlansHeroModule';
  backgroundImage?: Maybe<SanityImage>;
  heading?: Maybe<Scalars['String']['output']>;
  principles?: Maybe<Array<PlansPrinciple>>;
  rotation?: Maybe<Array<Scalars['String']['output']>>;
  subHeading?: Maybe<Scalars['JSON']['output']>;
}

export interface PlansLabelStripModule {
  __typename?: 'PlansLabelStripModule';
  heading?: Maybe<Scalars['String']['output']>;
}

export type PlansModule = PlansCardSectionModule | PlansCtaBannerModule | PlansHeroModule | PlansLabelStripModule | PlansTestimonialsModule | PlansValuePropsModule | SanityList;

/**
 * Content for the redesigned, re-orderable logged-out /plans page. Modules are
 * authored as standalone Sanity documents referenced (and sortable) from a
 * plansPage container, then returned here in editor order as a PlansModule union.
 */
export interface PlansPageContent {
  __typename?: 'PlansPageContent';
  modules: Array<PlansModule>;
  seoContent?: Maybe<PlansPageSeoContent>;
}

export interface PlansPageCopy {
  __typename?: 'PlansPageCopy';
  CTA: Scalars['String']['output'];
  higherCTA: Scalars['String']['output'];
  lowerCTA: Scalars['String']['output'];
  subtitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface PlansPageFlagEvaluation {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export interface PlansPageSeoContent {
  __typename?: 'PlansPageSeoContent';
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  noindex?: Maybe<Scalars['Boolean']['output']>;
  ogImage?: Maybe<SanityImage>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface PlansPrinciple {
  __typename?: 'PlansPrinciple';
  description?: Maybe<Scalars['String']['output']>;
  /** Design-system icon name. */
  icon?: Maybe<Scalars['String']['output']>;
  muted?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface PlansResponse {
  __typename?: 'PlansResponse';
  disclaimer?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<Plan>>;
  plan_select_table_headers?: Maybe<Array<Maybe<PlanSelectTableHeader>>>;
}

export interface PlansTestimonialItem {
  __typename?: 'PlansTestimonialItem';
  attribution?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<SanityImage>;
  quote?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['JSON']['output']>;
}

export interface PlansTestimonialsModule {
  __typename?: 'PlansTestimonialsModule';
  heading?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<PlansTestimonialItem>>;
  subHeading?: Maybe<Scalars['JSON']['output']>;
}

export interface PlansValueProp {
  __typename?: 'PlansValueProp';
  description?: Maybe<Scalars['JSON']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<SanityImage>;
}

export interface PlansValuePropsModule {
  __typename?: 'PlansValuePropsModule';
  featuredImage?: Maybe<SanityImage>;
  heading?: Maybe<Scalars['String']['output']>;
  props?: Maybe<Array<PlansValueProp>>;
  subHeading?: Maybe<Scalars['JSON']['output']>;
}

export enum Platform {
  Linux = 'Linux',
  Windows = 'Windows',
  MacOs = 'macOS'
}

export interface PluginCheckoutInfo {
  __typename?: 'PluginCheckoutInfo';
  authentication_url?: Maybe<Scalars['String']['output']>;
  manufacturer_name?: Maybe<Scalars['String']['output']>;
  manufacturer_url?: Maybe<Scalars['String']['output']>;
  marketing_opt_in: Scalars['Boolean']['output'];
  plugin_id?: Maybe<Scalars['Int']['output']>;
  plugin_seller_code?: Maybe<Scalars['String']['output']>;
  requires_authentication: Scalars['Boolean']['output'];
  requires_email_confirmation: Scalars['Boolean']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
}

export interface PluginDescription {
  background_url: Scalars['String']['output'];
  canonical_url: Scalars['String']['output'];
  description: Scalars['String']['output'];
  hide: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  is_free: Scalars['Boolean']['output'];
  manufacturer: Manufacturer;
  name: Scalars['String']['output'];
  prerelease?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  purchase_type?: Maybe<PurchaseType>;
  retail_url?: Maybe<Scalars['String']['output']>;
  screenshot_url: Scalars['String']['output'];
  seller_code: Scalars['String']['output'];
  tag_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail_url: Scalars['String']['output'];
  types: Array<Scalars['String']['output']>;
  uuid: Scalars['String']['output'];
}

export interface PluginDevice extends IDevice {
  __typename?: 'PluginDevice';
  asset?: Maybe<AnyAsset>;
  device_type_slug?: Maybe<DeviceTypeSlug>;
  minimum_device_version?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  plugin_type?: Maybe<PluginType>;
  uuid?: Maybe<Scalars['GUID']['output']>;
  versions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

/**
 * A bonus product bundled with a leased plugin's installer. `url` is deliberately
 * absent: the upstream links are short-lived, so the download is proxied per
 * request rather than handed to the client with the licenses list.
 */
export interface PluginExtra {
  __typename?: 'PluginExtra';
  name: Scalars['String']['output'];
  platform: PluginLeaseInstallerPlatform;
}

export interface PluginInfo {
  __typename?: 'PluginInfo';
  id?: Maybe<Scalars['Int']['output']>;
  manufacturer?: Maybe<Manufacturer>;
  name?: Maybe<Scalars['String']['output']>;
  seller_code?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
}

/**
 * Post-checkout install/onboarding details for a leasable plugin, keyed by
 * seller code. Combines plugin catalog data with the authenticated user's lease
 * so the install page renders in a single query.
 */
export interface PluginInstallInfo {
  __typename?: 'PluginInstallInfo';
  authentication_url?: Maybe<Scalars['String']['output']>;
  display_name: Scalars['String']['output'];
  is_daw: Scalars['Boolean']['output'];
  lease?: Maybe<PluginInstallLease>;
  manufacturer_name?: Maybe<Scalars['String']['output']>;
  manufacturer_url?: Maybe<Scalars['String']['output']>;
  plugin_id?: Maybe<Scalars['Int']['output']>;
  plugin_seller_code: Scalars['String']['output'];
  requires_authentication: Scalars['Boolean']['output'];
  requires_email_confirmation: Scalars['Boolean']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
}

/** The authenticated user's lease for a plugin, as needed by the install page. */
export interface PluginInstallLease {
  __typename?: 'PluginInstallLease';
  next_payment_date?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
}

export interface PluginInstaller {
  __typename?: 'PluginInstaller';
  instructions: Scalars['String']['output'];
  platform: PluginInstallerPlatform;
  url?: Maybe<Scalars['String']['output']>;
  /**
   * Present on installers from the inline `/www/me/plugin_licenses` array
   * (Type-1 licenses). Installers backfilled from the `/www/plugin_installers`
   * fallback (Type-2 licenses) carry no uuid, so this is null there.
   */
  uuid?: Maybe<Scalars['String']['output']>;
}

export enum PluginInstallerPlatform {
  Mac = 'mac',
  Osx = 'osx',
  Win = 'win'
}

/**
 * Cancellation reason payload for a plugin lease. Distinct from
 * `PlanSubscriptionCancelReasonInput`: the gear endpoint also records which
 * option the user picked.
 */
export interface PluginLeaseCancelReasonInput {
  /** `id` of the chosen CancellationReason. */
  cancellation_option_id: Scalars['Int']['input'];
  category_id: Scalars['Int']['input'];
  user_text?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Platform vocabulary used by `GET /www/plugin_leases/{uuid}/installer`. This
 * endpoint predates `PluginInstallerPlatform` and does not share its values.
 */
export enum PluginLeaseInstallerPlatform {
  Osx = 'osx',
  Windows = 'windows'
}

/**
 * Priced preview of paying off a plugin lease early. Upstream takes no lock and
 * charges nothing, so the backing query is safe to retry.
 */
export interface PluginLeasePayoffPreview {
  __typename?: 'PluginLeasePayoffPreview';
  currency: Scalars['String']['output'];
  /** Remaining balance before tax (installments left × installment price). */
  subtotal_in_cents: Scalars['Int']['output'];
  /** Zero for leases on legacy non-taxable gear plans. */
  tax_in_cents: Scalars['Int']['output'];
  tax_rate?: Maybe<Scalars['Float']['output']>;
  tax_region?: Maybe<Scalars['String']['output']>;
  tax_type?: Maybe<Scalars['String']['output']>;
  /** Subtotal plus tax — the amount the payoff charges. */
  total_amount_in_cents: Scalars['Int']['output'];
}

export interface PluginLicense {
  __typename?: 'PluginLicense';
  canonical_path?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['String']['output'];
  description: Scalars['String']['output'];
  drm: Scalars['String']['output'];
  extras?: Maybe<Array<PluginExtra>>;
  id: Scalars['Int']['output'];
  installers?: Maybe<Array<Maybe<PluginInstaller>>>;
  is_free?: Maybe<Scalars['Boolean']['output']>;
  license_uuid: Scalars['String']['output'];
  manufacturer_id?: Maybe<Scalars['Int']['output']>;
  manufacturer_name: Scalars['String']['output'];
  name: Scalars['String']['output'];
  plugin_lease_uuid: Scalars['String']['output'];
  purchase_uuid: Scalars['String']['output'];
  purchased_at: Scalars['String']['output'];
  serial: Scalars['String']['output'];
  thumbnail_url: Scalars['String']['output'];
}

/**
 * Platform a plugin installer can target. Mirrors the `platform` query-param
 * accepted by `GET /v3/plugins/{id}/installer`.
 */
export enum PluginPlatform {
  Darwin = 'darwin',
  Windows = 'windows'
}

export enum PluginType {
  Aax = 'AAX',
  Au = 'AU',
  Fl = 'FL',
  Max = 'MAX',
  Vst = 'VST',
  Vst3 = 'VST3'
}

export interface PresetAsset extends IAsset, IAssetChild, IDownloadableAsset, ILegacyAsset, IPreset, IReportableAsset {
  __typename?: 'PresetAsset';
  activities?: Maybe<Array<Maybe<AssetActivity>>>;
  asset_devices?: Maybe<Array<Maybe<AssetDevice>>>;
  asset_prices?: Maybe<Array<Maybe<Price>>>;
  asset_status_slug?: Maybe<AssetStatusSlug>;
  asset_type?: Maybe<AssetType>;
  asset_type_slug?: Maybe<AssetTypeSlug>;
  /** Eg. if an asset is rare */
  attributes?: Maybe<Array<AssetAttributeSlug>>;
  /** Eg, if asset is eligible for Presonus free bundled content */
  bundled_content_daws?: Maybe<Array<AssetBundledContentDawSlug>>;
  catalog_uuid?: Maybe<Scalars['GUID']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  device?: Maybe<PluginDevice>;
  downloaded?: Maybe<Scalars['Boolean']['output']>;
  file?: Maybe<AssetFile>;
  files?: Maybe<Array<AssetFile>>;
  /** Ingestion issues associated with the asset. */
  ingestion_issues?: Maybe<AssetIngestionIssues>;
  legacy_permalink?: Maybe<Scalars['String']['output']>;
  legacy_uuid?: Maybe<Scalars['GUID']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  localInfo?: Maybe<AssetLocalInfo>;
  marketplace_status_slug?: Maybe<MarketplaceStatusSlug>;
  name?: Maybe<Scalars['String']['output']>;
  pack_parent?: Maybe<PackAsset>;
  parent_asset_counts?: Maybe<Array<Maybe<RelatedAssetsCounts>>>;
  parent_asset_uuids?: Maybe<Array<Maybe<Scalars['GUID']['output']>>>;
  parents?: Maybe<AssetPage>;
  permalink_base_url?: Maybe<Scalars['String']['output']>;
  permalink_slug?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  provider_sku?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['GUID']['output']>;
  reported?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}


export interface PresetAssetFileArgs {
  type?: InputMaybe<AssetFileTypeSlug>;
}


export interface PresetAssetFilesArgs {
  includeSource?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface PresetAssetParentsArgs {
  filter: AssetFiltersInput;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<AssetSortInput>;
}

/**
 * A reference to a preset's compatible Plugin
 * FIXME: There is likely a more verbose "Plugin" type that should be used instead.
 */
export interface PresetPluginReference {
  __typename?: 'PresetPluginReference';
  name?: Maybe<Scalars['String']['output']>;
  plugin?: Maybe<PluginDevice>;
  uuid: Scalars['GUID']['output'];
}

/** FIXME: This looks like it's wrong. I believe this should be more like AssetFileType */
export enum PreviewType {
  Audio = 'AUDIO',
  BannerImage = 'BANNER_IMAGE',
  CoverImage = 'COVER_IMAGE',
  Video = 'VIDEO'
}

export interface PreviewWarning {
  __typename?: 'PreviewWarning';
  message: Scalars['String']['output'];
  type: PreviewWarningType;
}

export enum PreviewWarningType {
  InvalidCurrency = 'INVALID_CURRENCY',
  InvalidPromoCode = 'INVALID_PROMO_CODE'
}

export interface Price {
  __typename?: 'Price';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Currency>;
}

export interface PricingFlagEvaluation {
  key?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
}

export enum PricingModel {
  Fixed = 'fixed',
  Ramp = 'ramp'
}

export interface ProductCheckoutInput {
  marketing_opt_in?: InputMaybe<Scalars['Boolean']['input']>;
  product_catalog_uuid: Scalars['ID']['input'];
  promo_code?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
}

export interface ProductCheckoutPreview {
  __typename?: 'ProductCheckoutPreview';
  action: SubscriptionAction;
  due_next?: Maybe<ProductInvoice>;
  due_now: ProductInvoice;
  warnings?: Maybe<Array<PreviewWarning>>;
}

export interface ProductCheckoutResults {
  __typename?: 'ProductCheckoutResults';
  invoice: ProductInvoice;
  partialFailures?: Maybe<Array<PartialCheckoutFailure>>;
  /** @deprecated Use subscriptions instead. This field returns the first subscription for backward compatibility. */
  subscription?: Maybe<CheckoutPlanSubscription>;
  subscriptions?: Maybe<Array<CheckoutPlanSubscription>>;
}

export interface ProductDisplayName {
  __typename?: 'ProductDisplayName';
  displayName: Scalars['String']['output'];
  productNameSlug: Scalars['String']['output'];
}

export interface ProductInvoice {
  __typename?: 'ProductInvoice';
  /** @deprecated Use proration_amount instead */
  credited?: Maybe<Scalars['Int']['output']>;
  currency: Currency;
  discounts?: Maybe<Array<Discount>>;
  due_at: Scalars['String']['output'];
  full_price: Scalars['Int']['output'];
  invoice_total?: Maybe<Scalars['Int']['output']>;
  line_items: Array<ProductItemPreview>;
  proration_amount?: Maybe<Scalars['Int']['output']>;
  subtotal: Scalars['Int']['output'];
  tax?: Maybe<ProductTaxPreview>;
  total: Scalars['Int']['output'];
}

export interface ProductItemPreview {
  __typename?: 'ProductItemPreview';
  full_price: Scalars['Int']['output'];
  item_type: LineItemType;
  name: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  subtotal: Scalars['Int']['output'];
  tax?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  unit_price: Scalars['Int']['output'];
  uuid: Scalars['ID']['output'];
}

export interface ProductPlan extends IProduct {
  __typename?: 'ProductPlan';
  actions: Array<SubscriptionAction>;
  billing_frequency: BillingFrequencySlug;
  currency?: Maybe<Currency>;
  current: Scalars['Boolean']['output'];
  display_name: Scalars['String']['output'];
  full_price: Scalars['Int']['output'];
  monthly_credits?: Maybe<Scalars['Int']['output']>;
  next: Scalars['Boolean']['output'];
  plan_uuid: Scalars['ID']['output'];
  product_group: PlanGroupSlug;
  product_name: Scalars['String']['output'];
  ramp_duration?: Maybe<Scalars['Int']['output']>;
  ramp_price?: Maybe<Scalars['Int']['output']>;
  thumbnail_url: Scalars['String']['output'];
  trial_length_days?: Maybe<Scalars['Int']['output']>;
  type: ProductType;
  uuid: Scalars['ID']['output'];
}

export interface ProductPlanCard {
  __typename?: 'ProductPlanCard';
  afterSubscribeUrl?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<PlanCardFeatureItem>>;
  includesInstrument?: Maybe<Scalars['Boolean']['output']>;
  plan: ProductPlan;
}

export interface ProductRtoPlugin extends IProduct {
  __typename?: 'ProductRtoPlugin';
  actions: Array<SubscriptionAction>;
  billing_frequency: BillingFrequencySlug;
  currency?: Maybe<Currency>;
  display_name: Scalars['String']['output'];
  full_price: Scalars['Int']['output'];
  installment_price: Scalars['Int']['output'];
  plan_uuid: Scalars['ID']['output'];
  plugin_info?: Maybe<PluginCheckoutInfo>;
  product_group: PlanGroupSlug;
  product_name: Scalars['String']['output'];
  total_installments: Scalars['Int']['output'];
  trial_length_days?: Maybe<Scalars['Int']['output']>;
  type: ProductType;
  uuid: Scalars['ID']['output'];
}

export interface ProductTaxPreview {
  __typename?: 'ProductTaxPreview';
  amount?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Scalars['Float']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
}

export enum ProductType {
  CreditBooster = 'credit_booster',
  Credits = 'credits',
  InstrumentPresetPack = 'instrument_preset_pack',
  Item = 'item',
  Plan = 'plan',
  Plans = 'plans',
  RtoPlugin = 'rto_plugin',
  SetupFee = 'setup_fee'
}

export interface PromoCode {
  __typename?: 'PromoCode';
  campaign?: Maybe<Scalars['String']['output']>;
  coupon_code?: Maybe<Scalars['String']['output']>;
  coupon_type?: Maybe<CouponType>;
  description?: Maybe<Scalars['String']['output']>;
  plan_code?: Maybe<Scalars['String']['output']>;
}

export interface ProofOfLicense {
  __typename?: 'ProofOfLicense';
  artistName: Scalars['String']['output'];
  assetUuids: Array<Scalars['String']['output']>;
  fullLegalName: Scalars['String']['output'];
  licenseIssued: Scalars['String']['output'];
  userUuid: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
}

export interface Provider {
  __typename?: 'Provider';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  current_provider_chart_position?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  external_service?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  image_path?: Maybe<Scalars['String']['output']>;
  last_provider_chart_position?: Maybe<Scalars['Int']['output']>;
  legacy_uuid?: Maybe<Scalars['GUID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pack_count?: Maybe<Scalars['Int']['output']>;
  permalink_slug?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Scalars['String']['output']>;
  tags_array?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  twitter_url?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['GUID']['output'];
  visible?: Maybe<Scalars['Boolean']['output']>;
}


export interface ProviderPack_CountArgs {
  include_unpublished?: InputMaybe<Scalars['Boolean']['input']>;
}

/** Paged set of Providers */
export interface ProviderPage {
  __typename?: 'ProviderPage';
  /** Subset of Providers */
  items?: Maybe<Array<Maybe<Provider>>>;
}

export interface PublishAssetResponse {
  __typename?: 'PublishAssetResponse';
  job_uuid?: Maybe<Scalars['GUID']['output']>;
}

export interface PublishError {
  __typename?: 'PublishError';
  asset_name: Scalars['String']['output'];
  asset_type: AssetTypeSlug;
  asset_uuid: Scalars['GUID']['output'];
  error: Scalars['String']['output'];
}

export interface PublishResponse {
  __typename?: 'PublishResponse';
  errors: Array<Maybe<PublishError>>;
  requested_status: AssetRequestedStatus;
  result: AssetPublishResult;
}

export enum PublishState {
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED'
}

export enum PurchasableType {
  Plans = 'plans',
  RtoPlugin = 'rto_plugin'
}

export enum PurchaseType {
  Free = 'free',
  IncludedOnlyInBundle = 'included_only_in_bundle',
  OffsitePurchase = 'offsite_purchase',
  OneTimePurchase = 'one_time_purchase',
  RentToOwn = 'rent_to_own',
  RentToOwnUpgrade = 'rent_to_own_upgrade'
}

/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface Query {
  __typename?: 'Query';
  /** A single Asset by ID, called from admin tooling contexts */
  adminAsset?: Maybe<AnyAsset>;
  /** A single Asset by ID */
  asset?: Maybe<AnyAsset>;
  /** An array of asset category enums in the system. */
  assetCategories?: Maybe<Array<Maybe<AssetCategory>>>;
  /** An array of asset file type enums in the system. */
  assetFileTypes?: Maybe<Array<Maybe<AssetFileType>>>;
  /** A list of files for each of the given assets */
  assetFiles?: Maybe<Array<Maybe<AssetFilesList>>>;
  /** An array of asset status type enums in the system. */
  assetStatuses?: Maybe<Array<Maybe<AssetStatus>>>;
  /** Gets asset type summaries from the search service, optionally filtered by tags */
  assetTypeSummaries: Array<AssetTypeSummary>;
  /** An array of asset type enums in the system. */
  assetTypes?: Maybe<Array<Maybe<AssetType>>>;
  /** Gets status for uploaded Asset */
  assetUploadStatus?: Maybe<AssetUploadStatus>;
  /**
   * A page of Assets matching the given inputs.
   * @deprecated Use assetsSearch instead
   */
  assets?: Maybe<AssetPage>;
  assetsSearch?: Maybe<AssetPage>;
  /**
   * Collection of all available credit packs for the user
   * @deprecated Use listCreditBoosters. Credit booster purchases now go through productCheckout.
   */
  availableCreditPacks?: Maybe<AvailableCreditPacks>;
  /** Batch assets by uuid */
  batchAsset?: Maybe<Array<Maybe<AnyAsset>>>;
  /**
   * Fetch a saved Beatmaker beat by uuid. Resolves the beat metadata and the
   * underlying serialized beat content in a single call.
   */
  beatmakerBeat?: Maybe<BeatmakerBeat>;
  /**
   * Fetch a legacy Collection's (repack's) own samples by uuid, for the
   * beatmaker's Collections browser. Same file_hash-keyed sample shape as
   * `beatmakerSampleAssetsByFileHash`. Optionally filter to one instrument-type
   * tag slug (e.g. "kicks").
   */
  beatmakerCollectionSamples: Array<SampleAsset>;
  /**
   * List the current user's legacy Collections (repacks) — the same
   * file_hash-keyed "custom packs" the legacy Angular beatmaker's Collections
   * browser lists, distinct from the newer catalog CollectionAsset search
   * index. Beatmaker kits are excluded by the underlying legacy endpoint.
   */
  beatmakerCollections: Array<CollectionAsset>;
  /** Fetch a Beatmaker kit (repack) by uuid, including its samples. */
  beatmakerKit?: Maybe<BeatmakerKit>;
  /**
   * Resolve legacy Beatmaker sample file hashes to their catalog SampleAsset
   * representation (liked/licensed status, tags, pack info). Used to hydrate a
   * saved beat's pads with library data at load time. Hashes that don't
   * resolve to a sample are omitted from the result, not null-padded.
   */
  beatmakerSampleAssetsByFileHash: Array<SampleAsset>;
  /** List beats shared by the current user. */
  beatmakerSharedBeats: Array<BeatmakerSharedBeat>;
  /**
   * Selectable cancellation reasons for a product category (`gear`, `sounds`,
   * `splice-plans`), ordered with "Other" last.
   */
  cancellationReasons: Array<CancellationReason>;
  /** Get current status and error for a async job */
  catalogJob?: Maybe<CatalogJobResponse>;
  categoryPageContent?: Maybe<CategoryPageContent>;
  checkoutAction: Array<SubscriptionAction>;
  /** A page of Assets that are completed */
  completedAssets?: Maybe<AssetPage>;
  /**
   * The list of content groups for the browse section, with entries transformed
   * into canonical PackAsset and CollectionAsset
   */
  contentGroupsTransformed?: Maybe<Array<Maybe<TransformedContentGroup>>>;
  /**
   * The list of content groups for the browse section, with entries transformed
   * into canonical PackAsset and CollectionAsset, and with associated metadata.
   */
  contentGroupsTransformedWithMetadata?: Maybe<TransformedContentGroupsWithMetadata>;
  conversionInfo?: Maybe<ConversionInfo>;
  cosoTypeMetadata?: Maybe<CosoTypeMetadata>;
  /** Get a cost estimate to purchase the given assets */
  costEstimate?: Maybe<CostEstimate>;
  createProofOfLicense?: Maybe<CreateProofOfLicense>;
  creditBalance?: Maybe<Scalars['Int']['output']>;
  curatedCollection?: Maybe<CuratedCollection>;
  customStackTemplateFromPrompt?: Maybe<CustomStackTemplateFromPromptResult>;
  /** A single Device by ID */
  device?: Maybe<IDevice>;
  /** All Devices in the Splice catalog */
  devices?: Maybe<DevicePage>;
  /** Disclaimer text associated with all plans */
  disclaimerForPlans?: Maybe<Scalars['String']['output']>;
  /** Gets the Discord username for a user with a connected Discord account */
  discordUsername?: Maybe<Scalars['String']['output']>;
  discoverSectionWithItems?: Maybe<DiscoverSectionWithItems>;
  estimateStackKey?: Maybe<EstimateStackKeyResult>;
  /** Returns an array of all featured plan content rows for a plan group. */
  featuredPlanContent?: Maybe<Array<Maybe<FeaturedPlanContentItem>>>;
  /** Returns an array of all featured plan terms items for a plan group. */
  featuredPlanTerms?: Maybe<Array<Maybe<FeaturedPlanTermsItem>>>;
  gear?: Maybe<Gear>;
  /**
   * Signed installer URL for a specific plugin + platform. Must remain a
   * separate request from `gearPlugins`; the signed URL has a short TTL and
   * cannot share a cache window with the plugin list.
   */
  gearPluginInstaller: GearPluginInstaller;
  /** Plugins the authenticated user has access to. */
  gearPlugins: GearPlugins;
  getPromoCodeDetails?: Maybe<CheckoutPromoCode>;
  helloWorld?: Maybe<Scalars['String']['output']>;
  /** Returns the first 5 blog posts in the "tips-tutorials" category */
  homeBlogPosts: Array<BlogPost>;
  /**
   * Creates a new Stack layer from the provided 36-character asset (catalog) UUID.
   *
   * Use this query when you need to initialize a Stack layer based on an asset
   * but lack sufficient data to fully define the layer.
   *
   * The resulting Stack layer will include the complete structure needed for
   * rendering, saving, and playback.
   */
  initializeStackLayer?: Maybe<StackLayer>;
  /** A single Instructor by ID */
  instructor?: Maybe<Instructor>;
  /** All Instructors in the Splice catalog */
  instructors?: Maybe<InstructorPage>;
  instrumentLabels: Array<LabelContentItem>;
  instrumentPack?: Maybe<InstrumentPack>;
  instrumentPacks?: Maybe<InstrumentPacksWithPagination>;
  instrumentPacksByIds: Array<InstrumentPack>;
  /** Returns the Intercom user_hash for the current user. */
  intercomUser?: Maybe<IntercomUser>;
  /** @deprecated Replaced with leasableGearByCategory */
  leasableGear?: Maybe<Array<Maybe<Gear>>>;
  leasableGearByCategory?: Maybe<Array<Maybe<Gear>>>;
  legacyAdmin?: Maybe<LegacyAdminQuery>;
  legacyCollectionByPermalink: CollectionAsset;
  legacyPacksChart: Array<PackAsset>;
  /**
   * Queries legacy releases by username, buy plugin ID, or by generalized search.
   * This is currently backed by multiple purpose-built endpoints, which makes
   * inputs to this field mutually exclusive in some cases.
   */
  legacyReleases: Array<LegacyRelease>;
  /**
   * Returns the available credit boosters for purchase via productCheckout.
   * Replaces the legacy availableCreditPacks query.
   */
  listCreditBoosters?: Maybe<Array<CreditBooster>>;
  loggedInSoundsHomeStartup: Array<MerchContentBlock>;
  /** Gets the email and account_id if a user has an associated account with a manufacturer */
  manufacturerUserAccount?: Maybe<ManufacturerUserAccount>;
  merchContentBlock?: Maybe<MerchContentBlock>;
  merchContentBlockStatuses?: Maybe<Array<Maybe<MerchContentBlockStatus>>>;
  merchContentBlocks?: Maybe<Array<Maybe<MerchContentBlock>>>;
  merchContentBlocksPaginated: PaginatedContentBlocks;
  merchContentItemContentTypes?: Maybe<Array<Maybe<MerchContentItemContentType>>>;
  merchContentItemsPaginated: PaginatedContentItems;
  merchContentTypes?: Maybe<Array<Maybe<MerchContentType>>>;
  merchPage?: Maybe<MerchPage>;
  merchPages?: Maybe<MerchPagePage>;
  /**
   * Retrieve Partially hydrated asset models for cases where the fully hydrated model is not expected
   * to be necessary. We will depend on type resolvers to hydrate any fields that are necessary after retrieval.
   */
  minimalAssets?: Maybe<Array<AnyAsset>>;
  myStackSnapshots?: Maybe<StackSnapshotsPayload>;
  /** @deprecated use myStacksPaged */
  myStacks?: Maybe<Array<DbStack>>;
  myStacksClips?: Maybe<StacksClipsPayload>;
  myStacksPaged?: Maybe<StacksPayload>;
  myStacksSessions?: Maybe<StacksSessionsPayload>;
  newStack?: Maybe<Stack>;
  newStackLayer?: Maybe<Array<Maybe<StackLayer>>>;
  /**
   * V2 endpoints, since V1 returns only [StackLayer] and we want to return additional data
   * such as stackKey
   */
  newStackLayerV2?: Maybe<NewStackLayerV2Result>;
  /** Generate a new stack from a text prompt */
  newStackWithPrompt?: Maybe<NewStackWithPromptResult>;
  /** A pack by permalink */
  packAsset?: Maybe<PackAsset>;
  paymentMethod?: Maybe<PaymentMethod>;
  /** Return all permissions for the client */
  permissions: PermissionsResponse;
  /** A single subscription Plan by ID */
  plan?: Maybe<Plan>;
  /** Returns a list of card data by plan name and by page */
  planCards?: Maybe<Array<PlanCard>>;
  /** Marketing material for plan select. */
  planSelectTableHeaders?: Maybe<Array<Maybe<PlanSelectTableHeader>>>;
  /** Collection of all subscription Plan objects in the system */
  plans?: Maybe<Array<Plan>>;
  /** Returns a object with copy for a plan group and a user's current subscription state. */
  plansPageCopy?: Maybe<PlansPageCopy>;
  /**
   * Returns post-checkout install/onboarding details for a leasable plugin,
   * keyed by seller code. Backs the web-svelte /plugins/install/:sellerCode page.
   */
  pluginInstallInfo?: Maybe<PluginInstallInfo>;
  /**
   * Priced preview of paying off a plugin lease. Null when unauthenticated or
   * when upstream pricing fails, rather than erroring the whole query.
   *
   * `paymentMethodUuid` names the wallet entry the payoff will charge, so the
   * estimated tax comes from that entry's address. The upstream requires it
   * whenever the wallet flag is on.
   */
  pluginLeasePayoffPreview?: Maybe<PluginLeasePayoffPreview>;
  /** Returns a product by product uuid */
  product: AnyProduct;
  /**
   * Returns eligible bundle offers for this product. Each offer's bundled products are
   * eagerly resolved; the query errors if any product cannot be loaded.
   */
  productBundleOffers: Array<BundleOffer>;
  /** Returns a product by purchasable uuid (aka plan uuid) */
  productByPurchasableId: AnyProduct;
  /** Returns full checkout preview with line items and taxes */
  productCheckoutPreview: ProductCheckoutPreview;
  /** Lookup product display name from product slug */
  productNames?: Maybe<Array<ProductDisplayName>>;
  /** Returns a list of product plan cards by product names, billing models, plan groups, and page */
  productPlanCards: Array<ProductPlanCard>;
  /** Returns a list of plans by plan name and billing model */
  productPlans?: Maybe<Array<ProductPlan>>;
  /**
   * Returns an array of all promo codes in our system.
   * In the future, these will return from an API but they are currently hard-coded.
   */
  promoCodes?: Maybe<Array<Maybe<PromoCode>>>;
  /** A single Provider */
  provider?: Maybe<Provider>;
  /** A single Provider retrieved via legacy uuid. */
  providerByLegacyUUID?: Maybe<Provider>;
  /** A page of Providers matching the given inputs. */
  providers?: Maybe<ProviderPage>;
  /** recommendedPacks is a list of packs returned by the Recommendations Service based on the user's purchase history or survey responses */
  recommendedPacks?: Maybe<Array<Maybe<PackAsset>>>;
  recommendedPacksWithSource?: Maybe<RecommendedPacksWithSourceResponse>;
  sanityBannerContent?: Maybe<SanityBannerContent>;
  sanityEditorialCarousel?: Maybe<Array<EditorialSlideContent>>;
  sanityFeaturedPlugin?: Maybe<SanityFeaturedPlugin>;
  /** Returns the content for a given type from sanity.io. */
  sanityHomeContent?: Maybe<SanityHomeContent>;
  sanityHomeSampleLibrary?: Maybe<SanitySampleBrandPositioningContent>;
  sanityLegalPage?: Maybe<SanityLegalPage>;
  sanityList?: Maybe<SanityList>;
  /** Return marketing data needed for the logged-in home page */
  sanityLoggedInHomeContent?: Maybe<LoggedInHomeContent>;
  sanityMarketingHero?: Maybe<SanityMarketingHero>;
  sanityMediaTextBlocks: Array<SanityMediaTextBlock>;
  sanityNavContent?: Maybe<SanityNavContent>;
  sanityPlansAboveTheFoldContent?: Maybe<SanityPlansAboveTheFoldContent>;
  /**
   * Returns the re-orderable plans page content for a given URL path.
   * `variant` selects a query-param variation of the page; omit for the default.
   */
  sanityPlansPage?: Maybe<PlansPageContent>;
  /** Deprecated: Remove when FE uses sanitySoundsPageContent */
  sanityPromoSectionContent?: Maybe<SanityPromoSectionContent>;
  sanitySoundsPageContent?: Maybe<SanitySoundsPageContent>;
  sanityValuePropsSectionContent?: Maybe<SanityValuePropsSectionContent>;
  /** The currently active or selected Plan for the user. */
  selectedPlan?: Maybe<Plan>;
  /** Retrieve list of collections with their permalinks owned or liked by the user for hydrating the sounds sidebar */
  sidebarCollectionLinks?: Maybe<Array<SidebarCollectionLink>>;
  /** Gets signed url to upload to S3 */
  signedUrl?: Maybe<SignedUrl>;
  /**
   * An array of similar sounds samples from the legacy API or Catalog.
   * `limit` caps the result set (default 10, max 100). `offset` skips leading
   * results. Both are forwarded to the shapes CatalogAPI, which requests
   * `offset + limit` neighbors from the search service and returns the
   * `[offset, offset + limit)` window.
   */
  similarSounds?: Maybe<Array<Maybe<SampleAsset>>>;
  /**
   * Returns the current viewer's Soundcheck registration status. A viewer with
   * no registration at all is NOT_APPLIED.
   */
  soundcheckApplicationStatus: SoundcheckApplicationStatus;
  /** Returns a list of beta programs */
  soundcheckBetaPrograms: Array<SoundcheckBetaProgram>;
  /**
   * Look up a Splice Sounds client (DAW-hosted plugin or the Sounds app)
   * by `name` and operating system. Returns `null` if no build exists for
   * the requested combination.
   */
  soundsClient?: Maybe<SoundsClient>;
  /** Gets autocomplete suggestions from the search service */
  soundsSearchSuggestions: SoundsSearchSuggestionsResponse;
  stack?: Maybe<DbStack>;
  stackSnapshot?: Maybe<StackSnapshot>;
  stacksClip?: Maybe<StacksClip>;
  stacksSession?: Maybe<StacksSession>;
  stacksTypeMetadata?: Maybe<StacksTypeMetadata>;
  subscription?: Maybe<PlanSubscription>;
  swapStackLayer?: Maybe<Array<Maybe<StackLayer>>>;
  swapStackLayerV2?: Maybe<SwapStackLayerV2Result>;
  syncDiff?: Maybe<TaxonomySyncDiff>;
  /** Gets a Tag by ID. */
  tag?: Maybe<Tag>;
  /** Look up a `TagCategoryList` by `permalink_string` or `uuid` */
  tagCategoryList?: Maybe<TagCategoryList>;
  /** Get all available `TagCategoryList`s */
  tagCategoryLists: Array<TagCategoryList>;
  /**
   * Pass a `tagId` (tag slug) to retrieve information about which Product Category it belongs to and it's permalink url.
   * Product Categories are hardcoded in the category-route-list mock for Genres, Instruments, Cinematic FX, and Presets.
   * The default category if not listed there is `Tags`.
   */
  tagPageMetadata?: Maybe<TagPageMetadata>;
  /** Search for a Tag regardless of Taxonomy */
  tags?: Maybe<TagPage>;
  /** Paged collection of all Taxonomy objects in the system. */
  taxonomies?: Maybe<TaxonomyPage>;
  /** A single Taxonomy by ID. */
  taxonomy?: Maybe<Taxonomy>;
  /** The currently logged-in User */
  user?: Maybe<User>;
  userAudioFile?: Maybe<UserAudioFile>;
  userAudioFiles?: Maybe<UserAudioFilesPayload>;
  userAudioStorageData?: Maybe<UserAudioStorageData>;
  userAudioUploadJob: UserAudioUploadJob;
  userPersonalizationProfile?: Maybe<UserPersonalizationProfile>;
  /** The list of collaborators on a project. */
  v2ProjectCollaborators?: Maybe<Array<Maybe<LegacyStudioUser>>>;
  /** Full details of a project. */
  v2ProjectManifest?: Maybe<V2ProjectManifest>;
  /** Paginated list of projects for the logged in user. */
  v2Projects?: Maybe<Array<Maybe<V2Project>>>;
  /** Look up a user by uuid or email. */
  v2UserLookup?: Maybe<V2User>;
  /** User search by username. */
  v2UserSearch?: Maybe<Array<Maybe<LegacyStudioUser>>>;
  /** One wallet payment method by uuid */
  walletPaymentMethod?: Maybe<PaymentMethod>;
  walletPaymentMethods?: Maybe<Array<PaymentMethod>>;
  /** The list of content groups for the browse section. */
  wwwContentGroups?: Maybe<Array<Maybe<ContentGroup>>>;
  wwwEssentialPlugins: Array<WwwPlugin>;
  wwwGenre?: Maybe<WwwGenre>;
  wwwLeaseUpgrade?: Maybe<LeaseUpgrade>;
  wwwMeReleasesLiked?: Maybe<WwwMeReleasesLiked>;
  /** The list of MIDI content groups for the browse section. */
  wwwMidiContentGroups?: Maybe<Array<Maybe<ContentGroup>>>;
  /** Returns a plugin with or without a gearPlan */
  wwwPlugin?: Maybe<WwwPlugin>;
  /**
   * Signed download URL for one installer of a licence the caller owns. Short
   * lived, so request it per download attempt rather than with the licences list.
   */
  wwwPluginInstallerUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Signed download URL for a leased plugin's bonus product on one platform.
   * Short lived, as above.
   */
  wwwPluginLeaseExtraUrl?: Maybe<Scalars['String']['output']>;
  /** Returns a Plugin that is used for displaying a user's current leases */
  wwwPluginLeases?: Maybe<Array<Maybe<WwwPluginLease>>>;
  /** Signed download URL for a licence's DRM licence file. Short lived, as above. */
  wwwPluginLicenseFileUrl?: Maybe<Scalars['String']['output']>;
  wwwPluginLicenses: Array<Maybe<PluginLicense>>;
  /**
   * Returns a plugin manufacturer with one page of its plugins. The id accepts
   * either the manufacturer slug or its numeric id, matching the REST endpoint.
   */
  wwwPluginManufacturer?: Maybe<WwwPluginManufacturer>;
  /** Returns a paginated list of Plugins filtered by the provided arguments */
  wwwPlugins: Array<WwwPlugin>;
  /** Returns an ordered list of Top Plugins to display in the chart */
  wwwPluginsChart: Array<WwwPlugin>;
  /** Returns data used to populate a plugins hero banner */
  wwwPluginsHero: FeaturedPlugin;
  /** Returns a paginated, filterable list of Plugins with total hit count and matching tags */
  wwwPluginsSearch: WwwPluginsSearchResult;
  /** Returns a Plugin that is used for advertising */
  wwwPluginsShow?: Maybe<WwwPluginAdvertisement>;
  /** A list of providers (labels) in legacy format, optionally filtered by sort types and per-page limits. */
  wwwPremiumProviders: Array<Provider>;
  /** A Collection (Repack (Set)) as provided by the public legacy API. */
  wwwSoundsCustomPack?: Maybe<WwwSoundsCustomPack>;
  /** A pack as provided by the public packs legacy API. */
  wwwSoundsPack?: Maybe<WwwSoundsPack>;
  /** Packs matching the given input parameter filters */
  wwwSoundsPacks?: Maybe<WwwSoundsPacks>;
  /** A list of recently released packs, optionally filtered by provider. */
  wwwSoundsRecentPacks: Array<PackAsset>;
  wwwUser?: Maybe<WwwUser>;
  wwwUserTransactions?: Maybe<Array<WwwTransaction>>;
  wwwUsersFollowers?: Maybe<WwwUsersFollowers>;
  wwwUsersFollowing?: Maybe<WwwUsersFollowing>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryAdminAssetArgs {
  includePlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryAssetArgs {
  includePlaylist?: InputMaybe<Scalars['Boolean']['input']>;
  legacy?: InputMaybe<AssetLegacyInput>;
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryAssetCategoriesArgs {
  asset_type_slug?: InputMaybe<AssetTypeSlug>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryAssetFilesArgs {
  assetFileTypeSlug?: InputMaybe<Scalars['String']['input']>;
  assetUuids: Array<Scalars['GUID']['input']>;
  desktopPreview?: InputMaybe<Scalars['Boolean']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryAssetTypeSummariesArgs {
  tagLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  tagUuids?: InputMaybe<Array<Scalars['String']['input']>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryAssetUploadStatusArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryAssetsArgs {
  ac_uuid?: InputMaybe<Scalars['String']['input']>;
  asset_category_slug?: InputMaybe<AssetCategorySlug>;
  asset_status_slug?: InputMaybe<AssetStatusSlug>;
  asset_type_slug: AssetTypeSlug;
  bpm?: InputMaybe<Scalars['String']['input']>;
  child_asset_uuid?: InputMaybe<Scalars['GUID']['input']>;
  chord_type?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  device_name?: InputMaybe<Scalars['String']['input']>;
  device_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  filepath?: InputMaybe<Scalars['String']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  has_errors?: InputMaybe<Scalars['Boolean']['input']>;
  has_warnings?: InputMaybe<Scalars['Boolean']['input']>;
  include_inherited_tags?: InputMaybe<Scalars['Boolean']['input']>;
  instructor_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  key?: InputMaybe<Scalars['String']['input']>;
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  licensed?: InputMaybe<Scalars['Boolean']['input']>;
  liked?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  max_bpm?: InputMaybe<Scalars['Int']['input']>;
  min_bpm?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  name_exclude?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<SortOrder>;
  page?: InputMaybe<Scalars['Int']['input']>;
  parent_asset_uuid?: InputMaybe<Scalars['GUID']['input']>;
  parent_asset_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  provider?: InputMaybe<Scalars['GUID']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  random_seed?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<AssetSortType>;
  tag_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  tag_uuids_exclude?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryAssetsSearchArgs {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  children?: InputMaybe<AssetChildrenInput>;
  explain?: InputMaybe<Scalars['Boolean']['input']>;
  filter: AssetFiltersInput;
  legacy?: InputMaybe<AssetSearchLegacyInput>;
  pagination?: InputMaybe<CursorPaginationInput>;
  parents?: InputMaybe<AssetParentsInput>;
  sort?: InputMaybe<AssetSortInput>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryAvailableCreditPacksArgs {
  creditsNeeded?: InputMaybe<Scalars['Int']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryBatchAssetArgs {
  uuids: Array<Scalars['GUID']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryBeatmakerBeatArgs {
  uuid: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryBeatmakerCollectionSamplesArgs {
  tag?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryBeatmakerKitArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryBeatmakerSampleAssetsByFileHashArgs {
  fileHashes: Array<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryCancellationReasonsArgs {
  category: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryCatalogJobArgs {
  jobUuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryCategoryPageContentArgs {
  permalink: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryCheckoutActionArgs {
  planUUID: Scalars['ID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryCompletedAssetsArgs {
  asset_type_slug: AssetTypeSlug;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryCosoTypeMetadataArgs {
  withImages?: InputMaybe<Scalars['Boolean']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryCostEstimateArgs {
  assetUuids: Array<Scalars['GUID']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryCreateProofOfLicenseArgs {
  artistName: Scalars['String']['input'];
  assetUuids: Array<Scalars['String']['input']>;
  fullLegalName: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryCuratedCollectionArgs {
  id: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryCustomStackTemplateFromPromptArgs {
  prompt: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryDeviceArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryDevicesArgs {
  allow_preset?: InputMaybe<Scalars['Boolean']['input']>;
  include_hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent_asset_uuid?: InputMaybe<Scalars['GUID']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['GUID']['input']>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryDiscoverSectionWithItemsArgs {
  id: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryEstimateStackKeyArgs {
  stack: StackInput;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryFeaturedPlanContentArgs {
  daw_slug?: InputMaybe<Scalars['String']['input']>;
  flag_evaluations?: InputMaybe<Array<InputMaybe<PricingFlagEvaluation>>>;
  group?: InputMaybe<PlanGroupSlug>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryFeaturedPlanTermsArgs {
  flag_evaluations?: InputMaybe<Array<InputMaybe<PricingFlagEvaluation>>>;
  group?: InputMaybe<PlanGroupSlug>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryGearArgs {
  id: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryGearPluginInstallerArgs {
  platform: PluginPlatform;
  pluginId: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryGetPromoCodeDetailsArgs {
  planCode: Scalars['String']['input'];
  promoCode: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryInitializeStackLayerArgs {
  assetUuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryInstructorArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryInstructorsArgs {
  name?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['GUID']['input']>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryInstrumentLabelsArgs {
  brand?: InputMaybe<Brand>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryInstrumentPackArgs {
  slug: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryInstrumentPacksArgs {
  filter?: InputMaybe<InstrumentPackFiltersInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryInstrumentPacksByIdsArgs {
  ids: Array<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryLeasableGearArgs {
  filter: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryLeasableGearByCategoryArgs {
  category: LeasableGearCategoryInput;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryLegacyCollectionByPermalinkArgs {
  permalink: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryLegacyPacksChartArgs {
  searchParams?: InputMaybe<PackSearchParams>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryLegacyReleasesArgs {
  daw?: InputMaybe<Scalars['String']['input']>;
  derivatives_of?: InputMaybe<Scalars['String']['input']>;
  following?: InputMaybe<Scalars['Boolean']['input']>;
  genre?: InputMaybe<Scalars['String']['input']>;
  is_remix?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  plugin?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryListCreditBoostersArgs {
  currency?: InputMaybe<Currency>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryManufacturerUserAccountArgs {
  manufacturerName: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMerchContentBlockArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMerchContentBlocksArgs {
  page_slug?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMerchContentBlocksPaginatedArgs {
  page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
  page_slug: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMerchContentItemsPaginatedArgs {
  content_block_uuid: Scalars['String']['input'];
  page: Scalars['Int']['input'];
  page_size: Scalars['Int']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMerchPageArgs {
  slug: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMerchPagesArgs {
  input?: InputMaybe<MerchGetPagesInput>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMinimalAssetsArgs {
  assetUuids: Array<Scalars['GUID']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMyStackSnapshotsArgs {
  cursorToken?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StackSort>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMyStacksArgs {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StackSort>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMyStacksClipsArgs {
  cursorToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StacksClipsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StackSort>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMyStacksPagedArgs {
  cursorToken?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<StacksFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<StackSort>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryMyStacksSessionsArgs {
  cursorToken?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryNewStackArgs {
  customStackTemplate?: InputMaybe<CosoCustomStackTemplateInput>;
  estimateKey?: InputMaybe<Scalars['Boolean']['input']>;
  harmonicMode?: InputMaybe<Scalars['Boolean']['input']>;
  harmonicModeAudioKey?: InputMaybe<Scalars['String']['input']>;
  harmonicModeChordType?: InputMaybe<Scalars['String']['input']>;
  harmonicModeFirstLayerWeight?: InputMaybe<Scalars['Float']['input']>;
  harmonicModeOffset?: InputMaybe<Scalars['Int']['input']>;
  harmonicModePersistWeight?: InputMaybe<Scalars['Float']['input']>;
  harmonicModeVersion?: InputMaybe<Scalars['String']['input']>;
  numLayers?: InputMaybe<Scalars['Int']['input']>;
  randomize?: InputMaybe<Scalars['Boolean']['input']>;
  randomizeDefaultLayerOrder?: InputMaybe<Scalars['Boolean']['input']>;
  randomizeTopHitOffsetMax?: InputMaybe<Scalars['Int']['input']>;
  seed?: InputMaybe<CosoSeedInput>;
  stackBpm?: InputMaybe<Scalars['Int']['input']>;
  stackTemplate: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryNewStackLayerArgs {
  estimateKey?: InputMaybe<Scalars['Boolean']['input']>;
  harmonicMode?: InputMaybe<Scalars['Boolean']['input']>;
  harmonicModeWeight?: InputMaybe<Scalars['Float']['input']>;
  newLayerType?: InputMaybe<Scalars['String']['input']>;
  numResults?: InputMaybe<Scalars['Int']['input']>;
  stack: StackInput;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryNewStackLayerV2Args {
  customLayerFilter?: InputMaybe<CosoLayerFilterInput>;
  estimateKey?: InputMaybe<Scalars['Boolean']['input']>;
  harmonicMode?: InputMaybe<Scalars['Boolean']['input']>;
  harmonicModeWeight?: InputMaybe<Scalars['Float']['input']>;
  newLayerType?: InputMaybe<Scalars['String']['input']>;
  numResults?: InputMaybe<Scalars['Int']['input']>;
  queryString?: InputMaybe<Scalars['String']['input']>;
  stack: StackInput;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryNewStackWithPromptArgs {
  newStack?: InputMaybe<NewStackInput>;
  prompt: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryPackAssetArgs {
  permalink: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryPlanArgs {
  uuid: Scalars['ID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryPlanCardsArgs {
  page?: InputMaybe<Scalars['String']['input']>;
  productNames?: InputMaybe<Array<Scalars['String']['input']>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryPlanSelectTableHeadersArgs {
  billing_frequency?: InputMaybe<Array<InputMaybe<BillingFrequencySlug>>>;
  flag_evaluations?: InputMaybe<Array<InputMaybe<PricingFlagEvaluation>>>;
  group?: InputMaybe<Array<InputMaybe<PlanGroupSlug>>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryPlansArgs {
  billing_frequency?: InputMaybe<Array<InputMaybe<BillingFrequencySlug>>>;
  flag_evaluations?: InputMaybe<Array<InputMaybe<PricingFlagEvaluation>>>;
  group?: InputMaybe<Array<InputMaybe<PlanGroupSlug>>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryPlansPageCopyArgs {
  flag_evaluations?: InputMaybe<Array<InputMaybe<PricingFlagEvaluation>>>;
  group?: InputMaybe<PlanGroupSlug>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryPluginInstallInfoArgs {
  sellerCode: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryPluginLeasePayoffPreviewArgs {
  paymentMethodUuid?: InputMaybe<Scalars['ID']['input']>;
  uuid: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryProductArgs {
  currency?: InputMaybe<Currency>;
  uuid: Scalars['ID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryProductBundleOffersArgs {
  catalogProductUuid: Scalars['ID']['input'];
  currency?: InputMaybe<Currency>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryProductByPurchasableIdArgs {
  purchasableType?: InputMaybe<PurchasableType>;
  uuid: Scalars['ID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryProductCheckoutPreviewArgs {
  billingAddress?: InputMaybe<CheckoutBillingAddressInput>;
  checkoutProducts?: InputMaybe<Array<ProductCheckoutInput>>;
  currency?: InputMaybe<Currency>;
  paymentMethodUuid?: InputMaybe<Scalars['ID']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryProductPlanCardsArgs {
  billingModels?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Currency>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['String']['input']>;
  productNames?: InputMaybe<Array<Scalars['String']['input']>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryProductPlansArgs {
  billingModels?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Currency>;
  groups?: InputMaybe<Array<Scalars['String']['input']>>;
  productNames?: InputMaybe<Array<Scalars['String']['input']>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryPromoCodesArgs {
  campaign?: InputMaybe<Scalars['String']['input']>;
  plan_code?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryProviderArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryProviderByLegacyUuidArgs {
  legacyUuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryProvidersArgs {
  admin?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  uuids?: InputMaybe<Array<Scalars['GUID']['input']>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryRecommendedPacksArgs {
  userUuid?: InputMaybe<Scalars['GUID']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanityFeaturedPluginArgs {
  id: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanityHomeContentArgs {
  page?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanityLegalPageArgs {
  slug: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanityListArgs {
  id?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanityMarketingHeroArgs {
  page?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanityMediaTextBlocksArgs {
  id: Scalars['String']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanityPlansAboveTheFoldContentArgs {
  id?: InputMaybe<Scalars['ID']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanityPlansPageArgs {
  path: Scalars['ID']['input'];
  variant?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanityPromoSectionContentArgs {
  page?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanitySoundsPageContentArgs {
  page?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySanityValuePropsSectionContentArgs {
  page?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySidebarCollectionLinksArgs {
  legacy?: InputMaybe<Scalars['Boolean']['input']>;
  page: Scalars['Int']['input'];
  pageSize: Scalars['Int']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySignedUrlArgs {
  assetType?: InputMaybe<AssetTypeSlug>;
  name: Scalars['String']['input'];
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySimilarSoundsArgs {
  isLegacy?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySoundsClientArgs {
  name: SoundsClientName;
  platform: Platform;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySoundsSearchSuggestionsArgs {
  context: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  searchTerm: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryStackArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryStackSnapshotArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryStacksClipArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryStacksSessionArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySubscriptionArgs {
  group?: InputMaybe<PlanGroupSlug>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySwapStackLayerArgs {
  estimateKey?: InputMaybe<Scalars['Boolean']['input']>;
  numResults?: InputMaybe<Scalars['Int']['input']>;
  stack: StackInput;
  swapLayerIndex?: InputMaybe<Scalars['Int']['input']>;
  topHitOffset?: InputMaybe<Scalars['Int']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QuerySwapStackLayerV2Args {
  customLayerFilter?: InputMaybe<CosoLayerFilterInput>;
  estimateKey?: InputMaybe<Scalars['Boolean']['input']>;
  numResults?: InputMaybe<Scalars['Int']['input']>;
  stack: StackInput;
  swapLayerIndex?: InputMaybe<Scalars['Int']['input']>;
  topHitOffset?: InputMaybe<Scalars['Int']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryTagArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryTagCategoryListArgs {
  permalink_slug?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['String']['input']>;
  v2Enabled?: InputMaybe<Scalars['Boolean']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryTagPageMetadataArgs {
  tagId: Scalars['ID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryTagsArgs {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryTaxonomiesArgs {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryTaxonomyArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryUserAudioFileArgs {
  searchBy: UserAudioFileInput;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryUserAudioFilesArgs {
  page?: InputMaybe<Scalars['Int']['input']>;
  perPage?: InputMaybe<Scalars['Int']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryUserAudioUploadJobArgs {
  jobUuid: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryV2ProjectCollaboratorsArgs {
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryV2ProjectManifestArgs {
  revId?: InputMaybe<Scalars['GUID']['input']>;
  uuid: Scalars['GUID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryV2ProjectsArgs {
  page?: InputMaybe<Scalars['Int']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryV2UserLookupArgs {
  email?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['GUID']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryV2UserSearchArgs {
  query: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWalletPaymentMethodArgs {
  uuid: Scalars['ID']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwGenreArgs {
  permalink: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwLeaseUpgradeArgs {
  sellerCode: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwMeReleasesLikedArgs {
  uuids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwPluginArgs {
  id: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwPluginInstallerUrlArgs {
  platform: PluginInstallerPlatform;
  uuid: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwPluginLeaseExtraUrlArgs {
  leaseUuid: Scalars['String']['input'];
  platform: PluginLeaseInstallerPlatform;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwPluginLeasesArgs {
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwPluginLicenseFileUrlArgs {
  licenseUuid: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwPluginManufacturerArgs {
  id: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwPluginsArgs {
  category?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  manufacturer_name?: InputMaybe<Scalars['String']['input']>;
  native?: InputMaybe<Scalars['Int']['input']>;
  on_splice?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  pricing?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwPluginsSearchArgs {
  category?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
  pricing?: InputMaybe<Scalars['String']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwPremiumProvidersArgs {
  per_page?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwSoundsCustomPackArgs {
  permalink?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwSoundsPackArgs {
  permalink: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwSoundsPacksArgs {
  main_genre?: InputMaybe<Scalars['String']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwSoundsRecentPacksArgs {
  per_page?: InputMaybe<Scalars['Int']['input']>;
  provider_permalink?: InputMaybe<Scalars['String']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwUserArgs {
  username: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwUserTransactionsArgs {
  page?: InputMaybe<Scalars['Int']['input']>;
  per_page?: InputMaybe<Scalars['Int']['input']>;
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwUsersFollowersArgs {
  count?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  username: Scalars['String']['input'];
}


/**
 * This is the root query. Subsections of the graph use `extend` to place their
 * own fields here.
 */
export interface QueryWwwUsersFollowingArgs {
  count?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
}

export interface RawFeaturedCarousel {
  __typename?: 'RawFeaturedCarousel';
  desktop_image_url: Scalars['String']['output'];
  link_url: Scalars['String']['output'];
  mobile_image_url: Scalars['String']['output'];
}

export interface RawGalleryItem {
  __typename?: 'RawGalleryItem';
  data?: Maybe<RawGearMedia>;
  order?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface RawGearDetails {
  __typename?: 'RawGearDetails';
  desktop_carousel_image_url?: Maybe<Scalars['String']['output']>;
  desktop_carousel_index?: Maybe<Scalars['Int']['output']>;
  desktop_category?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  essential_rto_carousel_index?: Maybe<Scalars['Int']['output']>;
  featured_carousel?: Maybe<Array<Maybe<RawFeaturedCarousel>>>;
  featured_carousel_image?: Maybe<Scalars['String']['output']>;
  featured_mobile_carousel_image?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Maybe<RawGalleryItem>>>;
  features_description?: Maybe<Scalars['String']['output']>;
  gallery?: Maybe<Array<Maybe<RawGalleryItem>>>;
  highlights?: Maybe<Array<Maybe<RawGearFeatureHighlights>>>;
  marketing?: Maybe<GearSeo>;
  mini_features?: Maybe<Array<Maybe<RawGalleryItem>>>;
  mini_features_header?: Maybe<Scalars['String']['output']>;
  specifications?: Maybe<RawGearSpecifications>;
  testimonials?: Maybe<Array<Maybe<RawGalleryItem>>>;
}

export interface RawGearFeatureHighlights {
  __typename?: 'RawGearFeatureHighlights';
  description?: Maybe<Scalars['String']['output']>;
  highlight_items: Array<RawHighlightItem>;
  title: Scalars['String']['output'];
}

export interface RawGearMedia {
  __typename?: 'RawGearMedia';
  alt_text?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  upload_date?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  youtube_id?: Maybe<Scalars['String']['output']>;
}

export interface RawGearSpecifications {
  __typename?: 'RawGearSpecifications';
  max_activations?: Maybe<Scalars['Int']['output']>;
  specification_images: Array<Scalars['String']['output']>;
  specification_text: Scalars['String']['output'];
  system_requirements: Scalars['String']['output'];
}

export interface RawHighlightData {
  __typename?: 'RawHighlightData';
  description: Scalars['String']['output'];
  highlight_thumbnail: Scalars['String']['output'];
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface RawHighlightItem {
  __typename?: 'RawHighlightItem';
  data?: Maybe<RawHighlightData>;
  type?: Maybe<Scalars['String']['output']>;
}

/**
 * Products to move to the destination payment method, either everything billed
 * to `paymentMethodUuid` or a single `assignment`.
 */
export interface ReassignWalletPaymentMethodInput {
  assignment?: InputMaybe<WalletPaymentMethodAssignmentInput>;
  paymentMethodUuid?: InputMaybe<Scalars['ID']['input']>;
}

/**
 * Bulk reassignment is partial: assignments that could not be moved are
 * returned in `failed`.
 */
export interface ReassignWalletPaymentMethodResult {
  __typename?: 'ReassignWalletPaymentMethodResult';
  failed: Array<FailedWalletPaymentMethodAssignment>;
  successful: Array<WalletPaymentMethodAssignment>;
}

export enum RecommendationsSource {
  UserPackRecommendations = 'user_pack_recommendations',
  UserSurveyContent = 'user_survey_content'
}

export interface RecommendedPacksWithSourceResponse {
  __typename?: 'RecommendedPacksWithSourceResponse';
  packs?: Maybe<Array<PackAsset>>;
  source: RecommendationsSource;
}

export interface RelatedAssets {
  __typename?: 'RelatedAssets';
  /** @deprecated Not Implemented */
  tag_summary?: Maybe<Array<Maybe<TagSummary>>>;
}

export interface RelatedAssetsCounts {
  __typename?: 'RelatedAssetsCounts';
  count?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<AssetTypeSlug>;
}

export interface RemoveAssetFromCollection {
  __typename?: 'RemoveAssetFromCollection';
  asset?: Maybe<ChildAsset>;
  collection?: Maybe<CollectionAsset>;
}

/** Generic metadata response. */
export interface ResponseMetadata {
  __typename?: 'ResponseMetadata';
  /** Next cursor */
  next?: Maybe<Scalars['String']['output']>;
  /** Previous cursor */
  previous?: Maybe<Scalars['String']['output']>;
  /** Total Records */
  records?: Maybe<Scalars['Int']['output']>;
}

export interface RichPlanCard {
  __typename?: 'RichPlanCard';
  afterSubscribeUrl?: Maybe<Scalars['String']['output']>;
  /** Portable text button label used while the yearly period is selected; null when the editor left it blank. planField tokens resolve against the annual plan. */
  annualSubscribeButtonLabel?: Maybe<Scalars['JSON']['output']>;
  features?: Maybe<Array<PlansCardFeature>>;
  includesInstrument?: Maybe<Scalars['Boolean']['output']>;
  /** Live pricing hydrated from the product API — one entry per billing model (monthly/annual). */
  plans?: Maybe<Array<ProductPlan>>;
  productName?: Maybe<Scalars['String']['output']>;
  /** Portable text button label; planField tokens have their resolvedPlan injected by the resolver. */
  subscribeButtonLabel?: Maybe<Scalars['JSON']['output']>;
  tagline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
}

export interface Sample {
  __typename?: 'Sample';
  audio_key?: Maybe<Scalars['String']['output']>;
  bpm?: Maybe<Scalars['Int']['output']>;
  chord_type?: Maybe<Scalars['String']['output']>;
  dir?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  file_hash?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  pack?: Maybe<LegacyPack2>;
  popularity?: Maybe<Scalars['Int']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  provider_permalink?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['ID']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  published_at?: Maybe<Scalars['String']['output']>;
  sample_type?: Maybe<Scalars['String']['output']>;
  sas_id?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  trending?: Maybe<Scalars['Int']['output']>;
  waveform_url?: Maybe<Scalars['String']['output']>;
}

export interface SampleAsset extends IAsset, IAssetChild, IDownloadableAsset, ILegacyAsset, IReportableAsset, ISample {
  __typename?: 'SampleAsset';
  activities?: Maybe<Array<Maybe<AssetActivity>>>;
  allowed_asset_type_child?: Maybe<Array<Maybe<AssetType>>>;
  asset_category_slug?: Maybe<AssetCategorySlug>;
  asset_prices?: Maybe<Array<Maybe<Price>>>;
  asset_status_slug?: Maybe<AssetStatusSlug>;
  asset_type?: Maybe<AssetType>;
  asset_type_slug?: Maybe<AssetTypeSlug>;
  /** Eg. if an asset is rare */
  attributes?: Maybe<Array<AssetAttributeSlug>>;
  bpm?: Maybe<Scalars['Int']['output']>;
  /** Eg, if asset is eligible for Presonus free bundled content */
  bundled_content_daws?: Maybe<Array<AssetBundledContentDawSlug>>;
  catalog_uuid?: Maybe<Scalars['GUID']['output']>;
  chord_type?: Maybe<Scalars['String']['output']>;
  /** Playback information for a sample when queried with a coso seed (pitch shift, playback bpm, number of bars) */
  coso_playback_metadata?: Maybe<CosoPlaybackMetadata>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * by default the name for a sample is the full filepath
   * This will just be the path to the file.
   * example: /drums/snares/128/
   */
  display_file_path?: Maybe<Scalars['String']['output']>;
  /**
   * by default the name for a sample is the full filepath
   * This will just be the file name.
   * example: snare_128.wav
   */
  display_name?: Maybe<Scalars['String']['output']>;
  downloaded?: Maybe<Scalars['Boolean']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  file?: Maybe<AssetFile>;
  files?: Maybe<Array<AssetFile>>;
  /** a flag indicating that a sample is eligible for inclusion coso */
  has_coso?: Maybe<Scalars['Boolean']['output']>;
  /** a flag indicating that a sample has similar sounds */
  has_similar_sounds?: Maybe<Scalars['Boolean']['output']>;
  /** Ingestion issues associated with the asset. */
  ingestion_issues?: Maybe<AssetIngestionIssues>;
  instrument?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  legacy_permalink?: Maybe<Scalars['String']['output']>;
  legacy_uuid?: Maybe<Scalars['GUID']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  localInfo?: Maybe<AssetLocalInfo>;
  marketplace_status_slug?: Maybe<MarketplaceStatusSlug>;
  name?: Maybe<Scalars['String']['output']>;
  pack_parent?: Maybe<PackAsset>;
  /** A summary count of all parent assets of this asset, grouped by asset type. */
  parent_asset_counts?: Maybe<Array<Maybe<RelatedAssetsCounts>>>;
  parent_asset_uuids?: Maybe<Array<Maybe<Scalars['GUID']['output']>>>;
  parents?: Maybe<AssetPage>;
  permalink_base_url?: Maybe<Scalars['String']['output']>;
  permalink_slug?: Maybe<Scalars['String']['output']>;
  /**
   * Casa-stored pitch class profile for this sample.
   * Null when Casa has no PCP for the asset.
   */
  pitch_class_profile?: Maybe<PitchClassProfile>;
  provider?: Maybe<Provider>;
  provider_sku?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['GUID']['output']>;
  reported?: Maybe<Scalars['Boolean']['output']>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}


export interface SampleAssetCoso_Playback_MetadataArgs {
  seed?: InputMaybe<CosoSeedInput>;
}


export interface SampleAssetFileArgs {
  type?: InputMaybe<AssetFileTypeSlug>;
}


export interface SampleAssetFilesArgs {
  includeSource?: InputMaybe<Scalars['Boolean']['input']>;
}


export interface SampleAssetParentsArgs {
  filter: AssetFiltersInput;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<AssetSortInput>;
}

export interface SampleInput {
  audio_key?: InputMaybe<Scalars['String']['input']>;
  bpm?: InputMaybe<Scalars['Int']['input']>;
  chord_type?: InputMaybe<Scalars['String']['input']>;
  dir?: InputMaybe<Scalars['String']['input']>;
  file_hash?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Int']['input']>;
  sample_type?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
}

export interface SampleLibraryTabContent {
  __typename?: 'SampleLibraryTabContent';
  tabContent: Array<AnyAsset>;
  tabLabel: Scalars['String']['output'];
}

export interface SanityBackgroundGradient {
  __typename?: 'SanityBackgroundGradient';
  angle?: Maybe<Scalars['Float']['output']>;
  stops?: Maybe<Array<Maybe<SanityGradientStop>>>;
}

export interface SanityBannerContent {
  __typename?: 'SanityBannerContent';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['JSON']['output']>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  routeRules?: Maybe<SanityRouteRules>;
  textColor?: Maybe<Scalars['String']['output']>;
}

export interface SanityBlogLink {
  __typename?: 'SanityBlogLink';
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export enum SanityCtaAction {
  Anchor = 'ANCHOR',
  Checkout = 'CHECKOUT',
  Download = 'DOWNLOAD',
  Link = 'LINK'
}

export enum SanityCtaType {
  Button = 'BUTTON',
  Link = 'LINK'
}

export interface SanityColor {
  __typename?: 'SanityColor';
  alpha?: Maybe<Scalars['Float']['output']>;
  hex?: Maybe<Scalars['String']['output']>;
  rgb?: Maybe<SanityColorRgb>;
}

export interface SanityColorRgb {
  __typename?: 'SanityColorRgb';
  a?: Maybe<Scalars['Float']['output']>;
  b?: Maybe<Scalars['Float']['output']>;
  g?: Maybe<Scalars['Float']['output']>;
  r?: Maybe<Scalars['Float']['output']>;
}

export interface SanityCommunityNav {
  __typename?: 'SanityCommunityNav';
  ctaLink: Scalars['String']['output'];
  ctaText: Scalars['String']['output'];
  featured: SanityFeaturedBlog;
  header: Scalars['String']['output'];
  linkList: Array<SanityBlogLink>;
  tagline: Scalars['String']['output'];
}

export interface SanityCtaCheckoutConfig {
  __typename?: 'SanityCtaCheckoutConfig';
  billingFrequency?: Maybe<BillingFrequencySlug>;
  planProductName?: Maybe<Scalars['String']['output']>;
  planUuid?: Maybe<Scalars['ID']['output']>;
  productUuid?: Maybe<Scalars['ID']['output']>;
  promoCode?: Maybe<Scalars['String']['output']>;
}

export interface SanityCtaContent {
  __typename?: 'SanityCtaContent';
  checkout?: Maybe<SanityCtaCheckoutConfig>;
  ctaAction?: Maybe<SanityCtaAction>;
  ctaHref?: Maybe<Scalars['String']['output']>;
  ctaLabel: Scalars['String']['output'];
  download?: Maybe<SanityCtaDownloadConfig>;
  key?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
  type: SanityCtaType;
  variant?: Maybe<Scalars['String']['output']>;
}

export interface SanityCtaDownloadConfig {
  __typename?: 'SanityCtaDownloadConfig';
  macUrl?: Maybe<Scalars['String']['output']>;
  windowsUrl?: Maybe<Scalars['String']['output']>;
}

export interface SanityEditorialBannerImages {
  __typename?: 'SanityEditorialBannerImages';
  minWidth: Scalars['Int']['output'];
  src: Scalars['String']['output'];
}

export interface SanityEditorialSlide {
  __typename?: 'SanityEditorialSlide';
  bannerImages: Array<SanityEditorialBannerImages>;
  ctaText: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  header: Scalars['String']['output'];
  id: Scalars['String']['output'];
  packs: Array<Scalars['String']['output']>;
  samples: Array<Scalars['String']['output']>;
}

export interface SanityFeaturedBlog {
  __typename?: 'SanityFeaturedBlog';
  altText: Scalars['String']['output'];
  cloudinaryId: Scalars['String']['output'];
  url: Scalars['String']['output'];
}

export interface SanityFeaturedPlugin {
  __typename?: 'SanityFeaturedPlugin';
  canonicalPath: Scalars['String']['output'];
  description: Scalars['JSON']['output'];
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  heading: Scalars['String']['output'];
  imagePath: Scalars['String']['output'];
  manufacturerName: Scalars['String']['output'];
  manufacturerPath: Scalars['String']['output'];
  subheading: Scalars['String']['output'];
}

export interface SanityGear {
  __typename?: 'SanityGear';
  altText?: Maybe<Scalars['String']['output']>;
  cloudinaryId: Scalars['String']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  manufacturerUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  price?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
}

export interface SanityGradientStop {
  __typename?: 'SanityGradientStop';
  color?: Maybe<SanityColor>;
  position?: Maybe<Scalars['Float']['output']>;
}

export interface SanityHeroVideoContent {
  __typename?: 'SanityHeroVideoContent';
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  fullMediaUrl: Scalars['String']['output'];
  heading: Scalars['String']['output'];
  link?: Maybe<CtaLink>;
  previewMediaUrl: Scalars['String']['output'];
  subHeading: Scalars['String']['output'];
  videoPosterUrl: Scalars['String']['output'];
}

export interface SanityHomeContent {
  __typename?: 'SanityHomeContent';
  heroVideo?: Maybe<SanityHeroVideoContent>;
  pluginBrandPositioningContent?: Maybe<SanityPluginBrandPositioningContent>;
  promoSectionContent?: Maybe<SanityPromoSectionContent>;
  valuePropsSectionContent?: Maybe<SanityValuePropsSectionContent>;
}

/** This file contains the GraphQL queries and fragments for shared marketing components. */
export interface SanityImage {
  __typename?: 'SanityImage';
  alt?: Maybe<Scalars['String']['output']>;
  cloudinaryId?: Maybe<Scalars['String']['output']>;
  imageSrcset?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
}

export interface SanityLegalPage {
  __typename?: 'SanityLegalPage';
  content: Scalars['JSON']['output'];
  seoDescription: Scalars['String']['output'];
  seoTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
}

export interface SanityList {
  __typename?: 'SanityList';
  children?: Maybe<Array<SanityList>>;
  content?: Maybe<Scalars['JSON']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface SanityMarketingHero {
  __typename?: 'SanityMarketingHero';
  ctas?: Maybe<Array<SanityCtaContent>>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<SanityResponsiveImage>;
  heading?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<Scalars['JSON']['output']>;
  variant?: Maybe<Scalars['String']['output']>;
}

export interface SanityMedia {
  __typename?: 'SanityMedia';
  mediaAltText?: Maybe<Scalars['String']['output']>;
  mediaPath: Scalars['String']['output'];
  mediaType: Scalars['String']['output'];
}

export interface SanityMediaTextBlock {
  __typename?: 'SanityMediaTextBlock';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  content: Scalars['JSON']['output'];
  ctas?: Maybe<Array<SanityCtaContent>>;
  heading: Scalars['String']['output'];
  mediaAltText?: Maybe<Scalars['String']['output']>;
  mediaPath: Scalars['String']['output'];
  mediaType: Scalars['String']['output'];
  subHeading?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
}

export interface SanityMediaTextBlocks {
  __typename?: 'SanityMediaTextBlocks';
  blocks: Array<SanityMediaTextBlock>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  theme?: Maybe<Theme>;
  title: Scalars['String']['output'];
}

export interface SanityMultiMediaTextBlock {
  __typename?: 'SanityMultiMediaTextBlock';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  content: Scalars['JSON']['output'];
  ctas?: Maybe<Array<SanityCtaContent>>;
  heading: Scalars['String']['output'];
  media?: Maybe<Array<SanityMedia>>;
  subHeading?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
}

export interface SanityNavContent {
  __typename?: 'SanityNavContent';
  community: SanityCommunityNav;
  instrument: SanityProductNav;
  rto: SanityProductNav;
}

export interface SanityPlainTextBlock {
  __typename?: 'SanityPlainTextBlock';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  content: Scalars['JSON']['output'];
  ctas?: Maybe<Array<SanityCtaContent>>;
  heading: Scalars['String']['output'];
  subHeading?: Maybe<Scalars['String']['output']>;
  textColor?: Maybe<Scalars['String']['output']>;
}

export interface SanityPlansAboveTheFoldContent {
  __typename?: 'SanityPlansAboveTheFoldContent';
  backgroundGradientLeft?: Maybe<Scalars['String']['output']>;
  backgroundGradientRight?: Maybe<Scalars['String']['output']>;
  backgroundImageLeft?: Maybe<SanityImage>;
  backgroundImageRight?: Maybe<SanityImage>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  features?: Maybe<SanityList>;
  headerText: Scalars['String']['output'];
  morePlansText?: Maybe<Scalars['String']['output']>;
  subheaderText?: Maybe<Scalars['String']['output']>;
}

export interface SanityPluginBrandPositioningContent {
  __typename?: 'SanityPluginBrandPositioningContent';
  content: Array<SanityPluginContent>;
  ctaText: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  header: Scalars['String']['output'];
  subHeader: Scalars['String']['output'];
}

export interface SanityPluginContent {
  __typename?: 'SanityPluginContent';
  copy: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subTitle: Scalars['String']['output'];
  thumbnail: SanityPluginThumbnail;
  url: Scalars['String']['output'];
}

export interface SanityPluginThumbnail {
  __typename?: 'SanityPluginThumbnail';
  alt: Scalars['String']['output'];
  cloudinaryId: Scalars['String']['output'];
}

export interface SanityProductNav {
  __typename?: 'SanityProductNav';
  featured: NavFeaturedGear;
  sidebar: NavGearSidebar;
  tagline: Scalars['String']['output'];
}

export interface SanityPromoSectionContent {
  __typename?: 'SanityPromoSectionContent';
  backgroundGradient?: Maybe<SanityBackgroundGradient>;
  ctas?: Maybe<Array<SanityCtaContent>>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  featuredImage?: Maybe<SanityResponsiveImage>;
  heading?: Maybe<Scalars['String']['output']>;
  subHeading?: Maybe<Scalars['JSON']['output']>;
  theme?: Maybe<Scalars['String']['output']>;
}

export interface SanityResponsiveImage {
  __typename?: 'SanityResponsiveImage';
  caption?: Maybe<Scalars['String']['output']>;
  default?: Maybe<SanityImage>;
  sources?: Maybe<Array<Maybe<SanityResponsiveImageSource>>>;
}

export interface SanityResponsiveImageSource {
  __typename?: 'SanityResponsiveImageSource';
  image?: Maybe<SanityImage>;
  minWidth?: Maybe<Scalars['Int']['output']>;
}

export interface SanityRouteRules {
  __typename?: 'SanityRouteRules';
  excludeOnRoutes: Array<Scalars['String']['output']>;
  includeOnRoutes: Array<Scalars['String']['output']>;
  showOnAllRoutes?: Maybe<Scalars['Boolean']['output']>;
}

export interface SanitySampleBrandPositioningContent {
  __typename?: 'SanitySampleBrandPositioningContent';
  content: Array<SampleLibraryTabContent>;
  ctaText: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  header: Scalars['String']['output'];
  subHeader: Scalars['String']['output'];
}

export interface SanitySampleLibraryContent {
  __typename?: 'SanitySampleLibraryContent';
  genre: Scalars['String']['output'];
  sampleUuids: Array<Scalars['String']['output']>;
}

/**
 * This file contains the GraphQL queries and fragments for the SoundsPage route.
 * SoundsPage is a marketing concept that showcases our sounds.
 */
export interface SanitySoundsPageContent {
  __typename?: 'SanitySoundsPageContent';
  header?: Maybe<SanitySoundsPageHeaderContent>;
  promoSectionContent?: Maybe<SanityPromoSectionContent>;
  valuePropsSectionContent?: Maybe<SanityValuePropsSectionContent>;
}

export interface SanitySoundsPageHeaderContent {
  __typename?: 'SanitySoundsPageHeaderContent';
  ctas?: Maybe<Array<Maybe<SanityCtaContent>>>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  heading: Scalars['String']['output'];
  subHeading?: Maybe<Scalars['String']['output']>;
}

export interface SanityValuePropsContent {
  __typename?: 'SanityValuePropsContent';
  description: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  icon: SanityImage;
}

export interface SanityValuePropsSectionContent {
  __typename?: 'SanityValuePropsSectionContent';
  ctas?: Maybe<Array<SanityCtaContent>>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  props: Array<Maybe<SanityValuePropsContent>>;
}

export interface ShareStackInput {
  /** The type of License Use for this share */
  licenseUseType?: InputMaybe<StackLicenseUseType>;
  /**
   * The type of Render File to be uploaded. A signed upload URL will be returned.
   * This is no longer used, an uploaded render file for sharing is no longer required.
   * @deprecated Obsolete
   */
  renderFileType?: InputMaybe<UgcFileType>;
  /**
   * A complete Stack. This allows a stack's state in time to be captured.
   * This is no longer used, new clients are expected to send the UUID of a previously saved Stack.
   * @deprecated Obsolete
   */
  snapshot?: InputMaybe<StackInput>;
  /**
   * A uuid of the DBStack being referenced. If not present, a complete snapshot is
   * required.
   */
  stackUuid?: InputMaybe<Scalars['GUID']['input']>;
}

export interface ShareStackResult {
  __typename?: 'ShareStackResult';
  /**
   * A signed url for uploading a file to storage, if required.
   * This is no longer used, an uploaded render file for sharing is no longer required.
   * @deprecated Obsolete
   */
  fileUploadUrl?: Maybe<SignedUrlInfo>;
  /** Share URL to open Stack in Create. */
  shareUrl?: Maybe<Scalars['URL']['output']>;
  /** UUID of the saved Snapshot */
  snapshotUuid?: Maybe<Scalars['GUID']['output']>;
}

export interface SidebarCollectionLink {
  __typename?: 'SidebarCollectionLink';
  name: Scalars['String']['output'];
  owned: Scalars['Boolean']['output'];
  permalink_slug: Scalars['String']['output'];
  public: Scalars['Boolean']['output'];
  uuid: Scalars['GUID']['output'];
}

/** Url to upload to S3 */
export interface SignedUrl {
  __typename?: 'SignedUrl';
  url?: Maybe<Scalars['String']['output']>;
  /** uuid for the requested asset */
  uuid: Scalars['GUID']['output'];
}

/** Signed URL with method and headers */
export interface SignedUrlInfo {
  __typename?: 'SignedUrlInfo';
  /** Required HTTP headers/values, if any */
  headers?: Maybe<Array<HttpHeader>>;
  /** Required HTTP method, typically "PUT" for uploads or "GET" otherwise */
  method: HttpMethod;
  /** The signed URL */
  url: Scalars['URL']['output'];
}

export enum SimilarAssetTypeSlug {
  Lesson = 'lesson',
  Video = 'video'
}

/** SisoSeedInput is the seed input for similar-sounds (siso) search. */
export interface SisoSeedInput {
  /** assetUuid specifies a Splice catalog asset to find similar sounds for */
  assetUuid?: InputMaybe<Scalars['String']['input']>;
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export interface SoundContentItem {
  __typename?: 'SoundContentItem';
  audio_demo_id?: Maybe<Scalars['String']['output']>;
  audio_demo_item?: Maybe<AudioContentItem>;
  batch_id: Scalars['String']['output'];
  content_id: Scalars['String']['output'];
  family: Scalars['String']['output'];
  free: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  revision?: Maybe<Scalars['Int']['output']>;
  type: ContentType;
}

export interface SoundcheckApplicationInput {
  additionalNotes?: InputMaybe<Scalars['String']['input']>;
  ageRange: Scalars['String']['input'];
  cpuArchitecture: Scalars['String']['input'];
  discordUsername?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  genres: Scalars['String']['input'];
  ndaAgreed: Scalars['Boolean']['input'];
  operatingSystem: Scalars['String']['input'];
  otherDaws?: InputMaybe<Scalars['String']['input']>;
  otherPlugins?: InputMaybe<Scalars['String']['input']>;
  primaryDaw: Scalars['String']['input'];
  priorEmployers: Array<Scalars['String']['input']>;
  roles: Array<Scalars['String']['input']>;
  signature: Scalars['String']['input'];
  submissionId: Scalars['String']['input'];
  systemMemoryGb: Scalars['Int']['input'];
  techComfort: Scalars['Int']['input'];
  yearsMakingMusic: Scalars['Int']['input'];
}

export enum SoundcheckApplicationStatus {
  Active = 'ACTIVE',
  Deactivated = 'DEACTIVATED',
  Declined = 'DECLINED',
  NotApplied = 'NOT_APPLIED',
  Other = 'OTHER',
  Pending = 'PENDING'
}

export interface SoundcheckBetaProgram {
  __typename?: 'SoundcheckBetaProgram';
  contentAboveInstallers?: Maybe<Scalars['JSON']['output']>;
  contentBelowInstallers?: Maybe<Scalars['JSON']['output']>;
  cta?: Maybe<Scalars['String']['output']>;
  experimentFlagKey?: Maybe<Scalars['String']['output']>;
  experimentVariation?: Maybe<Scalars['String']['output']>;
  feedbackLink: Scalars['String']['output'];
  header: SoundcheckHeader;
  installers: Array<SoundcheckInstaller>;
  path?: Maybe<Scalars['String']['output']>;
  permissions: Array<SoundcheckPermission>;
  requiresNDA?: Maybe<Scalars['Boolean']['output']>;
  shortDescription: Scalars['String']['output'];
  status: Scalars['String']['output'];
  supportLink?: Maybe<Scalars['String']['output']>;
  supportText?: Maybe<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
}

export interface SoundcheckHeader {
  __typename?: 'SoundcheckHeader';
  image?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
}

export interface SoundcheckInstaller {
  __typename?: 'SoundcheckInstaller';
  buttons: Array<SoundcheckInstallerButton>;
  section: Scalars['String']['output'];
}

export interface SoundcheckInstallerButton {
  __typename?: 'SoundcheckInstallerButton';
  label: Scalars['String']['output'];
  link: Scalars['String']['output'];
}

export interface SoundcheckPermission {
  __typename?: 'SoundcheckPermission';
  error?: Maybe<Scalars['String']['output']>;
  hideIfNotEligible: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
}

/**
 * A Splice Sounds client — a DAW-hosted plugin (Pro Tools, Ableton, Studio One,
 * …) or the standalone Splice Sounds app. Returned by `soundsClient(name:, os:)`.
 */
export interface SoundsClient {
  __typename?: 'SoundsClient';
  /**
   * Versions of this client that Splice still considers supported on the
   * requested operating system.
   */
  supportedVersions: Array<SoundsClientVersion>;
}

/**
 * Known Sounds client identifiers. The resolver maps each value to the
 * `{daw}` path segment accepted by `GET /daw_plugin/{daw}/version/{os}`.
 */
export enum SoundsClientName {
  AbletonIntegration = 'ABLETON_INTEGRATION',
  ProToolsIntegration = 'PRO_TOOLS_INTEGRATION',
  SoundsPlugin = 'SOUNDS_PLUGIN',
  StudioOneIntegration = 'STUDIO_ONE_INTEGRATION'
}

/** A single released version of a Sounds client. */
export interface SoundsClientVersion {
  __typename?: 'SoundsClientVersion';
  /**
   * Semver string for this build, matching the existing
   * `GET /daw_plugin/{daw}/version/{os}` `plugin_version` response field one-to-
   * one so version-comparison logic in clients (e.g. `PluginUpdateProToolsService`)
   * does not need to change.
   */
  version: Scalars['String']['output'];
}

/** Response from the search service containing autocomplete suggestions for a given sounds search query */
export interface SoundsSearchSuggestionsResponse {
  __typename?: 'SoundsSearchSuggestionsResponse';
  /** ID used to link a search "session" with a specific set of results returned from the sounds search suggestions API */
  autocompleteUuid: Scalars['GUID']['output'];
  id?: Maybe<Scalars['GUID']['output']>;
  results: Array<SoundsSearchSuggestionsResult>;
}

/** Individual sounds search autocomplete suggestion */
export interface SoundsSearchSuggestionsResult {
  __typename?: 'SoundsSearchSuggestionsResult';
  autocompleteTerm: Scalars['String']['output'];
  length: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  termType: Scalars['String']['output'];
}

export interface Stack {
  __typename?: 'Stack';
  createMode?: Maybe<Scalars['String']['output']>;
  customStackTemplate?: Maybe<CosoCustomStackTemplate>;
  layers?: Maybe<Array<StackLayer>>;
  name?: Maybe<Scalars['String']['output']>;
  originalBpm?: Maybe<Scalars['Int']['output']>;
  stackBpm?: Maybe<Scalars['Int']['output']>;
  stackKey?: Maybe<StackKey>;
  stackPsOffset?: Maybe<Scalars['Int']['output']>;
  stackTemplate?: Maybe<Scalars['String']['output']>;
  /** @deprecated Static, use cosoTypeMetadata */
  stackTemplateLabel?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['GUID']['output'];
}

export interface StackExportType {
  __typename?: 'StackExportType';
  label: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  status: StackExportTypeStatus;
}

export enum StackExportTypeStatus {
  Active = 'ACTIVE',
  Comingsoon = 'COMINGSOON',
  Disabled = 'DISABLED',
  Unspecified = 'UNSPECIFIED'
}

export interface StackInput {
  createMode?: InputMaybe<Scalars['String']['input']>;
  customStackTemplate?: InputMaybe<CosoCustomStackTemplateInput>;
  layers: Array<StackLayerInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  originalBpm?: InputMaybe<Scalars['Int']['input']>;
  stackBpm?: InputMaybe<Scalars['Int']['input']>;
  stackKey?: InputMaybe<StackKeyInput>;
  stackPsOffset?: InputMaybe<Scalars['Int']['input']>;
  stackTemplate?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['GUID']['input']>;
}

export interface StackKey {
  __typename?: 'StackKey';
  audioKey?: Maybe<Scalars['String']['output']>;
  chordType?: Maybe<Scalars['String']['output']>;
}

export interface StackKeyInput {
  audioKey?: InputMaybe<Scalars['String']['input']>;
  chordType?: InputMaybe<Scalars['String']['input']>;
}

export interface StackLayer {
  __typename?: 'StackLayer';
  asset?: Maybe<SampleAsset>;
  /** @deprecated Obsolete */
  assetSource?: Maybe<Scalars['String']['output']>;
  assetUuid?: Maybe<Scalars['String']['output']>;
  bpm?: Maybe<Scalars['Int']['output']>;
  clip?: Maybe<StacksClip>;
  clipUuid?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  layerType?: Maybe<Scalars['String']['output']>;
  /** @deprecated Static, use cosoTypeMetadata */
  layerTypeLabel?: Maybe<Scalars['String']['output']>;
  locked?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use properties.mute */
  mute?: Maybe<Scalars['Boolean']['output']>;
  nonPitched?: Maybe<Scalars['Boolean']['output']>;
  numBars?: Maybe<Scalars['Int']['output']>;
  origin?: Maybe<Scalars['String']['output']>;
  playbackBpm?: Maybe<Scalars['Float']['output']>;
  properties?: Maybe<StackLayerProperties>;
  psOffset?: Maybe<Scalars['Int']['output']>;
  /**
   * Optional beat-region mask applied to this layer's CoSo embedding during
   * compatibility search. When unset, the full 8-bar (tiled) embedding is used.
   */
  region?: Maybe<LayerRegion>;
  userAudioFile?: Maybe<UserAudioFile>;
  userAudioFileHash?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['GUID']['output'];
  vectors?: Maybe<Array<FloatVector>>;
  /** @deprecated Use properties.volume */
  volume?: Maybe<Scalars['Float']['output']>;
}


export interface StackLayerAssetArgs {
  shouldUseLegacyApi?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface StackLayerInput {
  assetSource?: InputMaybe<Scalars['String']['input']>;
  assetUuid?: InputMaybe<Scalars['String']['input']>;
  bpm?: InputMaybe<Scalars['Int']['input']>;
  clipUuid?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  layerType?: InputMaybe<Scalars['String']['input']>;
  locked?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use properties.mute */
  mute?: InputMaybe<Scalars['Boolean']['input']>;
  nonPitched?: InputMaybe<Scalars['Boolean']['input']>;
  numBars?: InputMaybe<Scalars['Int']['input']>;
  origin?: InputMaybe<Scalars['String']['input']>;
  playbackBpm?: InputMaybe<Scalars['Float']['input']>;
  properties?: InputMaybe<StackLayerPropertiesInput>;
  psOffset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Optional beat-region mask applied to this layer's CoSo embedding during
   * compatibility search. When unset, the full 8-bar (tiled) embedding is used.
   */
  region?: InputMaybe<LayerRegionInput>;
  userAudioFileHash?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['GUID']['input']>;
  vectors?: InputMaybe<Array<FloatVectorInput>>;
  /** @deprecated Use properties.volume */
  volume?: InputMaybe<Scalars['Float']['input']>;
}

export interface StackLayerProperties {
  __typename?: 'StackLayerProperties';
  mute?: Maybe<StacksBoolProperty>;
  volume?: Maybe<StacksFloatProperty>;
}

export interface StackLayerPropertiesInput {
  mute?: InputMaybe<StacksBoolPropertyInput>;
  volume?: InputMaybe<StacksFloatPropertyInput>;
}

export enum StackLicenseStatus {
  LicenseStatusPending = 'LICENSE_STATUS_PENDING',
  LicenseStatusUnspecified = 'LICENSE_STATUS_UNSPECIFIED',
  LicenseStatusUsed = 'LICENSE_STATUS_USED'
}

/** Info about the share license used by a Stack */
export interface StackLicenseUse {
  __typename?: 'StackLicenseUse';
  /** Status of the share license. Must be LICENSE_STATUS_USED for a Stack to be shareable. */
  licenseStatus?: Maybe<StackLicenseStatus>;
  /**
   * Type of share license use, e.g. web share, user download, 3rd party, etc.
   * Stacks should be shared only in contexts for which the given license use type applies.
   */
  licenseUseType?: Maybe<StackLicenseUseType>;
}

export enum StackLicenseUseType {
  LicenseUseType_3RdPartyShare = 'LICENSE_USE_TYPE_3RD_PARTY_SHARE',
  LicenseUseTypeDawExport = 'LICENSE_USE_TYPE_DAW_EXPORT',
  LicenseUseTypeSpliceWebShare = 'LICENSE_USE_TYPE_SPLICE_WEB_SHARE',
  LicenseUseTypeUnspecified = 'LICENSE_USE_TYPE_UNSPECIFIED',
  LicenseUseTypeUserDownload = 'LICENSE_USE_TYPE_USER_DOWNLOAD'
}

/** An immutable snapshot of a Stack */
export interface StackSnapshot {
  __typename?: 'StackSnapshot';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  isPublic?: Maybe<Scalars['Boolean']['output']>;
  /** Hydrated User referenced in ownerUuid resolved via Legacy API */
  legacyV2User?: Maybe<V2User>;
  licenseUse?: Maybe<StackLicenseUse>;
  ownerUuid?: Maybe<Scalars['GUID']['output']>;
  stack?: Maybe<Stack>;
  uuid: Scalars['GUID']['output'];
}

export interface StackSnapshotsPayload {
  __typename?: 'StackSnapshotsPayload';
  cursor?: Maybe<StacksCursor>;
  snapshots?: Maybe<Array<StackSnapshot>>;
}

export enum StackSort {
  StackSortCreatedAtAsc = 'STACK_SORT_CREATED_AT_ASC',
  StackSortCreatedAtDesc = 'STACK_SORT_CREATED_AT_DESC',
  StackSortNameAsc = 'STACK_SORT_NAME_ASC',
  StackSortNameDesc = 'STACK_SORT_NAME_DESC',
  StackSortUnspecified = 'STACK_SORT_UNSPECIFIED',
  StackSortUpdatedAtAsc = 'STACK_SORT_UPDATED_AT_ASC',
  StackSortUpdatedAtDesc = 'STACK_SORT_UPDATED_AT_DESC'
}

export interface StacksBoolEvent {
  __typename?: 'StacksBoolEvent';
  beat: Scalars['Float']['output'];
  value: Scalars['Boolean']['output'];
}

export interface StacksBoolEventInput {
  beat: Scalars['Float']['input'];
  value: Scalars['Boolean']['input'];
}

export interface StacksBoolEventList {
  __typename?: 'StacksBoolEventList';
  events?: Maybe<Array<StacksBoolEvent>>;
}

export interface StacksBoolEventListInput {
  events?: InputMaybe<Array<StacksBoolEventInput>>;
}

export interface StacksBoolProperty {
  __typename?: 'StacksBoolProperty';
  eventList?: Maybe<StacksBoolEventList>;
  value?: Maybe<Scalars['Boolean']['output']>;
}

export interface StacksBoolPropertyInput {
  eventList?: InputMaybe<StacksBoolEventListInput>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
}

export interface StacksClip {
  __typename?: 'StacksClip';
  asset?: Maybe<SampleAsset>;
  assetUuid?: Maybe<Scalars['GUID']['output']>;
  loopStartBeat?: Maybe<Scalars['Float']['output']>;
  loopStopBeat?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourceStartMs?: Maybe<Scalars['Float']['output']>;
  sourceStopMs?: Maybe<Scalars['Float']['output']>;
  userAudioFile?: Maybe<UserAudioFile>;
  userAudioFileHash?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['GUID']['output'];
  version?: Maybe<Scalars['Int']['output']>;
}

export interface StacksClipInput {
  assetUuid?: InputMaybe<Scalars['GUID']['input']>;
  loopStartBeat?: InputMaybe<Scalars['Float']['input']>;
  loopStopBeat?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceStartMs?: InputMaybe<Scalars['Float']['input']>;
  sourceStopMs?: InputMaybe<Scalars['Float']['input']>;
  userAudioFileHash?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['GUID']['input'];
}

export interface StacksClipUpdateInput {
  latestVersion: Scalars['Int']['input'];
  loopStartBeat?: InputMaybe<Scalars['Float']['input']>;
  loopStopBeat?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceStartMs?: InputMaybe<Scalars['Float']['input']>;
  sourceStopMs?: InputMaybe<Scalars['Float']['input']>;
  uuid: Scalars['GUID']['input'];
}

export interface StacksClipsFilterInput {
  hasUserAudio?: InputMaybe<Scalars['Boolean']['input']>;
  usedInStack?: InputMaybe<Scalars['Boolean']['input']>;
  userAudioFileHash?: InputMaybe<Scalars['String']['input']>;
}

export interface StacksClipsPayload {
  __typename?: 'StacksClipsPayload';
  clips?: Maybe<Array<StacksClip>>;
  cursor?: Maybe<StacksCursor>;
}

export interface StacksCursor {
  __typename?: 'StacksCursor';
  nextToken?: Maybe<Scalars['String']['output']>;
  prevToken?: Maybe<Scalars['String']['output']>;
}

export interface StacksDoubleEvent {
  __typename?: 'StacksDoubleEvent';
  beat: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
}

export interface StacksDoubleEventInput {
  beat: Scalars['Float']['input'];
  value: Scalars['Float']['input'];
}

export interface StacksDoubleEventList {
  __typename?: 'StacksDoubleEventList';
  events?: Maybe<Array<StacksDoubleEvent>>;
}

export interface StacksDoubleEventListInput {
  events?: InputMaybe<Array<StacksDoubleEventInput>>;
}

export interface StacksDoubleProperty {
  __typename?: 'StacksDoubleProperty';
  eventList?: Maybe<StacksDoubleEventList>;
  value?: Maybe<Scalars['Float']['output']>;
}

export interface StacksDoublePropertyInput {
  eventList?: InputMaybe<StacksDoubleEventListInput>;
  value?: InputMaybe<Scalars['Float']['input']>;
}

export interface StacksFilterInput {
  bpmMax?: InputMaybe<Scalars['Int']['input']>;
  bpmMin?: InputMaybe<Scalars['Int']['input']>;
  clipUuid?: InputMaybe<Scalars['String']['input']>;
  hasUserAudio?: InputMaybe<Scalars['Boolean']['input']>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  styles?: InputMaybe<Array<Scalars['String']['input']>>;
  userAudioFileHash?: InputMaybe<Scalars['String']['input']>;
}

export interface StacksFloatEvent {
  __typename?: 'StacksFloatEvent';
  beat: Scalars['Float']['output'];
  value: Scalars['Float']['output'];
}

export interface StacksFloatEventInput {
  beat: Scalars['Float']['input'];
  value: Scalars['Float']['input'];
}

export interface StacksFloatEventList {
  __typename?: 'StacksFloatEventList';
  events?: Maybe<Array<StacksFloatEvent>>;
}

export interface StacksFloatEventListInput {
  events?: InputMaybe<Array<StacksFloatEventInput>>;
}

export interface StacksFloatProperty {
  __typename?: 'StacksFloatProperty';
  eventList?: Maybe<StacksFloatEventList>;
  value?: Maybe<Scalars['Float']['output']>;
}

export interface StacksFloatPropertyInput {
  eventList?: InputMaybe<StacksFloatEventListInput>;
  value?: InputMaybe<Scalars['Float']['input']>;
}

export interface StacksIntEvent {
  __typename?: 'StacksIntEvent';
  beat: Scalars['Float']['output'];
  value: Scalars['Int']['output'];
}

export interface StacksIntEventInput {
  beat: Scalars['Float']['input'];
  value: Scalars['Int']['input'];
}

export interface StacksIntEventList {
  __typename?: 'StacksIntEventList';
  events?: Maybe<Array<StacksIntEvent>>;
}

export interface StacksIntEventListInput {
  events?: InputMaybe<Array<StacksIntEventInput>>;
}

export interface StacksIntProperty {
  __typename?: 'StacksIntProperty';
  eventList?: Maybe<StacksIntEventList>;
  value?: Maybe<Scalars['Int']['output']>;
}

export interface StacksIntPropertyInput {
  eventList?: InputMaybe<StacksIntEventListInput>;
  value?: InputMaybe<Scalars['Int']['input']>;
}

export interface StacksPayload {
  __typename?: 'StacksPayload';
  cursor?: Maybe<StacksCursor>;
  stacks?: Maybe<Array<DbStack>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
}

export interface StacksSection {
  __typename?: 'StacksSection';
  name?: Maybe<Scalars['String']['output']>;
  numBars?: Maybe<Scalars['Int']['output']>;
  sectionStacks: Array<StacksSectionStack>;
  /** @deprecated Use 'section_stacks' instead */
  sections?: Maybe<Array<StacksSection>>;
  /** @deprecated Use 'section_stacks' instead */
  stackUuid?: Maybe<Scalars['GUID']['output']>;
  uuid: Scalars['GUID']['output'];
}

export interface StacksSectionInput {
  name?: InputMaybe<Scalars['String']['input']>;
  numBars?: InputMaybe<Scalars['Int']['input']>;
  sectionStacks?: InputMaybe<Array<StacksSectionStackInput>>;
  /** @deprecated Use `section_stacks` instead */
  sections?: InputMaybe<Array<StacksSectionInput>>;
  /** @deprecated Use `section_stacks` instead */
  stackUuid?: InputMaybe<Scalars['GUID']['input']>;
  uuid: Scalars['GUID']['input'];
}

export interface StacksSectionStack {
  __typename?: 'StacksSectionStack';
  name?: Maybe<Scalars['String']['output']>;
  numBars?: Maybe<Scalars['Int']['output']>;
  stack?: Maybe<Stack>;
  stackUuid: Scalars['GUID']['output'];
  uuid: Scalars['GUID']['output'];
}

export interface StacksSectionStackInput {
  name?: InputMaybe<Scalars['String']['input']>;
  numBars?: InputMaybe<Scalars['Int']['input']>;
  stackUuid: Scalars['GUID']['input'];
  uuid: Scalars['GUID']['input'];
}

export interface StacksSession {
  __typename?: 'StacksSession';
  bpm?: Maybe<Scalars['Float']['output']>;
  clipUuids?: Maybe<Array<Scalars['GUID']['output']>>;
  clips?: Maybe<Array<StacksClip>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  ownerUuid?: Maybe<Scalars['GUID']['output']>;
  sections?: Maybe<Array<StacksSection>>;
  stackUuids?: Maybe<Array<Scalars['GUID']['output']>>;
  stacks?: Maybe<Array<Stack>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
  version?: Maybe<Scalars['Int']['output']>;
}

export interface StacksSessionInput {
  bpm?: InputMaybe<Scalars['Float']['input']>;
  clipUuids?: InputMaybe<Array<Scalars['GUID']['input']>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerUuid?: InputMaybe<Scalars['GUID']['input']>;
  sections?: InputMaybe<Array<StacksSectionInput>>;
  stackUuids?: InputMaybe<Array<Scalars['GUID']['input']>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  uuid: Scalars['GUID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
}

export interface StacksSessionsPayload {
  __typename?: 'StacksSessionsPayload';
  cursor?: Maybe<StacksCursor>;
  sessions?: Maybe<Array<StacksSession>>;
}

export interface StacksTypeMetadata {
  __typename?: 'StacksTypeMetadata';
  exportTypes?: Maybe<Array<StackExportType>>;
}

export enum SubscriptionAction {
  Cancel = 'cancel',
  Convert = 'convert',
  ConvertDowngrade = 'convert_downgrade',
  ConvertUpgrade = 'convert_upgrade',
  Downgrade = 'downgrade',
  Pause = 'pause',
  Purchase = 'purchase',
  Trial = 'trial',
  Uncancel = 'uncancel',
  UncancelDowngrade = 'uncancel_downgrade',
  UncancelUpgrade = 'uncancel_upgrade',
  Unpause = 'unpause',
  Upgrade = 'upgrade'
}

export interface SubscriptionResponse {
  __typename?: 'SubscriptionResponse';
  items?: Maybe<Array<Maybe<PlanSubscription>>>;
}

export enum SubscriptionState {
  Active = 'active',
  CancellationScheduled = 'cancellation_scheduled',
  Cancelled = 'cancelled',
  New = 'new',
  PastDue = 'past_due',
  PauseScheduled = 'pause_scheduled',
  Paused = 'paused',
  Processing = 'processing',
  Trial = 'trial',
  TrialCancellationScheduled = 'trial_cancellation_scheduled',
  TrialCancelled = 'trial_cancelled'
}

export interface SwapStackLayerV2Result {
  __typename?: 'SwapStackLayerV2Result';
  layers?: Maybe<Array<Maybe<StackLayer>>>;
  stackKey?: Maybe<StackKey>;
}

export interface SyncDiscordRoleWithSubscriptionResult {
  __typename?: 'SyncDiscordRoleWithSubscriptionResult';
  discordUsername?: Maybe<Scalars['String']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
}

export interface Tag {
  __typename?: 'Tag';
  /** If this Tag has child Tags */
  has_children?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  parent_label?: Maybe<Scalars['String']['output']>;
  parent_uuid?: Maybe<Scalars['String']['output']>;
  parents?: Maybe<Array<Maybe<Tag>>>;
  status?: Maybe<PublishState>;
  /** The paginated child Tags of this Tag */
  tags?: Maybe<TagPage>;
  /** The Taxonomy this tag is a part of. */
  taxonomy?: Maybe<Taxonomy>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
}


export interface TagTagsArgs {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}

/**
 * Object used to define the tags in a taxonomy associated
 * with a foreign object defined in the taxonomy api
 */
export interface TagBranch {
  __typename?: 'TagBranch';
  items?: Maybe<Array<Maybe<Tag>>>;
  taxonomy?: Maybe<Taxonomy>;
}

/**
 * A `TagCategory` is a grouping of tags that have something in common.
 * They are usually displayed together in a list, and have a descriptive name,
 * an optional parent tag, and a list of tags.
 *
 * Examples:
 * {
 *   name: 'Cinematic / FX',
 *   tags: [
 *     { label: 'whoosh' },
 *     { label: 'riser' }
 *   ]
 * }
 *
 * {
 *   name: 'Drums',
 *   parent: { label: 'drums' },
 *   tags: [
 *     { label: 'snare' },
 *     { label: 'kick' }
 *   ]
 * }
 */
export interface TagCategory {
  __typename?: 'TagCategory';
  altDescription?: Maybe<Scalars['String']['output']>;
  altName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Tag>;
  permalink: Scalars['String']['output'];
  subcategories?: Maybe<Array<TagCategory>>;
  tags: Array<Tag>;
  uuid: Scalars['String']['output'];
}

/**
 * A `TagCategoryList` is a list of `TagCategory` items, usually
 * grouped around a theme e.g "Instrument" or "Genre".
 *
 * The list can optionally include a `Taxonomy`.
 */
export interface TagCategoryList {
  __typename?: 'TagCategoryList';
  categories: Array<TagCategory>;
  name: Scalars['String']['output'];
  permalink_slug: Scalars['String']['output'];
  taxonomy?: Maybe<Taxonomy>;
  uuid: Scalars['String']['output'];
}

export interface TagInput {
  label?: InputMaybe<Scalars['String']['input']>;
  parent_uuid?: InputMaybe<Scalars['GUID']['input']>;
  status?: InputMaybe<PublishState>;
  taxonomy_uuid?: InputMaybe<Scalars['GUID']['input']>;
  uuid?: InputMaybe<Scalars['GUID']['input']>;
}

export interface TagPage {
  __typename?: 'TagPage';
  items?: Maybe<Array<Maybe<Tag>>>;
  response_metadata?: Maybe<ResponseMetadata>;
}

/**
 * TagPageMetadata is pulling data from the hardcoded category route list mock if the 'tagId' passed
 * has already been attributed to a Tag Category as defined in Tag-category-list-v2.
 *
 * This is used on the /tag landing page to reroute if a tag already belongs to another Tag Category, such as 'Genre' or 'Instruments'
 */
export interface TagPageMetadata {
  __typename?: 'TagPageMetadata';
  label: Scalars['String']['output'];
  productLandingPagePermalink?: Maybe<Scalars['String']['output']>;
}

/** Information about how a tag is applied through the system */
export interface TagSummary {
  __typename?: 'TagSummary';
  /** The number of entities in the system with the associated tag applied */
  count?: Maybe<Scalars['Int']['output']>;
  /** The tag */
  tag?: Maybe<Tag>;
  tagUuid?: Maybe<Scalars['GUID']['output']>;
  /**
   * The UUID of the tag
   * @deprecated use tagUuid
   */
  tag_uuid?: Maybe<Scalars['GUID']['output']>;
}

/** Input required to bulk edit tags in the taxonomy api on foreign objects based on UUID */
export interface TaggedEntitiesInput {
  entity_type?: InputMaybe<Scalars['String']['input']>;
  entity_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
  operation_name?: InputMaybe<TaggedEntityOperation>;
  tag_uuids?: InputMaybe<Array<InputMaybe<Scalars['GUID']['input']>>>;
}

/** Represents a foreign object in the taxonomy api that has has tags associated with it */
export interface TaggedEntity {
  __typename?: 'TaggedEntity';
  entity_type?: Maybe<Scalars['String']['output']>;
  entity_uuid?: Maybe<Scalars['GUID']['output']>;
  tag_branches?: Maybe<Array<Maybe<TagBranch>>>;
}

/**
 * These are enums used to bulk edit tags
 * - add: add provided tag UUIDs to provided asset UUIDs
 * - remove: remove provided tag UUIDs from provided asset UUIDs
 * - remove_all: remove all from provided asset UUIDs
 */
export enum TaggedEntityOperation {
  Add = 'add',
  Remove = 'remove',
  RemoveAll = 'remove_all'
}

export interface TaxPreview {
  __typename?: 'TaxPreview';
  currency?: Maybe<Scalars['String']['output']>;
  pricing_model?: Maybe<Scalars['String']['output']>;
  recurly_account_code?: Maybe<Scalars['String']['output']>;
  subtotal_in_cents?: Maybe<Scalars['Int']['output']>;
  tax_in_cents?: Maybe<Scalars['Int']['output']>;
  tax_rate?: Maybe<Scalars['Int']['output']>;
  tax_region?: Maybe<Scalars['String']['output']>;
  tax_type?: Maybe<Scalars['String']['output']>;
  total_amount_in_cents?: Maybe<Scalars['Int']['output']>;
  unit_amount_in_cents?: Maybe<Scalars['Int']['output']>;
}

export interface Taxonomy {
  __typename?: 'Taxonomy';
  count?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Paged tags within a taxonomy */
  tags?: Maybe<TagPage>;
  type?: Maybe<TaxonomyType>;
  /** Formatted as `2020-04-24T12:06:01.753Z` */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['GUID']['output']>;
}


export interface TaxonomyTagsArgs {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<SortOrder>;
  pending?: InputMaybe<Scalars['Boolean']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}

/** Input values used when creating a brand new Taxonomy. */
export interface TaxonomyCreateInput {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  taxonomy_type_id?: InputMaybe<Scalars['Int']['input']>;
}

/** Paged subset of Taxonomy objects */
export interface TaxonomyPage {
  __typename?: 'TaxonomyPage';
  items?: Maybe<Array<Maybe<Taxonomy>>>;
  response_metadata?: Maybe<ResponseMetadata>;
}

/** Paged subset of Taxonomy objects */
export interface TaxonomySync {
  __typename?: 'TaxonomySync';
  version?: Maybe<Scalars['Int']['output']>;
}

/** Paged subset of Taxonomy objects */
export interface TaxonomySyncDiff {
  __typename?: 'TaxonomySyncDiff';
  tags?: Maybe<Array<Maybe<Tag>>>;
  version?: Maybe<Scalars['Int']['output']>;
}

export interface TaxonomyType {
  __typename?: 'TaxonomyType';
  display_name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid?: Maybe<Scalars['GUID']['output']>;
}

export enum Theme {
  Dark = 'dark',
  Light = 'light'
}

export interface TransformedContentGroup {
  __typename?: 'TransformedContentGroup';
  description?: Maybe<Scalars['String']['output']>;
  entries?: Maybe<Array<Maybe<TransformedContentGroupEntry>>>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
}

export interface TransformedContentGroupEntry {
  __typename?: 'TransformedContentGroupEntry';
  caption?: Maybe<Scalars['String']['output']>;
  collection?: Maybe<CollectionAsset>;
  collection_uuid?: Maybe<Scalars['String']['output']>;
  main_image_url?: Maybe<Scalars['String']['output']>;
  mobile_image_url?: Maybe<Scalars['String']['output']>;
  pack?: Maybe<PackAsset>;
  pack_uuid?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface TransformedContentGroupsMetadata {
  __typename?: 'TransformedContentGroupsMetadata';
  page_slug?: Maybe<Scalars['String']['output']>;
}

export interface TransformedContentGroupsWithMetadata {
  __typename?: 'TransformedContentGroupsWithMetadata';
  groups?: Maybe<Array<TransformedContentGroup>>;
  metadata: TransformedContentGroupsMetadata;
}

export enum UgcFileType {
  Mp3 = 'MP3',
  Wav = 'WAV'
}

export interface UpdateAssetResponse {
  __typename?: 'UpdateAssetResponse';
  asset: AnyAsset;
  publishResult?: Maybe<PublishResponse>;
}

export enum UpdateMode {
  Add = 'add',
  Remove = 'remove',
  Replace = 'replace'
}

export interface UpdateUserPersonalizationProfileInput {
  experienceLevel?: InputMaybe<UserProficiency>;
  genreAffinities?: InputMaybe<Array<Scalars['String']['input']>>;
  musicGoals?: InputMaybe<Array<UserMusicGoal>>;
  preferredDaws?: InputMaybe<Array<UserPreferredDaw>>;
  subgenreAffinities?: InputMaybe<Array<Scalars['String']['input']>>;
  userArchetypes?: InputMaybe<Array<Scalars['String']['input']>>;
}

export interface UpdateWalletPaymentMethodInput {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
}

export interface User {
  __typename?: 'User';
  avatar_url?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  extendedAttributes?: Maybe<UserExtendedAttributes>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<UserStatus>;
  username?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['GUID']['output']>;
}

export interface UserAudioFile {
  __typename?: 'UserAudioFile';
  bpm?: Maybe<Scalars['Int']['output']>;
  downloadUrl?: Maybe<Scalars['String']['output']>;
  durationMs?: Maybe<Scalars['Int']['output']>;
  fileHash: Scalars['String']['output'];
  numBars?: Maybe<Scalars['Int']['output']>;
  originalFilename: Scalars['String']['output'];
  sampleFamilySlug?: Maybe<Scalars['String']['output']>;
  size: Scalars['Int']['output'];
  userUuid: Scalars['GUID']['output'];
  uuid: Scalars['GUID']['output'];
  waveformUrl?: Maybe<Scalars['String']['output']>;
}

export interface UserAudioFileInput {
  fileHash?: InputMaybe<Scalars['String']['input']>;
  uuid?: InputMaybe<Scalars['GUID']['input']>;
}

export enum UserAudioFileSource {
  DawPlugin = 'daw_plugin',
  DesktopCreate = 'desktop_create',
  MobileMicCapture = 'mobile_mic_capture',
  WebCreate = 'web_create'
}

export interface UserAudioFilesPayload {
  __typename?: 'UserAudioFilesPayload';
  totalCount?: Maybe<Scalars['Int']['output']>;
  userAudioFiles?: Maybe<Array<UserAudioFile>>;
}

export interface UserAudioStorageData {
  __typename?: 'UserAudioStorageData';
  numFilesStored: Scalars['Int']['output'];
  totalStorage: Scalars['Float']['output'];
  usedStorage: Scalars['Float']['output'];
}

export interface UserAudioUploadJob {
  __typename?: 'UserAudioUploadJob';
  createdAt: Scalars['DateTime']['output'];
  /** If a job has a status of `complete`, a signed download URL is returned */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  fileHash: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  jobUuid: Scalars['String']['output'];
  status: UserAudioUploadJobStatus;
  updatedAt: Scalars['DateTime']['output'];
  userUuid: Scalars['String']['output'];
}

export enum UserAudioUploadJobStatus {
  Completed = 'completed',
  FileTooLarge = 'file_too_large',
  InternalError = 'internal_error',
  InvalidBpm = 'invalid_bpm',
  InvalidMimeType = 'invalid_mime_type',
  Processing = 'processing',
  Quarantined = 'quarantined',
  StorageLimitExceeded = 'storage_limit_exceeded',
  UploadPending = 'upload_pending',
  ValidationFailed = 'validation_failed'
}

export interface UserAudioUploadUrl {
  __typename?: 'UserAudioUploadUrl';
  jobUuid: Scalars['String']['output'];
  uploadUrl: Scalars['String']['output'];
}

export interface UserExtendedAttributes {
  __typename?: 'UserExtendedAttributes';
  channel?: Maybe<Scalars['String']['output']>;
  client_installed?: Maybe<Scalars['Boolean']['output']>;
  credits?: Maybe<Scalars['Int']['output']>;
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  features?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  hasSkills?: Maybe<Scalars['Boolean']['output']>;
  has_cc?: Maybe<Scalars['Boolean']['output']>;
  identities?: Maybe<Array<Maybe<UserIdentity>>>;
  location?: Maybe<Scalars['String']['output']>;
  pubnub_key?: Maybe<Scalars['String']['output']>;
  sounds?: Maybe<Scalars['Boolean']['output']>;
  sounds_plan?: Maybe<Scalars['Int']['output']>;
  sounds_state?: Maybe<Scalars['String']['output']>;
  tos?: Maybe<Scalars['Boolean']['output']>;
  username_last_updated_at?: Maybe<Scalars['String']['output']>;
  xsfr?: Maybe<Scalars['String']['output']>;
  xsrf?: Maybe<Scalars['String']['output']>;
}

export interface UserIdentity {
  __typename?: 'UserIdentity';
  account_id?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_uuid?: Maybe<Scalars['String']['output']>;
}

export enum UserMusicGoal {
  AspiringIncome = 'aspiring_income',
  Hobby = 'hobby',
  PrimaryIncome = 'primary_income',
  SupplementalIncome = 'supplemental_income'
}

export interface UserPersonalizationProfile {
  __typename?: 'UserPersonalizationProfile';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  experienceLevel?: Maybe<UserProficiency>;
  genreAffinities?: Maybe<Array<Scalars['String']['output']>>;
  musicGoals?: Maybe<Array<UserMusicGoal>>;
  preferredDaws?: Maybe<Array<UserPreferredDaw>>;
  subgenreAffinities?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userArchetypes?: Maybe<Array<Scalars['String']['output']>>;
  userUuid: Scalars['String']['output'];
}

export enum UserPreferredDaw {
  Ableton = 'ableton',
  Bandlab = 'bandlab',
  BitwigStudio = 'bitwig_studio',
  Cubase = 'cubase',
  FlStudio = 'fl_studio',
  GarageBand = 'garage_band',
  LogicPro = 'logic_pro',
  None = 'none',
  Other = 'other',
  ProTools = 'pro_tools',
  Reaper = 'reaper',
  Reason = 'reason',
  StudioOne = 'studio_one'
}

export enum UserProficiency {
  Hobbyist = 'hobbyist',
  New = 'new',
  Professional = 'professional',
  Unspecified = 'unspecified'
}

export interface UserStatus {
  __typename?: 'UserStatus';
  client_installed?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated studio removal */
  collaboration_count?: Maybe<Scalars['Int']['output']>;
  dismissed?: Maybe<Dismissables>;
  has_trialed_before?: Maybe<Scalars['Boolean']['output']>;
  previous_sounds_subscriber?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated studio removal */
  project_count?: Maybe<Scalars['Int']['output']>;
  signup_date?: Maybe<Scalars['String']['output']>;
}

/** Input values used when updating User. */
export interface UserUpdateInput {
  avatar?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  uuid: Scalars['GUID']['input'];
}

export interface V2Project {
  __typename?: 'V2Project';
  artwork_url?: Maybe<Scalars['URL']['output']>;
  collaborators?: Maybe<Array<Maybe<LegacyStudioUser>>>;
  creator?: Maybe<LegacyStudioUser>;
  daw?: Maybe<Scalars['String']['output']>;
  daw_version?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  latest_revision?: Maybe<LegacyStudioRevision>;
  name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['GUID']['output']>;
}

export interface V2ProjectManifest {
  __typename?: 'V2ProjectManifest';
  collaboration?: Maybe<Scalars['Boolean']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  creator_id?: Maybe<Scalars['Int']['output']>;
  effective_revision_mtime?: Maybe<Scalars['String']['output']>;
  files?: Maybe<LegacyStudioProjectFileCollection>;
  is_newly_spliced?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  previous_revision_uuid?: Maybe<Scalars['GUID']['output']>;
  project_type?: Maybe<Scalars['String']['output']>;
  revision_mtime?: Maybe<Scalars['String']['output']>;
  revision_uuid?: Maybe<Scalars['GUID']['output']>;
  total_size?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['GUID']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
}

export interface V2User {
  __typename?: 'V2User';
  avatar_background_url?: Maybe<Scalars['String']['output']>;
  avatar_url?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  follower_count?: Maybe<Scalars['Int']['output']>;
  following_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  release_like_count?: Maybe<Scalars['Int']['output']>;
  release_play_count?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['GUID']['output']>;
}

export interface VideoAsset extends IAsset, IAssetChild {
  __typename?: 'VideoAsset';
  activities?: Maybe<Array<Maybe<AssetActivity>>>;
  allowed_asset_type_child?: Maybe<Array<Maybe<AssetType>>>;
  /** Asset Visibility Slug will be used to represent the visibility status of a video */
  asset_access_type_slug?: Maybe<AssetAccessTypeSlug>;
  /** Asset Category Slug defines the kind of video */
  asset_category_slug?: Maybe<AssetCategorySlug>;
  asset_devices?: Maybe<Array<Maybe<AssetDevice>>>;
  asset_prices?: Maybe<Array<Maybe<Price>>>;
  asset_status_slug?: Maybe<AssetStatusSlug>;
  asset_type?: Maybe<AssetType>;
  asset_type_slug?: Maybe<AssetTypeSlug>;
  /** Eg. if an asset is rare */
  attributes?: Maybe<Array<AssetAttributeSlug>>;
  /** Eg, if asset is eligible for Presonus free bundled content */
  bundled_content_daws?: Maybe<Array<AssetBundledContentDawSlug>>;
  created_at?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated replacing with asset_devices */
  devices?: Maybe<Array<Maybe<IDevice>>>;
  duration?: Maybe<Scalars['Int']['output']>;
  file?: Maybe<AssetFile>;
  files?: Maybe<Array<AssetFile>>;
  /** Ingestion issues associated with the asset. */
  ingestion_issues?: Maybe<AssetIngestionIssues>;
  instructor_uuids?: Maybe<Array<Maybe<Scalars['GUID']['output']>>>;
  /** Instructor will be used to represent the instructors */
  instructors?: Maybe<Array<Maybe<Instructor>>>;
  legacy_permalink?: Maybe<Scalars['String']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  marketplace_status_slug?: Maybe<MarketplaceStatusSlug>;
  name?: Maybe<Scalars['String']['output']>;
  /**
   * This must be here because Video extends the IAssetChild interface, so it must have this field.
   * In practice, this will never be used because videos don't come in packs.
   */
  pack_parent?: Maybe<PackAsset>;
  parent_asset_counts?: Maybe<Array<Maybe<RelatedAssetsCounts>>>;
  parent_asset_uuids?: Maybe<Array<Maybe<Scalars['GUID']['output']>>>;
  parents?: Maybe<AssetPage>;
  permalink_base_url?: Maybe<Scalars['String']['output']>;
  permalink_slug?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  provider_sku?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['GUID']['output']>;
  /** Public will be used to represent videos that are free to all */
  public?: Maybe<Scalars['Boolean']['output']>;
  similar_assets?: Maybe<AssetPage>;
  tags?: Maybe<Array<Maybe<Tag>>>;
  /** Trial will be used to represent whether the video is available only to trial members */
  trial?: Maybe<Scalars['Boolean']['output']>;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  uuid: Scalars['GUID']['output'];
}


export interface VideoAssetFileArgs {
  type?: InputMaybe<AssetFileTypeSlug>;
}


export interface VideoAssetParentsArgs {
  filter: AssetFiltersInput;
  pagination?: InputMaybe<CursorPaginationInput>;
  sort?: InputMaybe<AssetSortInput>;
}


export interface VideoAssetSimilar_AssetsArgs {
  asset_type_slug: SimilarAssetTypeSlug;
  limit?: InputMaybe<Scalars['Int']['input']>;
}

/** The "public" representation of a pack coming out of the Legacy API. */
export interface WwwCollection {
  __typename?: 'WWWCollection';
  asset_uuid?: Maybe<Scalars['String']['output']>;
  cover_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  demo_mp3_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  owned?: Maybe<Scalars['Boolean']['output']>;
  pack_count?: Maybe<Scalars['Int']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  subscribers_subset?: Maybe<Array<Maybe<User>>>;
  subscription_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
}

/** The "public" representation of a pack coming out of the Legacy API. */
export interface WwwPack {
  __typename?: 'WWWPack';
  asset_uuid?: Maybe<Scalars['String']['output']>;
  banner_url?: Maybe<Scalars['URL']['output']>;
  cover_url?: Maybe<Scalars['URL']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  current_global_chart_pos?: Maybe<Scalars['Int']['output']>;
  current_label_chart_pos?: Maybe<Scalars['Int']['output']>;
  demo_mp3_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Int']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  last_global_chart_pos?: Maybe<Scalars['Int']['output']>;
  last_label_chart_pos?: Maybe<Scalars['Int']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  loops_count?: Maybe<Scalars['Int']['output']>;
  main_genre?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  one_shots_count?: Maybe<Scalars['Int']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  popularity?: Maybe<Scalars['String']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  presets?: Maybe<Scalars['JSON']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  provider_permalink?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['ID']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  published_at?: Maybe<Scalars['String']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  samples?: Maybe<Scalars['JSON']['output']>;
  tag_stats?: Maybe<Scalars['JSON']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated_at?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['ID']['output']>;
}

export interface WalletPaymentMethodAssignment {
  __typename?: 'WalletPaymentMethodAssignment';
  type: PaymentMethodAssignmentType;
  uuid: Scalars['ID']['output'];
}

/** A single subscription or lease to move to another payment method. */
export interface WalletPaymentMethodAssignmentInput {
  type: PaymentMethodAssignmentType;
  uuid: Scalars['ID']['input'];
}

export type WorkflowCard = PlanCard | SanityMultiMediaTextBlock;

export interface WwwContentGroups {
  __typename?: 'WwwContentGroups';
  groups?: Maybe<Array<Maybe<ContentGroup>>>;
}

export interface WwwCreditCardTransaction {
  __typename?: 'WwwCreditCardTransaction';
  brand?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
}

export interface WwwGearDetails {
  __typename?: 'WwwGearDetails';
  created_at: Scalars['String']['output'];
  /** @deprecated use portable text from product_overview_content instead */
  description: Scalars['String']['output'];
  discount_text: Scalars['String']['output'];
  edition_level: Scalars['String']['output'];
  editions?: Maybe<Array<Maybe<GearEdition>>>;
  features?: Maybe<Array<Maybe<GearMedia>>>;
  /** @deprecated use product.full_price */
  full_price: Scalars['Int']['output'];
  gallery?: Maybe<Array<Maybe<GearMedia>>>;
  has_upgrade: Scalars['Boolean']['output'];
  highlights?: Maybe<Array<Maybe<GearFeatureHighlights>>>;
  included_components?: Maybe<Array<Maybe<GearComponent>>>;
  included_in?: Maybe<Array<Maybe<GearComponent>>>;
  /** @deprecated use product.installment_price */
  installment_price: Scalars['Int']['output'];
  marketing: GearSeo;
  marketing_opt_in: Scalars['Boolean']['output'];
  mini_features?: Maybe<GearMiniFeatures>;
  name: Scalars['String']['output'];
  plugin: PluginDescription;
  plugin_description_id: Scalars['Int']['output'];
  plugin_seller_code: Scalars['String']['output'];
  product?: Maybe<ProductRtoPlugin>;
  product_overview_content: Array<Scalars['JSON']['output']>;
  specifications: GearSpecifications;
  testimonials?: Maybe<Array<Maybe<GearImage>>>;
  /** @deprecated use product.total_installments */
  total_installments: Scalars['Int']['output'];
  /** @deprecated use product.trial_length_days */
  trial_period_days: Scalars['Int']['output'];
  uuid: Scalars['GUID']['output'];
}

export interface WwwGenre {
  __typename?: 'WwwGenre';
  bpm_high?: Maybe<Scalars['Int']['output']>;
  bpm_low?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  genres_influenced?: Maybe<Array<InfluenceGenre>>;
  genres_influenced_by?: Maybe<Array<InfluenceGenre>>;
  id: Scalars['ID']['output'];
  locations?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name: Scalars['String']['output'];
  permalink?: Maybe<Scalars['String']['output']>;
  seo_description?: Maybe<Scalars['String']['output']>;
  uuid: Scalars['GUID']['output'];
  year?: Maybe<Scalars['Int']['output']>;
}

export interface WwwLeasablePluginPayload {
  created_at: Scalars['Int']['output'];
  essential_rto_carousel_index: Scalars['Int']['output'];
  plugin: PluginDescription;
}

export interface WwwMeReleasesLiked {
  __typename?: 'WwwMeReleasesLiked';
  releases?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
}

export interface WwwPaypalTransaction {
  __typename?: 'WwwPaypalTransaction';
  email?: Maybe<Scalars['String']['output']>;
}

export interface WwwPlugin {
  __typename?: 'WwwPlugin';
  background_url?: Maybe<Scalars['String']['output']>;
  canonical_path?: Maybe<Scalars['String']['output']>;
  canonical_url: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  gear_details?: Maybe<WwwGearDetails>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  is_daw?: Maybe<Scalars['Boolean']['output']>;
  is_free: Scalars['Boolean']['output'];
  manufacturer: Manufacturer;
  name: Scalars['String']['output'];
  prerelease?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  purchase_type?: Maybe<PurchaseType>;
  retail_url?: Maybe<Scalars['String']['output']>;
  screenshot_url: Scalars['String']['output'];
  seller_code: Scalars['String']['output'];
  tag_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  thumbnail_url: Scalars['String']['output'];
  types: Array<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
}

export interface WwwPluginAdvertisement {
  __typename?: 'WwwPluginAdvertisement';
  alt: Scalars['String']['output'];
  product: WwwPlugin;
  src: Scalars['String']['output'];
  src_2x: Scalars['String']['output'];
  src_mobile: Scalars['String']['output'];
  src_mobile_2x: Scalars['String']['output'];
}

export interface WwwPluginLease {
  __typename?: 'WwwPluginLease';
  extras?: Maybe<Array<PluginExtra>>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  installment_price: Scalars['Int']['output'];
  installments_paid: Scalars['Int']['output'];
  /**
   * True when this lease came from upgrading an earlier one. Upgraded leases
   * carry their history in `lease_info`, and the flat installment fields above
   * describe only the newest segment — see `lease_info` before showing money.
   */
  is_upgrade?: Maybe<Scalars['Boolean']['output']>;
  leasable_plugin?: Maybe<LeaseData>;
  /**
   * One entry per lease in an upgrade chain, oldest last. Present only for
   * upgraded leases. Remaining balance and months-to-go must be summed across
   * every entry: the top-level `remaining_installments` and `installment_price`
   * cover the newest segment alone and understate what the user still owes.
   */
  lease_info?: Maybe<Array<LeaseInfo>>;
  /**
   * When the lease was paid in full. Null while installments are still owed.
   * An upgrade of a paid-off lease bills the account default rather than the
   * lease's own payment method.
   */
  paid_off_at?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<PaymentMethod>;
  payment_method_uuid?: Maybe<Scalars['ID']['output']>;
  period_end_at: Scalars['String']['output'];
  plugin?: Maybe<PluginInfo>;
  plugin_display_name: Scalars['String']['output'];
  remaining_installments: Scalars['Int']['output'];
  state?: Maybe<Scalars['String']['output']>;
  total_installments: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
}

/**
 * A plugin manufacturer and one page of its plugins. Backs the web-svelte
 * /plugins/manufacturers/:name page.
 */
export interface WwwPluginManufacturer {
  __typename?: 'WwwPluginManufacturer';
  canonical_path?: Maybe<Scalars['String']['output']>;
  canonical_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  logo_url?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /**
   * Total plugins for this manufacturer, reduced by any hidden or prerelease
   * plugins filtered out of the requested page.
   */
  plugin_count: Scalars['Int']['output'];
  plugins: Array<WwwPlugin>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface WwwPluginSearchTag {
  __typename?: 'WwwPluginSearchTag';
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
}

export interface WwwPluginsSearchResult {
  __typename?: 'WwwPluginsSearchResult';
  matching_tags: Array<WwwPluginSearchTag>;
  plugins: Array<WwwPlugin>;
  total_hits: Scalars['Int']['output'];
}

/** A provider (label) as represented by the Legacy API. */
export interface WwwPremiumProvider {
  __typename?: 'WwwPremiumProvider';
  catalog_uuid?: Maybe<Scalars['String']['output']>;
  current_provider_chart_position: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  facebook_url?: Maybe<Scalars['String']['output']>;
  image_path: Scalars['String']['output'];
  last_provider_chart_position: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pack_count: Scalars['Int']['output'];
  permalink: Scalars['String']['output'];
  tags?: Maybe<Array<Scalars['String']['output']>>;
  twitter_url?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
}

export interface WwwSoundsCustomPack {
  __typename?: 'WwwSoundsCustomPack';
  matching_packs?: Maybe<Array<Maybe<WwwSoundsCustomPackMatchingPack>>>;
  matching_tags?: Maybe<Scalars['JSON']['output']>;
  samples?: Maybe<Array<Maybe<WwwSoundsCustomPackSample>>>;
  set?: Maybe<WwwSoundsCustomPackSet>;
  total_hits?: Maybe<Scalars['Int']['output']>;
}

export interface WwwSoundsCustomPackMatchingPack {
  __typename?: 'WwwSoundsCustomPackMatchingPack';
  banner_url?: Maybe<Scalars['String']['output']>;
  cover_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Int']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  main_genre?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
}

export interface WwwSoundsCustomPackSample {
  __typename?: 'WwwSoundsCustomPackSample';
  dir?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  file_hash?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  pack?: Maybe<WwwSoundsCustomPackSamplePack>;
  popularity?: Maybe<Scalars['Int']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  provider_permalink?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  published_at?: Maybe<Scalars['String']['output']>;
  sample_type?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  trending?: Maybe<Scalars['Int']['output']>;
  waveform_url?: Maybe<Scalars['String']['output']>;
}

export interface WwwSoundsCustomPackSamplePack {
  __typename?: 'WwwSoundsCustomPackSamplePack';
  banner_url?: Maybe<Scalars['String']['output']>;
  cover_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Int']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  main_genre?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
}

/** set is another name for collection or repack */
export interface WwwSoundsCustomPackSet {
  __typename?: 'WwwSoundsCustomPackSet';
  cover_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<WwwSoundsCustomPackSetCreator>;
  demo_mp3_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pack_count?: Maybe<Scalars['Int']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  public?: Maybe<Scalars['Boolean']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  subscribers_subset?: Maybe<Array<Maybe<WwwSoundsCustomPackSetSubscribersSubset>>>;
  subscription_count?: Maybe<Scalars['Int']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
}

export interface WwwSoundsCustomPackSetCreator {
  __typename?: 'WwwSoundsCustomPackSetCreator';
  avatar_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
}

export interface WwwSoundsCustomPackSetSubscribersSubset {
  __typename?: 'WwwSoundsCustomPackSetSubscribersSubset';
  avatar_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
}

export interface WwwSoundsPack {
  __typename?: 'WwwSoundsPack';
  banner_url?: Maybe<Scalars['String']['output']>;
  companion_pack_group?: Maybe<WwwSoundsPackCompanionPackGroup>;
  cover_url?: Maybe<Scalars['String']['output']>;
  demo_mp3_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Array<Maybe<WwwSoundsPackExtra>>>;
  featured?: Maybe<Scalars['Int']['output']>;
  liked?: Maybe<Scalars['Boolean']['output']>;
  loops_count?: Maybe<Scalars['Int']['output']>;
  main_genre?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  one_shots_count?: Maybe<Scalars['Int']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  presets?: Maybe<Array<Maybe<WwwwSoundsPackPreset>>>;
  provider_name?: Maybe<Scalars['String']['output']>;
  provider_permalink?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['String']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  samples?: Maybe<Array<Maybe<WwwSoundsPackSample>>>;
  story?: Maybe<WwwSoundsPackStory>;
  tag_stats?: Maybe<Scalars['JSON']['output']>;
  uuid: Scalars['String']['output'];
}

export interface WwwSoundsPackCompanionPack {
  __typename?: 'WwwSoundsPackCompanionPack';
  pack?: Maybe<WwwSoundsPackCompanionPackData>;
}

export interface WwwSoundsPackCompanionPackData {
  __typename?: 'WwwSoundsPackCompanionPackData';
  cover_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Int']['output']>;
  main_genre?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
}

export interface WwwSoundsPackCompanionPackGroup {
  __typename?: 'WwwSoundsPackCompanionPackGroup';
  members?: Maybe<Array<Maybe<WwwSoundsPackCompanionPack>>>;
  parent_pack?: Maybe<WwwSoundsPackCompanionPack>;
}

export interface WwwSoundsPackCost {
  __typename?: 'WwwSoundsPackCost';
  credits: Scalars['Int']['output'];
}

export interface WwwSoundsPackExtra {
  __typename?: 'WwwSoundsPackExtra';
  description?: Maybe<Scalars['String']['output']>;
  licensed?: Maybe<Scalars['Boolean']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
}

export interface WwwSoundsPackSample {
  __typename?: 'WwwSoundsPackSample';
  audio_key?: Maybe<Scalars['String']['output']>;
  bpm?: Maybe<Scalars['Int']['output']>;
  dir?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  file_hash?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  genre?: Maybe<Scalars['String']['output']>;
  pack?: Maybe<WwwSoundsPackSoundPack>;
  popularity?: Maybe<Scalars['Int']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  provider_permalink?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  published_at?: Maybe<Scalars['String']['output']>;
  sample_type?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  trending?: Maybe<Scalars['Int']['output']>;
  waveform_url?: Maybe<Scalars['String']['output']>;
}

export interface WwwSoundsPackSoundPack {
  __typename?: 'WwwSoundsPackSoundPack';
  banner_url?: Maybe<Scalars['String']['output']>;
  cover_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Int']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  main_genre?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
}

export interface WwwSoundsPackStory {
  __typename?: 'WwwSoundsPackStory';
  background_url?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
  videos?: Maybe<Array<Maybe<WwwSoundsPackStoryVideo>>>;
}

export interface WwwSoundsPackStoryVideo {
  __typename?: 'WwwSoundsPackStoryVideo';
  background_url?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
}

export interface WwwSoundsPacks {
  __typename?: 'WwwSoundsPacks';
  matching_tags?: Maybe<Scalars['JSON']['output']>;
  packs?: Maybe<Array<Maybe<WwwSoundsPacksPack>>>;
  total_hits?: Maybe<Scalars['Int']['output']>;
}

export interface WwwSoundsPacksPack {
  __typename?: 'WwwSoundsPacksPack';
  banner_url?: Maybe<Scalars['String']['output']>;
  cover_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  current_global_chart_pos?: Maybe<Scalars['Int']['output']>;
  current_label_chart_pos?: Maybe<Scalars['Int']['output']>;
  demo_mp3_url?: Maybe<Scalars['String']['output']>;
  featured?: Maybe<Scalars['Int']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  last_global_chart_pos?: Maybe<Scalars['Int']['output']>;
  last_label_chart_pos?: Maybe<Scalars['Int']['output']>;
  loops_count?: Maybe<Scalars['Int']['output']>;
  matching_plugins?: Maybe<Scalars['JSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  one_shots_count?: Maybe<Scalars['Int']['output']>;
  permalink?: Maybe<Scalars['String']['output']>;
  popularity?: Maybe<Scalars['Int']['output']>;
  preset_count?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  provider_permalink?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  published_at?: Maybe<Scalars['String']['output']>;
  sample_count?: Maybe<Scalars['Int']['output']>;
  tag_stats?: Maybe<Scalars['JSON']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updated_at?: Maybe<Scalars['String']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
}

export interface WwwTransaction {
  __typename?: 'WwwTransaction';
  amount: Scalars['Int']['output'];
  can_download: Scalars['Boolean']['output'];
  card?: Maybe<WwwCreditCardTransaction>;
  cc_brand?: Maybe<Scalars['String']['output']>;
  cc_last4?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Currency>;
  description: Scalars['String']['output'];
  payment_provider: Scalars['String']['output'];
  paypal?: Maybe<WwwPaypalTransaction>;
  product: Scalars['String']['output'];
  subtotal: Scalars['Int']['output'];
  tax: Scalars['Int']['output'];
  uuid: Scalars['String']['output'];
}

export interface WwwUser {
  __typename?: 'WwwUser';
  avatar_background_url?: Maybe<Scalars['String']['output']>;
  avatar_url?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  follower_count?: Maybe<Scalars['Int']['output']>;
  following_count?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  release_like_count?: Maybe<Scalars['Int']['output']>;
  release_play_count?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
}

export interface WwwUsersFollowers {
  __typename?: 'WwwUsersFollowers';
  followers?: Maybe<Array<Maybe<WwwUsersFollowersUser>>>;
  user?: Maybe<WwwUsersFollowersUser>;
}

export interface WwwUsersFollowersUser {
  __typename?: 'WwwUsersFollowersUser';
  avatar_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  username: Scalars['String']['output'];
}

export interface WwwUsersFollowing {
  __typename?: 'WwwUsersFollowing';
  following?: Maybe<Array<Maybe<WwwUsersFollowingUser>>>;
  user?: Maybe<WwwUsersFollowingUser>;
}

export interface WwwUsersFollowingUser {
  __typename?: 'WwwUsersFollowingUser';
  avatar_url?: Maybe<Scalars['String']['output']>;
  created_at?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  username: Scalars['String']['output'];
}

export interface WwwwSoundsPackPreset {
  __typename?: 'WwwwSoundsPackPreset';
  file_hash?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  is_default?: Maybe<Scalars['Boolean']['output']>;
  pack?: Maybe<WwwSoundsPackSoundPack>;
  plugin_description_id?: Maybe<Scalars['Int']['output']>;
  plugin_name?: Maybe<Scalars['String']['output']>;
  plugin_version?: Maybe<Scalars['String']['output']>;
  preview_url?: Maybe<Scalars['String']['output']>;
  preview_url_mono_g1?: Maybe<Scalars['String']['output']>;
  preview_url_mono_g3?: Maybe<Scalars['String']['output']>;
  preview_url_mono_g5?: Maybe<Scalars['String']['output']>;
  preview_url_poly_g1?: Maybe<Scalars['String']['output']>;
  preview_url_poly_g3?: Maybe<Scalars['String']['output']>;
  preview_url_poly_g5?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  provider_name?: Maybe<Scalars['String']['output']>;
  provider_permalink?: Maybe<Scalars['String']['output']>;
  provider_uuid?: Maybe<Scalars['String']['output']>;
  published?: Maybe<Scalars['Boolean']['output']>;
  published_at?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  trending?: Maybe<Scalars['Int']['output']>;
  uuid?: Maybe<Scalars['String']['output']>;
}

export interface ContentGroupsAssets {
  __typename?: 'contentGroupsAssets';
  groups?: Maybe<Array<Maybe<TransformedContentGroup>>>;
}

export interface CtaLink {
  __typename?: 'ctaLink';
  ctaBackground?: Maybe<Scalars['String']['output']>;
  ctaHref?: Maybe<Scalars['String']['output']>;
  ctaLabel?: Maybe<Scalars['String']['output']>;
}

export type SampleLocalInfoFragment = { __typename: 'SampleAsset', uuid: string, licensed?: boolean | null | undefined, downloaded?: boolean | null | undefined, reported?: boolean | null | undefined, localInfo?: { __typename?: 'AssetLocalInfo', path?: string | null | undefined, loading?: boolean | null | undefined, loadingProgress?: number | null | undefined } | null | undefined };

export type SampleInfoFragment = { __typename: 'SampleAsset', uuid: string, name?: string | null | undefined };

export type PresetLocalInfoFragment = { __typename: 'PresetAsset', uuid: string, licensed?: boolean | null | undefined, downloaded?: boolean | null | undefined, reported?: boolean | null | undefined, localInfo?: { __typename?: 'AssetLocalInfo', path?: string | null | undefined, loading?: boolean | null | undefined, loadingProgress?: number | null | undefined, loadingInPlugin?: number | null | undefined } | null | undefined };

export type PresetInfoFragment = { __typename: 'PresetAsset', uuid: string, name?: string | null | undefined };

export type GeneratedSampleLocalInfoFragment = { __typename: 'GeneratedSampleAsset', uuid: string, licensed?: boolean | null | undefined, downloaded?: boolean | null | undefined, localInfo?: { __typename?: 'AssetLocalInfo', path?: string | null | undefined, loading?: boolean | null | undefined, loadingProgress?: number | null | undefined } | null | undefined };

export type GeneratedSampleInfoFragment = { __typename: 'GeneratedSampleAsset', uuid: string, name?: string | null | undefined };

export const SampleLocalInfoFragmentDoc = gql`
    fragment sampleLocalInfo on SampleAsset {
  __typename
  uuid
  licensed
  downloaded @client
  reported @client
  localInfo @client {
    path
    loading
    loadingProgress
  }
}
    `;
export const SampleInfoFragmentDoc = gql`
    fragment sampleInfo on SampleAsset {
  __typename
  uuid
  name
}
    `;
export const PresetLocalInfoFragmentDoc = gql`
    fragment presetLocalInfo on PresetAsset {
  __typename
  uuid
  licensed
  downloaded @client
  reported @client
  localInfo @client {
    path
    loading
    loadingProgress
    loadingInPlugin
  }
}
    `;
export const PresetInfoFragmentDoc = gql`
    fragment presetInfo on PresetAsset {
  __typename
  uuid
  name
}
    `;
export const GeneratedSampleLocalInfoFragmentDoc = gql`
    fragment generatedSampleLocalInfo on GeneratedSampleAsset {
  __typename
  uuid
  licensed
  downloaded @client
  localInfo @client {
    path
    loading
    loadingProgress
  }
}
    `;
export const GeneratedSampleInfoFragmentDoc = gql`
    fragment generatedSampleInfo on GeneratedSampleAsset {
  __typename
  uuid
  name
}
    `;
